/**
 * Constantes utilizadas no sistema
 */
export interface IConstants {
	readonly API: {
		CreditoImobiliario: {
			host: string | undefined
			key: string | undefined
		}

		Auth: {
			host: string | undefined
		}

		AttaServices: {
			host: string | undefined
		}

		Login: {
			host: string | undefined
		}
	}

	readonly BANCOS: {
		ITAU: number
		BRADESCO: number
		SANTANDER: number
		CAIXA: number
		All: Array<IBanco>
	}

	readonly PRODUTOS_CREDITO_IMOBILIARIO: {
		SAC: number
		PRICE: number
		POUPANCA_MAIS: number
		ALL: Array<ISimpleOption>
	}

	readonly PRODUTOS_BANCO_CREDITO_IMOBILIARIO: {
		ITAU: Array<IProdutoCreditoImobiliarioOption>
		BRADESCO: Array<IProdutoCreditoImobiliarioOption>
		SANTANDER: Array<IProdutoCreditoImobiliarioOption>
		CAIXA: Array<IProdutoCreditoImobiliarioOption>
	}

	readonly PRE_ANALISE: {
		SCORE_STATUS: TScoreStatus
	}

	readonly Estados: Array<IEstado>

	readonly TIPO_IMOVEL: TTipoImovel

	readonly ISOLVE_SITUACAO: TiSolveSituacoes

	readonly TIPO_RESIDENCIA: Array<ISelectPadraoIdString>

	readonly TIPO_PESSOA: Array<ISelectPadraoIdString>

	readonly ESTADO_CIVIL: Array<ISelectPadraoIdString>

	readonly REGIME_CASAMENTOS: Array<ISelectPadraoIdString>

	readonly TIPO_CONTRATACAO: Array<ISelectPadraoIdString>

	readonly LISTA_BANCOS: Array<ISelectPadraoIdNumber>

	readonly TIPO_DOCUMENTOS: Array<ISelectPadraoIdString>

	readonly GENERO: Array<ISelectPadraoIdString>
	readonly ISOLVE_GRUPOS: TiSolveGrupos
	readonly ISOLVE_FRANQUIA: TiSolveFranquias

	readonly PROFISSAO: Array<ISelectPadraoIdStringValue>
	readonly ORGAO_EXPEDIDOR: Array<ISelectPadraoIdStringValue>

	readonly FINALIDADE_IMOVEL: Array<ISelectPadraoIdNumber>

	readonly ATIVIDADE: Array<ISelectPadraoIdStringValue>

	readonly ESTADO_CIVIL_VALUES: {
		SOLTEIRO: string
		CASADO: string
		DIVORCIADO: string
		VIUVO: string
		SEPARADO: string
		SEPARADO_DE_FATO: string
		SEPARADO_JUDICIALMENTE: string
		DESQUITADO: string
	}

	readonly SUB_PRODUTO_MULTIBANCO_ITAU_ISOLADO: Array<ISelectPadraoIdNumber>

	readonly SUB_PRODUTO_MULTIBANCO_OUTROS: Array<ISelectPadraoIdNumber>

	readonly LISTA_ASSISTENCIA_TOO: Array<ISelectPadraoIdNumber>

	readonly FORNECEDOR_TIPO_PARAMETRO: {
		TAXA_MINIMA: number
		LTV_MAXIMO: number
		PRAZO_MAXIMO: number
		TAXA_AVALIACAO: number
		FINANCIAMENTO_MINIMO: number
		FINANCIAMENTO_MAXIMO: number
		IMOVEL_VALOR_MINIMO: number
		IMOVEL_VALOR_MAXIMO: number
		PRAZO_MINIMO: number
	}

	readonly PRODUTOS_MULTIBANCO: {
		CI_ISOLADO: number
		CI_REPASSE: number
		CI_PILOTO: number
		CGI: number
		SBPE: number
		FGTS_MCMV: number
		FGTS_PRO_COTISTA: number
		ALL: Array<IProductMultibank>
	}
}

export enum ETipoImovel {
	RESIDENCIAL = 1,
	COMERCIAL = 2,
	TERRENO = 3
}
// Necessario declarar o tipo para a interface intepretar de forma correta :)
export type TTipoImovel = typeof ETipoImovel

enum EScoreStatus {
	ERRO = -1,
	ENVIADO = 1,
	CONCLUIDO = 4,
	TAXAS_ATUALIZADAS = 5
}

type TAnaliseCreditoParametroTipo = typeof EAnaliseCreditoParametroTipo

enum EAnaliseCreditoParametroTipo {
	SCORE_SPC = 10000,
	SCORE_ITAU = 10001,
	SCORE_BRADESCO = 10002,
	SCORE_SANTANDER = 10003,
	RENDA_COMPROVADA = 20001,
	RENDA_PRESUMIDA = 20002,
	RENDA_OBTIDA = 20003,
	RENDA_COMPROMETIMENTO = 20004,
	APONTAMENTOS_SPC = 30000
}

type TScoreStatus = typeof EScoreStatus

/**
 * NAO USAR MAIS ESSE
 */
export enum EiSolveSituacoes {
	ANDAMENTO = 1,
	APROVADO = 2,
	PENDENTE = 3,
	REPROVADO = 4,
	CANCELADO = 5,
	FINALIZADO = 6,
	EM_ANALISE = 7,
	ANALISE_ATTA = 8,
	ANALISE_BANCO = 9,
	ANALISE_BANCO_DUVIDA = 10
}

export type TiSolveSituacoes = typeof EiSolveSituacoes

export enum EiSolveGrupos {
	GRP_DIRETORIA = 1,
	GRP_ADMINISTRATIVO = 3,
	GRP_TECNOLOGIA = 2,
	GRP_USUARIOS_MASTER = 8,
	GRP_USUARIOS_BASICO = 9,
	GRP_COMERCIAL_CONSULTOR = 12,
	GRP_USUARIO_ADMINISTRATIVO = 13,
	GRP_CREDIMOB = 15,
	GRP_FRANQUIAS_FRANQUEADO = 19,
	GRP_FRANQUIAS_ADMINISTRATIVO = 22,
	GRP_GESTOR_ITAU = 24,
	GRP_GESTOR_BRADESCO = 25,
	GRP_GESTOR_SANTANDER = 26,
	GRP_USUARIOS_MASTER_5A = 27,
	GRP_USUARIOS_ADM_5A = 33,

	GRP_USUARIOS_ADM_5A_CAIXA = 34,
	GRP_USUARIOS_MASTER_5A_CAIXA = 35,
	GRP_CREDIMOB_CAIXA = 36,

	GRP_USUARIO_MASTER_5AHUBS = 37,
	GRP_USUARIO_MASTER_CASAMINEIRA = 38
}

export type TiSolveGrupos = typeof EiSolveGrupos

export type TiSolveFranquias = typeof EiSolveFranquias

enum EiSolveFranquias {
	JARDINS = 1
}

export type TiSolveDocumentosCapitalizacao = typeof EiSolveDocumentosCapitalizacao

enum EiSolveDocumentosCapitalizacao {
	CREA = 1,
	RG = 2,
	CRM = 3,
	RNE = 4,
	OAB = 5,
	CNH = 6,
	PASSAPORTE = 7
}

export interface ISimpleOption {
	id: number
	description: string
	value?: any
}

interface IBanco {
	id: number
	name: string
	icon: string
	//TODO: Remover o time e usar prazo
	time: number
	prazo?: number
	taxa?: number | null
	taxaMinima: {
		residencial: number
		comercial: number
		terreno?: number
		sacPlus?: number
	}
	editable: boolean
	financiamentoMinimo: number
}

interface IEstado {
	id: number
	sigla: string
	nome: string
}

interface ISeguradora {
	id: number
	seguradora: string
	img: string
	assistenciaDomiciliar: string
	assistenciaJuridica: string
	showCard: boolean
	itens: Array<string>
}

interface ISeguradoraIncendio {
	id: number
	seguradora: string
	img: string
	assistenciaResidencial: string
	showCard: boolean
	assistencia: Array<ISelectPadraoIdNumber>
}

export interface ISelectPadraoIdString {
	id: string
	description: string
}

interface ISelectPadraoIdStringValue {
	value: string
	description: string
}

interface ISelectPadraoIdStringValueBoolean {
	value: boolean
	description: string
}

export interface ISelectPadraoIdNumber {
	id: number
	description: string
}

interface ISelectPadraoIdNumberTipoimovel {
	id: number
	description: string
	finalidade: number
}

export interface IProdutoCreditoImobiliarioOption {
	id: number
	nome: string
	bancoOpera: boolean
}

interface IProductMultibank {
	id: number
	banks: Array<number>
	description: string
}

class ConstantsModel implements IConstants {
	SOLICITAR_DOCUMENTO_TOPICO: any
	TIPO_NACIONALIDADE: ISelectPadraoIdString[] = []

	readonly ISOLVE_FRANQUIA = EiSolveFranquias
	readonly ISOLVE_GRUPOS = EiSolveGrupos
	readonly ISOLVE_SITUACAO = EiSolveSituacoes
	readonly ISOLVE_DOCUMENTOS_CAPITALIZACAO = EiSolveDocumentosCapitalizacao

	/**
	 * Acesso rapido as URLS e endpoints utilizadas no sistema
	 */
	readonly API = {
		CreditoImobiliario: {
			host: import.meta.env.VUE_APP_API_CREDITO_IMOBILIARIO,
			key: import.meta.env.VUE_APP_KEY_CREDITO_IMOBILIARIO
		},

		Auth: {
			host: import.meta.env.VUE_APP_API_AUTH
		},

		AttaServices: {
			host: import.meta.env.VUE_APP_API_ATTA_SERVICES
		},

		Login: {
			host: import.meta.env.VUE_APP_API_LOGIN
		}
	}

	/**
     * Bancos

     */
	readonly BANCOS = {
		ITAU: 1,
		BRADESCO: 3,
		SANTANDER: 5,
		CHB: 21,
		CAIXA: 25,
		All: [
			{
				id: 1,
				name: 'Itaú',
				icon: 'itau.svg',
				time: 360,
				taxa: null,
				taxaMinima: {
					residencial: 8.5,
					comercial: 10,
					sacPlus: 7.37
				},

				tiposImovel: [ETipoImovel.COMERCIAL, ETipoImovel.RESIDENCIAL],
				produtos: [
					{
						nome: 'SAC',
						taxa: 8.3,
						tipoImovel: ETipoImovel.RESIDENCIAL
					},
					{
						nome: 'Poupança',
						taxa: 5.92,
						tipoImovel: ETipoImovel.RESIDENCIAL
					},
					{
						nome: 'SAC',
						taxa: 10,
						tipoImovel: ETipoImovel.COMERCIAL
					}
				],

				editable: true,
				financiamentoMinimo: 40000,
				valorImovelMinimo: 60000,
				segmento: [
					{ id: 1, description: 'Private', taxaSac: '9,99% a.a + TR', taxaPoupanca: '3,99% a.a + poupança = 10,16%' },
					{ id: 13, description: 'Personnalité', taxaSac: '9,99% a.a + TR', taxaPoupanca: '3,99% a.a + poupança = 10,16%' },
					{ id: 12, description: 'Uniclass', taxaSac: '10,49% a.a + TR', taxaPoupanca: '4,99% a.a + poupança = 11,16%' },
					{ id: 4, description: 'Agências', taxaSac: '10,99% a.a + TR', taxaPoupanca: '4,99% a.a + poupança = 11,16%' },
					{ id: 5, description: 'Não Correntistas', taxaSac: '10,99% a.a + TR', taxaPoupanca: '4,99% a.a + poupança = 11,16%' }
				],
				financiamentoMaximo: 100000000,
				valorImovelMaximo: 100000000,
				ordemExibicao: 1000
			},
			{
				id: 3,
				name: 'Bradesco',
				icon: 'bradesco.svg',
				time: 360,
				taxaMinima: {
					residencial: 9.5,
					comercial: 10.5,
					terreno: 10.5
				},

				tiposImovel: [ETipoImovel.COMERCIAL, ETipoImovel.RESIDENCIAL, ETipoImovel.TERRENO],

				produtos: [
					{
						nome: 'SAC',
						taxa: 8.5,
						tipoImovel: ETipoImovel.RESIDENCIAL
					},
					{
						nome: 'SAC',
						taxa: 10.5,
						tipoImovel: ETipoImovel.TERRENO
					},
					{
						nome: 'SAC',
						taxa: 10.5,
						tipoImovel: ETipoImovel.COMERCIAL
					}
				],

				taxa: null,
				editable: true,
				financiamentoMinimo: 0,
				valorMinimoFinanciamento: {
					padrao: 0,
					terreno: 100000
				},
				financiamentoMaximo: 100000000,
				valorImovelMaximo: 100000000,
				ordemExibicao: 3000,
				segmento: [
					{ id: 1, description: 'Prime', taxaSac: '9,89% a.a + TR', taxaPoupanca: '2,99% a.a + poupança = 10,06%' },
					{ id: 2, description: 'Exclusive', taxaSac: '10,39% a.a + TR', taxaPoupanca: '2,99% a.a + poupança = 10,06%' },
					{ id: 3, description: 'Classic', taxaSac: '10,89% a.a + TR', taxaPoupanca: '2,99% a.a + poupança = 10,06%' },
					{ id: 4, description: 'Não Possui / Repasse / PJ', taxaSac: '10,89% a.a + TR', taxaPoupanca: '2,99% a.a + poupança = 10,06%' }
				]
			},
			{
				id: 5,
				name: 'Santander',
				icon: 'santander.svg',
				time: 420,
				taxaMinima: {
					residencial: 8.99,
					comercial: 9.99
				},

				tiposImovel: [ETipoImovel.COMERCIAL, ETipoImovel.RESIDENCIAL],

				produtos: [
					{
						nome: 'SAC',
						taxa: 8.99,
						tipoImovel: ETipoImovel.RESIDENCIAL
					},
					{
						nome: 'SAC',
						taxa: 9.99,
						tipoImovel: ETipoImovel.COMERCIAL
					}
				],
				taxa: null,
				editable: false,
				financiamentoMinimo: 60000,
				financiamentoMaximo: 100000000,
				valorImovelMaximo: 100000000,
				ordemExibicao: 4000
			},
			{
				id: 25,
				name: 'CAIXA',
				icon: 'caixa.svg',
				time: 420,
				taxaMinima: {
					residencial: 8.6,
					comercial: 8.6
				},

				tiposImovel: [ETipoImovel.COMERCIAL, ETipoImovel.RESIDENCIAL],

				produtos: [
					{
						nome: 'SAC',
						taxa: 8.99,
						tipoImovel: ETipoImovel.RESIDENCIAL
					}
				],
				taxa: null,
				editable: true,
				financiamentoMinimo: 20000,
				financiamentoMaximo: 1200000,
				valorImovelMaximo: 1500000,
				ordemExibicao: 2000
			}
		]
	}

	readonly Estados = [
		{ id: 1, sigla: 'AC', nome: 'Acre' },
		{ id: 2, sigla: 'AL', nome: 'Alagoas' },
		{ id: 3, sigla: 'AM', nome: 'Amazonas' },
		{ id: 4, sigla: 'AP', nome: 'Amapá' },
		{ id: 5, sigla: 'BA', nome: 'Bahia' },
		{ id: 6, sigla: 'CE', nome: 'Ceará' },
		{ id: 7, sigla: 'DF', nome: 'Distrito Federal' },
		{ id: 8, sigla: 'ES', nome: 'Espírito Santo' },
		{ id: 9, sigla: 'GO', nome: 'Goiás' },
		{ id: 10, sigla: 'MA', nome: 'Maranhão' },
		{ id: 11, sigla: 'MG', nome: 'Minas Gerais' },
		{ id: 12, sigla: 'MS', nome: 'Mato Grosso do Sul' },
		{ id: 13, sigla: 'MT', nome: 'Mato Grosso' },
		{ id: 14, sigla: 'PA', nome: 'Pará' },
		{ id: 15, sigla: 'PB', nome: 'Paraíba' },
		{ id: 16, sigla: 'PE', nome: 'Pernambuco' },
		{ id: 17, sigla: 'PI', nome: 'Piauí' },
		{ id: 18, sigla: 'PR', nome: 'Paraná' },
		{ id: 19, sigla: 'RJ', nome: 'Rio de Janeiro' },
		{ id: 20, sigla: 'RN', nome: 'Rio Grande do Norte' },
		{ id: 21, sigla: 'RO', nome: 'Rondônia' },
		{ id: 22, sigla: 'RR', nome: 'Roraima' },
		{ id: 23, sigla: 'RS', nome: 'Rio Grande do Sul' },
		{ id: 24, sigla: 'SC', nome: 'Santa Catarina' },
		{ id: 25, sigla: 'SE', nome: 'Sergipe' },
		{ id: 26, sigla: 'SP', nome: 'São Paulo' },
		{ id: 27, sigla: 'TO', nome: 'Tocantins' }
	]

	readonly CANAL = [
		{ id: 1, nome: 'ZAP/OLX' },
		{ id: 2, nome: 'Santander' },
		{ id: 3, nome: 'Matriz' }
	]

	/**
	 * Lista enumerada de tipos de imovel
	 */
	readonly TIPO_IMOVEL = ETipoImovel

	/**
	 * Pacote de implementacoes para Pré Analise
	 */
	readonly PRE_ANALISE = {
		/**
		 * Lista enumerada para status de uma consulta de score
		 */
		SCORE_STATUS: EScoreStatus
	}

	readonly GENERO = [
		{ id: 'M', description: 'Masculino' },
		{ id: 'F', description: 'Feminino' }
	]

	readonly TIPO_DOCUMENTOS = [
		{ id: 'RG', description: 'RG' },
		{ id: 'RNE', description: 'RNE' },
		{ id: 'CRM', description: 'CRM' },
		{ id: 'CREA', description: 'CREA' },
		{ id: 'OAB', description: 'OAB' },
		{ id: 'CNH', description: 'CNH' }
	]

	readonly REGIME_CASAMENTOS = [
		{ id: 'ST', description: 'Separação Total' },
		{ id: 'CT', description: 'Comunhão Total' },
		{ id: 'CP', description: 'Comunhão Parcial' }
	]

	readonly TIPO_CONTRATACAO = [
		{ id: '000', description: 'Assalariado' },
		{ id: '007', description: 'Aposentado' },
		{ id: '002', description: 'Sócio Proprietário' },
		{ id: '001', description: 'Autônomo' },
		{ id: '009', description: 'Profissional Liberal' }
	]

	readonly LISTA_BANCOS = [
		{ id: 237, idString: '237', description: 'Banco Bradesco S.A.' },
		{ id: 1, idString: '1', description: 'Banco do Brasil S.A.' },
		{ id: 33, idString: '33', description: 'Banco Santander (Brasil) S.A.' },
		{ id: 104, idString: '104', description: 'Caixa Econômica Federal' },
		{ id: 341, idString: '341', description: 'Itaú Unibanco S.A.' }
	]

	readonly ESTADO_CIVIL = [
		{ id: '004', description: 'Solteiro(a)' },
		{ id: '001', description: 'Casado(a)' },
		{ id: '003', description: 'Divorciado(a)' },
		{ id: '005', description: 'Viúvo(a)' },
		{ id: '008', description: 'Separado(a)' },
		{ id: '009', description: 'Desquitado(a)' }
	]

	readonly ESTADO_CIVIL2 = [
		{ id: '004', description: 'Solteiro(a)' },
		{ id: '001', description: 'Casado(a)' },
		{ id: '003', description: 'Divorciado(a)' },
		{ id: '005', description: 'Viúvo(a)' },
		{ id: '008', description: 'Separado(a)' },
		{ id: '010', description: 'Separado(a) de fato' },
		{ id: '011', description: 'Separado(a) judicialmente' },
		{ id: '009', description: 'Desquitado(a)' }
	]

	readonly TIPO_RESIDENCIA = [
		{ id: 'A', description: 'Alugada' },
		{ id: 'P', description: 'Própria' },
		{ id: 'C', description: 'Com os pais' }
	]

	readonly TIPO_TELEFONE = [
		{ id: 1, description: 'Residencial' },
		{ id: 2, description: 'Comercial' },
		{ id: 3, description: 'Celular' }
	]

	readonly FINALIDADE_IMOVEL = [
		{ id: 1, description: 'Apartamento', tipo: ETipoImovel.RESIDENCIAL },
		{ id: 2, description: 'Casa', tipo: ETipoImovel.RESIDENCIAL },
		{ id: 3, description: 'Box', tipo: ETipoImovel.COMERCIAL },
		{ id: 4, description: 'Flat', tipo: ETipoImovel.COMERCIAL },
		{ id: 5, description: 'Galpão', tipo: ETipoImovel.COMERCIAL },
		{ id: 6, description: 'Loja', tipo: ETipoImovel.COMERCIAL },
		{ id: 7, description: 'Quiosque', tipo: ETipoImovel.COMERCIAL },
		{ id: 8, description: 'Sala comercial', tipo: ETipoImovel.COMERCIAL },
		{ id: 9, description: 'Outros', tipo: ETipoImovel.COMERCIAL }
	]

	readonly TIPO_PESSOA = [
		{ id: 'F', description: 'Pessoa Física' },
		{ id: 'J', description: 'Pessoa Jurídica' }
	]

	readonly TIPO_PESSOA_NUMBER = [
		{ id: 1, description: 'Pessoa Física' },
		{ id: 2, description: 'Pessoa Jurídica' }
	]

	readonly FUNCAO_POLITICAMENTE_EXPOSTA = [
		{ value: 'ADJUNTO DO ADVOGADO GERAL DA UNIAO', description: 'ADJUNTO DO ADVOGADO GERAL DA UNIAO' },
		{ value: 'ADVOGADO GERAL DA UNIAO', description: 'ADVOGADO GERAL DA UNIAO' },
		{ value: 'ALTO SERVIDOR DO PODER PUBLICO DE PAIS ESTRANGEIRO', description: 'ALTO SERVIDOR DO PODER PUBLICO DE PAIS ESTRANGEIRO' },
		{ value: 'ASSESSOR CHEFE/ESPECIAL DE ORGAO PUBLICO FEDERAL', description: 'ASSESSOR CHEFE/ESPECIAL DE ORGAO PUBLICO FEDERAL' },
		{ value: 'CHEFE DE ESTADo/GOVERNO ESTRANGEIRO', description: 'CHEFE DE ESTADo/GOVERNO ESTRANGEIRO' },
		{ value: 'CHEFE DO CERIMONIAL DE ORGAO PUBLICO FEDERAL', description: 'CHEFE DO CERIMONIAL DE ORGAO PUBLICO FEDERAL' },
		{ value: 'CHEFE EM ORGAO PUBLICO FEDERAL', description: 'CHEFE EM ORGAO PUBLICO FEDERAL' },
		{ value: 'COMANDANTE DE EXERCITO/MARINHA/AERONAUTICA', description: 'COMANDANTE DE EXERCITO/MARINHA/AERONAUTICA' },
		{ value: 'CONSULTOR GERLA DE ORGAO PUBLICO FEDERAL', description: 'CONSULTOR GERLA DE ORGAO PUBLICO FEDERAL' },
		{ value: 'CORREGEDOR DE ORGAO JUDICIARIO FEDERAL', description: 'CORREGEDOR DE ORGAO JUDICIARIO FEDERAL' },
		{ value: 'CORREGEDOR GERAL DE ORGAO PUBLICO FEDERAL', description: 'CORREGEDOR GERAL DE ORGAO PUBLICO FEDERAL' },
		{ value: 'DIRETOR DE ORGAO PUBLICO FEDERAL', description: 'DIRETOR DE ORGAO PUBLICO FEDERAL' },
		{ value: 'DIRIGENTE DE EMPRESA PUBLICA ESTRANGEIRA', description: 'DIRIGENTE DE EMPRESA PUBLICA ESTRANGEIRA' },
		{ value: 'DIRIGENTE DE PARTIDO POLITICO DE PAIS ESTRANGEIRO', description: 'DIRIGENTE DE PARTIDO POLITICO DE PAIS ESTRANGEIRO' },
		{ value: 'Defensor publico geral da uniao', description: 'Defensor publico geral da uniao' },
		{ value: 'Deputado Federal', description: 'Deputado Federal' },
		{ value: 'Diretor de autarquia federal', description: 'Diretor de autarquia federal' },
		{ value: 'Diretor de empresa publica federal', description: 'Diretor de empresa publica federal' },
		{ value: 'Diretor de fundacao publica federal', description: 'Diretor de fundacao publica federal' },
		{ value: 'Diretor de sociedade de economia mista federal', description: 'Diretor de sociedade de economia mista federal' },
		{ value: 'EMBAIXADOR', description: 'EMBAIXADOR' },
		{ value: 'EMBAIXADOR ESTRANGEIRO NO BRASIL', description: 'EMBAIXADOR ESTRANGEIRO NO BRASIL' },
		{ value: 'GOVERNADOR', description: 'GOVERNADOR' },
		{ value: 'MAGISTRADO DE PAIS ESTRANGEIRO', description: 'MAGISTRADO DE PAIS ESTRANGEIRO' },
		{
			value: 'MEMBRO DE CONSELHO DE ADMINISTRACAO - EMPRESA PUBLICA FEDERAL',
			description: 'MEMBRO DE CONSELHO DE ADMINISTRACAO - EMPRESA PUBLICA FEDERAL'
		},
		{
			value: 'MEMBRO DE CONSELHO DE ADMINISTRACAO - SOCIEDADE ECONOMIA MISTA FEDERAL',
			description: 'MEMBRO DE CONSELHO DE ADMINISTRACAO - SOCIEDADE ECONOMIA MISTA FEDERAL'
		},
		{ value: 'MILITAR DE ALTO NIVEL DE PAIS ESTRANGEIRO', description: 'MILITAR DE ALTO NIVEL DE PAIS ESTRANGEIRO' },
		{ value: 'Membro de Tribunal Superior', description: 'Membro de Tribunal Superior' },
		{ value: 'Membro do Conselho Nacional de Justica', description: 'Membro do Conselho Nacional de Justica' },
		{ value: 'Membro do Conselho Nacional do Ministerio Publico', description: 'Membro do Conselho Nacional do Ministerio Publico' },
		{ value: 'Membro do Supremo Tribunal Federal', description: 'Membro do Supremo Tribunal Federal' },
		{ value: 'Membro do Tribunal de Contas da Uniao', description: 'Membro do Tribunal de Contas da Uniao' },
		{ value: 'Ministro de Estado', description: 'Ministro de Estado' },
		{ value: 'OUVIDOR GERAL EM ORGAO PUBLICO FEDERAL', description: 'OUVIDOR GERAL EM ORGAO PUBLICO FEDERAL' },
		{ value: 'POLITICO DE ALTO NIVEL DE PAIS ESTRANGEIRO', description: 'POLITICO DE ALTO NIVEL DE PAIS ESTRANGEIRO' },
		{ value: 'PORTA-VOZ DA PRESIDENCIA DA REPUBLICA', description: 'PORTA-VOZ DA PRESIDENCIA DA REPUBLICA' },
		{ value: 'PRESIDENTE DE ORGAO PUBLICO FEDERAL', description: 'PRESIDENTE DE ORGAO PUBLICO FEDERAL' },
		{ value: 'PROCURADOR GERAL DE MINISTERIO PUBLICO', description: 'PROCURADOR GERAL DE MINISTERIO PUBLICO' },
		{ value: 'PROCURADOR-GERAL DE ORGAO PUBLICO FEDERAL', description: 'PROCURADOR-GERAL DE ORGAO PUBLICO FEDERAL' },
		{ value: 'Prefeito de capital de estado', description: 'Prefeito de capital de estado' },
		{ value: 'Presidente da Republica', description: 'Presidente da Republica' },
		{
			value: 'Presidente de Assembleia Legislativa/Camara Distrital',
			description: 'Presidente de Assembleia Legislativa/Camara Distrital'
		},
		{
			value: 'Presidente de Conselho de Contas de Estado/Distrito Federal',
			description: 'Presidente de Conselho de Contas de Estado/Distrito Federal'
		},
		{ value: 'Presidente de Conselho de Contas de municipio', description: 'Presidente de Conselho de Contas de municipio' },
		{ value: 'Presidente de Tribunal de Justica', description: 'Presidente de Tribunal de Justica' },
		{ value: 'Presidente de autarquia Federal', description: 'Presidente de autarquia Federal' },
		{ value: 'Presidente de camara municipal de capital de estado', description: 'Presidente de camara municipal de capital de estado' },
		{ value: 'Presidente de empresa publica federal', description: 'Presidente de empresa publica federal' },
		{ value: 'presidente de fundacao publica federal', description: 'presidente de fundacao publica federal' },
		{ value: 'Presidente de sociedade de economia mista federal', description: 'Presidente de sociedade de economia mista federal' },
		{ value: 'Procurador-Geral da Justica Militar', description: 'Procurador-Geral da Justica Militar' },
		{ value: 'Procurador-Geral da Republica', description: 'Procurador-Geral da Republica' },
		{
			value: 'Procurador-Geral da Justica de Estado/Distrito Federal',
			description: 'Procurador-Geral da Justica de Estado/Distrito Federal'
		},
		{ value: 'Procurador-Geral do Ministerio Publico junto ao TCU', description: 'Procurador-Geral do Ministerio Publico junto ao TCU' },
		{ value: 'Procurador-Geral do Trabalho', description: 'Procurador-Geral do Trabalho' },
		{ value: 'REITOR DE UNIVERSIDADE PUBLICA FEDERAL', description: 'REITOR DE UNIVERSIDADE PUBLICA FEDERAL' },
		{ value: 'SECRETARIO ADJUNTO DE ORGAO PUBLICO FEDERAL', description: 'SECRETARIO ADJUNTO DE ORGAO PUBLICO FEDERAL' },
		{ value: 'SUBCHEFE DE ORGAO PUBLICO FEDERAL', description: 'SUBCHEFE DE ORGAO PUBLICO FEDERAL' },
		{ value: 'SUBDEFENSOR PUBLICO GERAL DA UNIAO', description: 'SUBDEFENSOR PUBLICO GERAL DA UNIAO' },
		{ value: 'SUBPROCURADOR-GERAL DE ORGAO PUBLICO FEDERAL', description: 'SUBPROCURADOR-GERAL DE ORGAO PUBLICO FEDERAL' },
		{ value: 'SUBSECRETARIO DE ORGAO PUBLICO FEDERAL', description: 'SUBSECRETARIO DE ORGAO PUBLICO FEDERAL' },
		{ value: 'SUPERINTENDENTE DE AUTARQUIA FEDERAL', description: 'SUPERINTENDENTE DE AUTARQUIA FEDERAL' },
		{ value: 'Secretario Especial', description: 'Secretario Especial' },
		{ value: 'Senador', description: 'Senador' },
		{ value: 'SubProcurador-Geral da Republica', description: 'SubProcurador-Geral da Republica' },
		{ value: 'VICE-PRESIDENTE DE ASSEMBLEIA LEGISLATIVA ESTADUAL', description: 'VICE-PRESIDENTE DE ASSEMBLEIA LEGISLATIVA ESTADUAL' },
		{ value: 'VICE-REITOR DE UNIVERSIDADE PUBLICA FEDERAL', description: 'VICE-REITOR DE UNIVERSIDADE PUBLICA FEDERAL' },
		{ value: 'Vice-Governador', description: 'Vice-Governador' },
		{ value: 'Vice-Prefeito de capital de estado', description: 'Vice-Prefeito de capital de estado' },
		{ value: 'Vice-Presidente da Republica', description: 'Vice-Presidente da Republica' },
		{ value: 'Vice-Presidente de autarquia federal', description: 'Vice-Presidente de autarquia federal' },
		{
			value: 'Vice-Presidente de camara municipal de capital de estado',
			description: 'Vice-Presidente de camara municipal de capital de estado'
		},
		{ value: 'Vice-Presidente de empresa publica federal', description: 'Vice-Presidente de empresa publica federal' },
		{ value: 'Vice-Presidente de fundacao publica federal', description: 'Vice-Presidente de fundacao publica federal' },
		{
			value: 'Vice-Presidente de Sociedade de economia mista federal',
			description: 'Vice-Presidente de Sociedade de economia mista federal'
		},
		{ value: 'Vice-Procura-Geral da Republica', description: 'Vice-Procura-Geral da Republica' }
	]

	readonly ATIVIDADE = [
		{ value: '1012101', description: 'Abate de aves' },
		{ value: '1012102', description: 'Abate de pequenos animais CNA' },
		{ value: '1531902', description: 'Acabamento de calçados de couro sob contrato' },
		{ value: '5231101', description: 'Administração da infra-estrutura portuária' },
		{ value: '8550301', description: 'Administração de caixas escolares' },
		{ value: '6613400', description: 'Administração de cartões de crédito' },
		{ value: '6493000', description: 'Administração de consórcios para aquisição de bens e direitos' },
		{ value: '6611804', description: 'Administração de mercados de balcão organizados' },
		{ value: '4399101', description: 'Administração de obras' },
		{ value: '8411600', description: 'Administração pública em geral' },
		{ value: '5250803', description: 'Agenciamento de cargas, exceto para o transporte marítimo' },
		{ value: '7312200', description: 'Agenciamento de espaços para publicidade, exceto em veículos de comunicação' },
		{ value: '7490105', description: 'Agenciamento de profissionais para atividades esportivas, culturais e artísticas' },
		{ value: '6434400', description: 'Agências de fomento' },
		{ value: '6391700', description: 'Agências de notícias' },
		{ value: '7311400', description: 'Agências de publicidade' },
		{ value: '7911200', description: 'Agências de viagens' },
		{ value: '9609202', description: 'Agências matrimoniais' },
		{ value: '6911703', description: 'Agente de propriedade industrial' },
		{ value: '6612605', description: 'Agentes de investimentos em aplicações financeiras' },
		{ value: '8730102', description: 'Albergues assistenciais' },
		{ value: '5590601', description: 'Albergues, exceto assistenciais' },
		{ value: '9609203', description: 'Alojamento, higiene e embelezamento de animais' },
		{ value: '7732202', description: 'Aluguel de andaimes' },
		{ value: '7729201', description: 'Aluguel de aparelhos de jogos eletrônicos' },
		{ value: '7739002', description: 'Aluguel de equipamentos científicos, médicos e hospitalares, sem operador' },
		{ value: '7721700', description: 'Aluguel de equipamentos recreativos e esportivos' },
		{ value: '7722500', description: 'Aluguel de fitas de vídeo, DVDs e similares' },
		{ value: '6810202', description: 'Aluguel de imóveis próprios' },
		{ value: '7731400', description: 'Aluguel de máquinas e equipamentos agrícolas sem operador' },
		{ value: '7732201', description: 'Aluguel de máquinas e equipamentos para construção sem operador, exceto andaimes' },
		{ value: '7733100', description: 'Aluguel de máquinas e equipamentos para escritório' },
		{ value: '7739001', description: 'Aluguel de máquinas e equipamentos para extração de minérios e petróleo, sem operador' },
		{ value: '7729203', description: 'Aluguel de material médico' },
		{ value: '7729202', description: 'Aluguel de móveis, utensílios e aparelhos de uso doméstico e pessoal; instrumentos musicais' },
		{ value: '7723300', description: 'Aluguel de objetos do vestuário, jóias e acessórios' },
		{
			value: '7739099',
			description: 'Aluguel de outras máquinas e equipamentos comerciais e industriais não especificados anteriormente, '
		},
		{ value: '7729299', description: 'Aluguel de outros objetos pessoais e domésticos não especificados anteriormente' },
		{ value: '7739003', description: 'Aluguel de palcos, coberturas e outras estruturas de uso temporário, exceto andaimes' },
		{ value: '1340502', description: 'Alvejamento, tingimento e torção em fios, tecidos, artefatos têxteis e peças do vestuário' },
		{ value: '2391502', description: 'Aparelhamento de pedras para construção, exceto associado à extração' },
		{ value: '2391503', description: 'Aparelhamento de placas e execução de trabalhos em mármore, granito, ardósia e outras pedras' },
		{ value: '5510802', description: 'Apart-hotéis' },
		{ value: '159801', description: 'Apicultura' },
		{ value: '4330405', description: 'Aplicação de revestimentos e de resinas em interiores e exteriores' },
		{ value: '5211701', description: 'Armazéns gerais - emissão de warrant' },
		{ value: '6440900', description: 'Arrendamento mercantil' },
		{ value: '9001999', description: 'Artes cênicas, espetáculos e atividades complementares não especificados anteriormente' },
		{ value: '6435202', description: 'Associações de poupança e empréstimo' },
		{ value: '8630502', description: 'Atividade médica ambulatorial com recursos para realização de exames complementares' },
		{ value: '8630501', description: 'Atividade médica ambulatorial com recursos para realização de procedimentos cirúrgicos' },
		{ value: '8630503', description: 'Atividade médica ambulatorial restrita a consultas' },
		{ value: '8630504', description: 'Atividade odontológica' },
		{ value: '9499500', description: 'Atividades associativas não especificadas anteriormente' },
		{ value: '6911702', description: 'Atividades auxiliares da justiça' },
		{
			value: '6629100',
			description: 'Atividades auxiliares dos seguros, da previdência complementar e dos planos de saúde não especificad'
		},
		{
			value: '5240199',
			description: 'Atividades auxiliares dos transportes aéreos, exceto operação dos aeroportos e campos de aterrissage'
		},
		{ value: '5239700', description: 'Atividades auxiliares dos transportes aquaviários não especificadas anteriormente' },
		{ value: '8690903', description: 'Atividades de acupuntura' },
		{ value: '6630400', description: 'Atividades de administração de fundos por contrato ou comissão' },
		{ value: '5232000', description: 'Atividades de agenciamento marítimo' },
		{ value: '161099', description: 'Atividades de apoio à agricultura não especificadas anteriormente' },
		{ value: '322107', description: 'Atividades de apoio à aqüicultura em água doce' },
		{ value: '321305', description: 'Atividades de apoio à aqüicultura em água salgada e salobra' },
		{ value: '8550302', description: 'Atividades de apoio à educação, exceto caixas escolares' },
		{ value: '990402', description: 'Atividades de apoio à extração de minerais metálicos não-ferrosos' },
		{ value: '990403', description: 'Atividades de apoio à extração de minerais não-metálicos' },
		{ value: '990401', description: 'Atividades de apoio à extração de minério de ferro' },
		{ value: '910600', description: 'Atividades de apoio à extração de petróleo e gás natural' },
		{ value: '8660700', description: 'Atividades de apoio à gestão de saúde' },
		{ value: '162899', description: 'Atividades de apoio à pecuária não especificadas anteriormente' },
		{ value: '312404', description: 'Atividades de apoio à pesca em água doce' },
		{ value: '311604', description: 'Atividades de apoio à pesca em água salgada' },
		{ value: '230600', description: 'Atividades de apoio à produção florestal' },
		{ value: '9002701', description: 'Atividades de artistas plásticos, jornalistas independentes e escritores' },
		{ value: '8711503', description: 'Atividades de assistência a deficientes físicos, imunodeprimidos e convalescentes' },
		{
			value: '8720499',
			description: 'Atividades de assistência psicossocial e à saúde a portadores de distúrbios psíquicos, deficiência m'
		},
		{
			value: '8730199',
			description: 'Atividades de assistência social prestadas em residências coletivas e particulares não especificadas'
		},
		{ value: '9430800', description: 'Atividades de associações de defesa de direitos sociais' },
		{ value: '8630599', description: 'Atividades de atenção ambulatorial não especificadas anteriormente' },
		{ value: '8610102', description: 'Atividades de atendimento em pronto-socorro e unidades hospitalares para atendimento a urgências' },
		{
			value: '8610101',
			description: 'Atividades de atendimento hospitalar, exceto pronto-socorro e unidades para atendimento a urgências'
		},
		{ value: '8690902', description: 'Atividades de bancos de leite humano' },
		{ value: '9101500', description: 'Atividades de bibliotecas e arquivos' },
		{ value: '8720401', description: 'Atividades de centros de assistência psicossocial' },
		{ value: '8291100', description: 'Atividades de cobrança e informações cadastrais' },
		{ value: '9313100', description: 'Atividades de condicionamento físico' },
		{ value: '6920602', description: 'Atividades de consultoria e auditoria contábil e tributária' },
		{ value: '7020400', description: 'Atividades de consultoria em gestão empresarial, exceto consultoria técnica específica' },
		{ value: '6920601', description: 'Atividades de contabilidade' },
		{ value: '3511502', description: 'Atividades de coordenação e controle da operação da geração e transmissão de energia elétrica' },
		{ value: '5250802', description: 'Atividades de despachantes aduaneiros' },
		{ value: '8650001', description: 'Atividades de enfermagem' },
		{ value: '9602502', description: 'Atividades de estética e outros serviços de cuidados com a beleza' },
		{ value: '7119702', description: 'Atividades de estudos geológicos' },
		{ value: '5914600', description: 'Atividades de exibição cinematográfica' },
		{ value: '8650004', description: 'Atividades de fisioterapia' },
		{ value: '8650006', description: 'Atividades de fonoaudiologia' },
		{ value: '8712300', description: 'Atividades de fornecimento de infra-estrutura de apoio e assistência a paciente no domicílio' },
		{ value: '5310502', description: 'Atividades de franqueadas e permissionárias do Correio Nacional' },
		{ value: '5920100', description: 'Atividades de gravação de som e de edição de música' },
		{ value: '7490104', description: 'Atividades de intermediação e agenciamento de serviços e negócios em geral, exceto imobiliários' },
		{ value: '8030700', description: 'Atividades de investigação particular' },
		{
			value: '9103100',
			description: 'Atividades de jardins botânicos, zoológicos, parques nacionais, reservas ecológicas e áreas de prote'
		},
		{ value: '8129000', description: 'Atividades de limpeza não especificadas anteriormente' },
		{ value: '8020000', description: 'Atividades de monitoramento de sistemas de segurança' },
		{ value: '9102301', description: 'Atividades de museus e de exploração de lugares e prédios históricos e atrações similares' },
		{ value: '9493600', description: 'Atividades de organizações associativas ligadas à cultura e à arte' },
		{ value: '9411100', description: 'Atividades de organizações associativas patronais e empresariais' },
		{ value: '9412000', description: 'Atividades de organizações associativas profissionais' },
		{ value: '9492800', description: 'Atividades de organizações políticas' },
		{ value: '9491000', description: 'Atividades de organizações religiosas' },
		{ value: '9420100', description: 'Atividades de organizações sindicais' },
		{ value: '8690904', description: 'Atividades de podologia' },
		{ value: '163600', description: 'Atividades de pós-colheita' },
		{
			value: '5912099',
			description: 'Atividades de pós-produção cinematográfica, de vídeos e de programas de televisão não especificadas '
		},
		{ value: '8690901', description: 'Atividades de práticas integrativas e complementares em saúde humana' },
		{
			value: '5911199',
			description: 'Atividades de produção cinematográfica, de vídeos e de programas de televisão não especificadas ante'
		},
		{ value: '7420002', description: 'Atividades de produção de fotografias aéreas e submarinas' },
		{ value: '7420001', description: 'Atividades de produção de fotografias, exceto aérea e submarina' },
		{ value: '8650099', description: 'Atividades de profissionais da área de saúde não especificadas anteriormente' },
		{ value: '8650002', description: 'Atividades de profissionais da nutrição' },
		{ value: '8650003', description: 'Atividades de psicologia e psicanálise' },
		{ value: '6010100', description: 'Atividades de rádio' },
		{ value: '8630507', description: 'Atividades de reprodução humana assistida' },
		{ value: '9609205', description: 'Atividades de sauna e banhos' },
		{ value: '8640299', description: 'Atividades de serviços de complementação diagnóstica e terapêutica não especificadas anteriormente' },
		{ value: '9001906', description: 'Atividades de sonorização e de iluminação' },
		{ value: '8220200', description: 'Atividades de teleatendimento' },
		{ value: '6021700', description: 'Atividades de televisão aberta' },
		{ value: '8650007', description: 'Atividades de terapia de nutrição enteral e parenteral' },
		{ value: '8650005', description: 'Atividades de terapia ocupacional' },
		{ value: '8012900', description: 'Atividades de transporte de valores' },
		{ value: '8011101', description: 'Atividades de vigilância e segurança privada' },
		{ value: '5310501', description: 'Atividades do Correio Nacional' },
		{ value: '9603399', description: 'Atividades funerárias e serviços relacionados não especificados anteriormente' },
		{ value: '8130300', description: 'Atividades paisagísticas' },
		{ value: '3702900', description: 'Atividades relacionadas a esgoto, exceto a gestão de redes' },
		{ value: '6022502', description: 'Atividades relacionadas à televisão por assinatura, exceto programadoras' },
		{ value: '7119799', description: 'Atividades técnicas relacionadas à engenharia e arquitetura não especificadas anteriormente' },
		{ value: '7500100', description: 'Atividades veterinárias' },
		{ value: '6621502', description: 'Auditoria e consultoria atuarial' },
		{ value: '6410700', description: 'Banco Central' },
		{ value: '6421200', description: 'Bancos comerciais' },
		{ value: '6424701', description: 'Bancos cooperativos' },
		{ value: '6438701', description: 'Bancos de câmbio' },
		{ value: '6433600', description: 'Bancos de desenvolvimento' },
		{ value: '6432800', description: 'Bancos de investimento' },
		{ value: '6422100', description: 'Bancos múltiplos, com carteira comercial' },
		{ value: '6431000', description: 'Bancos múltiplos, sem carteira comercial' },
		{ value: '5611202', description: 'Bares e outros estabelecimentos especializados em servir bebidas' },
		{ value: '1061901', description: 'Beneficiamento de arroz' },
		{ value: '1081301', description: 'Beneficiamento de café' },
		{ value: '500302', description: 'Beneficiamento de carvão mineral' },
		{ value: '810010', description: 'Beneficiamento de gesso e caulim associado à extração' },
		{ value: '721902', description: 'Beneficiamento de minério de alumínio' },
		{ value: '722702', description: 'Beneficiamento de minério de estanho' },
		{ value: '723502', description: 'Beneficiamento de minério de manganês' },
		{ value: '724302', description: 'Beneficiamento de minério de metais preciosos' },
		{
			value: '729405',
			description: 'Beneficiamento de minérios de cobre, chumbo, zinco e outros minerais metálicos não-ferrosos não espe'
		},
		{ value: '6611802', description: 'Bolsa de mercadorias' },
		{ value: '6611803', description: 'Bolsa de mercadorias e futuros' },
		{ value: '6611801', description: 'Bolsa de valores' },
		{ value: '2391501', description: 'Britamento de pedras, exceto associado à extração' },
		{ value: '9602501', description: 'Cabeleireiros' },
		{ value: '170900', description: 'Caça e serviços relacionados' },
		{ value: '6499904', description: 'Caixas de financiamento de corporações' },
		{ value: '6423900', description: 'Caixas econômicas' },
		{ value: '6619304', description: 'Caixas eletrônicos' },
		{ value: '5590602', description: 'Campings' },
		{ value: '5620103', description: 'Cantinas - serviços de alimentação privativos' },
		{ value: '3600601', description: 'Captação, tratamento e distribuição de água' },
		{ value: '5212500', description: 'Carga e descarga' },
		{ value: '6912500', description: 'Cartórios' },
		{ value: '9200301', description: 'Casas de bingo' },
		{ value: '8230002', description: 'Casas de festas e eventos' },
		{ value: '8299706', description: 'Casas lotéricas' },
		{ value: '8711504', description: 'Centros de apoio a pacientes com câncer e com AIDS' },
		{ value: '9529102', description: 'Chaveiros' },
		{ value: '8711501', description: 'Clínicas e residências geriátricas' },
		{ value: '6499901', description: 'Clubes de investimento' },
		{ value: '9312300', description: 'Clubes sociais, esportivos e similares' },
		{ value: '220903', description: 'Coleta de castanha-do-pará em florestas nativas' },
		{ value: '220904', description: 'Coleta de látex em florestas nativas' },
		{ value: '312403', description: 'Coleta de outros produtos aquáticos de água doce' },
		{ value: '311603', description: 'Coleta de outros produtos marinhos' },
		{ value: '220905', description: 'Coleta de palmito em florestas nativas' },
		{ value: '220999', description: 'Coleta de produtos não-madeireiros não especificados anteriormente em florestas nativas' },
		{ value: '3811400', description: 'Coleta de resíduos não-perigosos' },
		{ value: '3812200', description: 'Coleta de resíduos perigosos' },
		{
			value: '4649409',
			description: 'Comércio  atacadista  de  produtos  de  higiene,  limpeza  e  conservação  domiciliar,  com   ativid'
		},
		{ value: '4511101', description: 'Comércio a varejo de automóveis, camionetas e utilitários novos' },
		{ value: '4511102', description: 'Comércio a varejo de automóveis, camionetas e utilitários usados' },
		{ value: '4541203', description: 'Comércio a varejo de motocicletas e motonetas novas' },
		{ value: '4541204', description: 'Comércio a varejo de motocicletas e motonetas usadas' },
		{ value: '4530703', description: 'Comércio a varejo de peças e acessórios novos para veículos automotores' },
		{ value: '4541205', description: 'Comércio a varejo de peças e acessórios para motocicletas e motonetas' },
		{ value: '4530704', description: 'Comércio a varejo de peças e acessórios usados para veículos automotores' },
		{ value: '4530705', description: 'Comércio a varejo de pneumáticos e câmaras-de-ar' },
		{
			value: '4632003',
			description: 'Comércio atacadista  de  cereais  e  leguminosas beneficiados,  farinhas, amidos  e féculas, com  at'
		},
		{ value: '4637102', description: 'Comércio atacadista de açúcar' },
		{ value: '4635401', description: 'Comércio atacadista de água mineral' },
		{
			value: '4681801',
			description: 'Comércio atacadista de álcool carburante, biodiesel, gasolina e demais derivados de petróleo, exceto'
		},
		{ value: '4623103', description: 'Comércio atacadista de algodão' },
		{ value: '4623109', description: 'Comércio atacadista de alimentos para animais' },
		{ value: '4623101', description: 'Comércio atacadista de animais vivos' },
		{ value: '4649402', description: 'Comércio atacadista de aparelhos eletrônicos de uso pessoal e doméstico' },
		{ value: '4641903', description: 'Comércio atacadista de artigos de armarinho' },
		{ value: '4641902', description: 'Comércio atacadista de artigos de cama, mesa e banho' },
		{ value: '4647801', description: 'Comércio atacadista de artigos de escritório e de papelaria' },
		{ value: '4649405', description: 'Comércio atacadista de artigos de tapeçaria; persianas e cortinas' },
		{ value: '4642701', description: 'Comércio atacadista de artigos do vestuário e acessórios, exceto profissionais e de segurança' },
		{ value: '4634602', description: 'Comércio atacadista de aves abatidas e derivados' },
		{ value: '4633802', description: 'Comércio atacadista de aves vivas e ovos' },
		{ value: '4635403', description: 'Comércio atacadista de bebidas com atividade de fracionamento e acondicionamento associada' },
		{ value: '4635499', description: 'Comércio atacadista de bebidas não especificadas anteriormente' },
		{ value: '4649403', description: 'Comércio atacadista de bicicletas, triciclos e outros veículos recreativos' },
		{ value: '4643502', description: 'Comércio atacadista de bolsas, malas e artigos de viagem' },
		{ value: '4669901', description: 'Comércio atacadista de bombas e compressores; partes e peças' },
		{ value: '4623105', description: 'Comércio atacadista de cacau' },
		{ value: '4621400', description: 'Comércio atacadista de café em grão' },
		{ value: '4637101', description: 'Comércio atacadista de café torrado, moído e solúvel' },
		{ value: '4643501', description: 'Comércio atacadista de calçados' },
		{ value: '4634601', description: 'Comércio atacadista de carnes bovinas e suínas e derivados' },
		{ value: '4634699', description: 'Comércio atacadista de carnes e derivados de outros animais' },
		{ value: '4632001', description: 'Comércio atacadista de cereais e leguminosas beneficiados' },
		{ value: '4635402', description: 'Comércio atacadista de cerveja, chope e refrigerante' },
		{ value: '4637107', description: 'Comércio atacadista de chocolates, confeitos, balas, bombons e semelhantes' },
		{ value: '4636202', description: 'Comércio atacadista de cigarros, cigarrilhas e charutos' },
		{ value: '4674500', description: 'Comércio atacadista de cimento' },
		{ value: '4633803', description: 'Comércio atacadista de coelhos e outros pequenos animais vivos para alimentação' },
		{ value: '4681804', description: 'Comércio atacadista de combustíveis de origem mineral em bruto' },
		{ value: '4681803', description: 'Comércio atacadista de combustíveis de origem vegetal, exceto álcool carburante' },
		{ value: '4681802', description: 'Comércio atacadista de combustíveis realizado por transportador retalhista (TRR)' },
		{ value: '4652400', description: 'Comércio atacadista de componentes eletrônicos e equipamentos de telefonia e comunicação' },
		{ value: '4646001', description: 'Comércio atacadista de cosméticos e produtos de perfumaria' },
		{ value: '4623102', description: 'Comércio atacadista de couros, lãs, peles e outros subprodutos não-comestíveis de origem animal' },
		{ value: '4683400', description: 'Comércio atacadista de defensivos agrícolas, adubos, fertilizantes e corretivos do solo' },
		{ value: '4686902', description: 'Comércio atacadista de embalagens' },
		{ value: '3513100', description: 'Comércio atacadista de energia elétrica' },
		{ value: '4651601', description: 'Comércio atacadista de equipamentos de informática' },
		{ value: '4649401', description: 'Comércio atacadista de equipamentos elétricos de uso pessoal e doméstico' },
		{ value: '4632002', description: 'Comércio atacadista de farinhas, amidos e féculas' },
		{ value: '4672900', description: 'Comércio atacadista de ferragens e ferramentas' },
		{ value: '4649407', description: 'Comércio atacadista de filmes, CDs, DVDs, fitas e discos' },
		{ value: '4689302', description: 'Comércio atacadista de fios e fibras têxteis beneficiados' },
		{ value: '4633801', description: 'Comércio atacadista de frutas, verduras, raízes, tubérculos, hortaliças e legumes frescos' },
		{ value: '4636201', description: 'Comércio atacadista de fumo beneficiado' },
		{ value: '4623104', description: 'Comércio atacadista de fumo em folha não beneficiado' },
		{ value: '4682600', description: 'Comércio atacadista de gás liqüefeito de petróleo (GLP)' },
		{
			value: '4645101',
			description: 'Comércio atacadista de instrumentos e materiais para uso médico, cirúrgico, hospitalar e de laborató'
		},
		{
			value: '4649410',
			description: 'Comércio atacadista de jóias, relógios e bijuterias, inclusive pedras preciosas e semipreciosas lapi'
		},
		{ value: '4631100', description: 'Comércio atacadista de leite e laticínios' },
		{ value: '4647802', description: 'Comércio atacadista de livros, jornais e outras publicações' },
		{ value: '4681805', description: 'Comércio atacadista de lubrificantes' },
		{ value: '4649406', description: 'Comércio atacadista de lustres, luminárias e abajures' },
		{ value: '4671100', description: 'Comércio atacadista de madeira e produtos derivados' },
		{ value: '4665600', description: 'Comércio atacadista de máquinas e equipamentos para uso comercial; partes e peças' },
		{ value: '4663000', description: 'Comércio atacadista de máquinas e equipamentos para uso industrial; partes e peças' },
		{ value: '4661300', description: 'Comércio atacadista de máquinas, aparelhos e equipamentos para uso agropecuário; partes e peças' },
		{
			value: '4664800',
			description: 'Comércio atacadista de máquinas, aparelhos e equipamentos para uso odonto-médico-hospitalar; partes '
		},
		{
			value: '4662100',
			description: 'Comércio atacadista de máquinas, equipamentos para terraplenagem, mineração e construção; partes e p'
		},
		{ value: '4679602', description: 'Comércio atacadista de mármores e granitos' },
		{ value: '4637105', description: 'Comércio atacadista de massas alimentícias' },
		{ value: '4679699', description: 'Comércio atacadista de materiais de construção em geral' },
		{ value: '4673700', description: 'Comércio atacadista de material elétrico' },
		{
			value: '4623108',
			description: 'Comércio atacadista de matérias-primas agrícolas com atividade de fracionamento e acondicionamento a'
		},
		{ value: '4623199', description: 'Comércio atacadista de matérias-primas agrícolas não especificadas anteriormente' },
		{ value: '4644301', description: 'Comércio atacadista de medicamentos e drogas de uso humano' },
		{ value: '4644302', description: 'Comércio atacadista de medicamentos e drogas de uso veterinário' },
		{ value: '4692300', description: 'Comércio atacadista de mercadorias em geral, com predominância de insumos agropecuários' },
		{ value: '4691500', description: 'Comércio atacadista de mercadorias em geral, com predominância de produtos alimentícios' },
		{
			value: '4693100',
			description: 'Comércio atacadista de mercadorias em geral, sem predominância de alimentos ou de insumos agropecuár'
		},
		{ value: '4649404', description: 'Comércio atacadista de móveis e artigos de colchoaria' },
		{ value: '4637103', description: 'Comércio atacadista de óleos e gorduras' },
		{
			value: '4669999',
			description: 'Comércio atacadista de outras máquinas e equipamentos não especificados anteriormente; partes e peça'
		},
		{
			value: '4649499',
			description: 'Comércio atacadista de outros equipamentos e artigos de uso pessoal e doméstico não especificados an'
		},
		{ value: '4684299', description: 'Comércio atacadista de outros produtos químicos e petroquímicos não especificados anteriormente' },
		{ value: '4637104', description: 'Comércio atacadista de pães, bolos, biscoitos e similares' },
		{ value: '4686901', description: 'Comércio atacadista de papel e papelão em bruto' },
		{ value: '4634603', description: 'Comércio atacadista de pescados e frutos do mar' },
		{ value: '4639701', description: 'Comércio atacadista de produtos alimentícios em geral' },
		{
			value: '4639702',
			description: 'Comércio atacadista de produtos alimentícios em geral, com atividade de fracionamento e acondicionam'
		},
		{ value: '4689301', description: 'Comércio atacadista de produtos da extração mineral, exceto combustíveis' },
		{ value: '4646002', description: 'Comércio atacadista de produtos de higiene pessoal' },
		{ value: '4649408', description: 'Comércio atacadista de produtos de higiene, limpeza e conservação domiciliar' },
		{ value: '4645103', description: 'Comércio atacadista de produtos odontológicos' },
		{ value: '4685100', description: 'Comércio atacadista de produtos siderúrgicos e metalúrgicos, exceto para construção' },
		{ value: '4645102', description: 'Comércio atacadista de próteses e artigos de ortopedia' },
		{ value: '4687701', description: 'Comércio atacadista de resíduos de papel e papelão' },
		{ value: '4687703', description: 'Comércio atacadista de resíduos e sucatas metálicos' },
		{ value: '4687702', description: 'Comércio atacadista de resíduos e sucatas não-metálicos, exceto de papel e papelão' },
		{ value: '4684201', description: 'Comércio atacadista de resinas e elastômeros' },
		{ value: '4642702', description: 'Comércio atacadista de roupas e acessórios para uso profissional e de segurança do trabalho' },
		{ value: '4623106', description: 'Comércio atacadista de sementes, flores, plantas e gramas' },
		{ value: '4623107', description: 'Comércio atacadista de sisal' },
		{ value: '4622200', description: 'Comércio atacadista de soja' },
		{ value: '4684202', description: 'Comércio atacadista de solventes' },
		{ value: '4637106', description: 'Comércio atacadista de sorvetes' },
		{ value: '4651602', description: 'Comércio atacadista de suprimentos para informática' },
		{ value: '4641901', description: 'Comércio atacadista de tecidos' },
		{ value: '4679601', description: 'Comércio atacadista de tintas, vernizes e similares' },
		{ value: '4679603', description: 'Comércio atacadista de vidros, espelhos e vitrais' },
		{ value: '4679604', description: 'Comércio atacadista especializado de materiais de construção não especificados anteriormente' },
		{ value: '4637199', description: 'Comércio atacadista especializado em outros produtos alimentícios não especificados anteriormente' },
		{
			value: '4689399',
			description: 'Comércio atacadista especializado em outros produtos intermediários não especificados anteriormente'
		},
		{ value: '4511103', description: 'Comércio por atacado de automóveis, camionetas e utilitários novos e usados' },
		{ value: '4511104', description: 'Comércio por atacado de caminhões novos e usados' },
		{ value: '4541201', description: 'Comércio por atacado de motocicletas e motonetas' },
		{ value: '4511106', description: 'Comércio por atacado de ônibus e microônibus novos e usados' },
		{ value: '4530701', description: 'Comércio por atacado de peças e acessórios novos para veículos automotores' },
		{ value: '4541202', description: 'Comércio por atacado de peças e acessórios para motocicletas e motonetas' },
		{ value: '4530702', description: 'Comércio por atacado de pneumáticos e câmaras-de-ar' },
		{ value: '4511105', description: 'Comércio por atacado de reboques e semi-reboques novos e usados' },
		{ value: '4542102', description: 'Comércio sob consignação de motocicletas e motonetas' },
		{ value: '4512902', description: 'Comércio sob consignação de veículos automotores' },
		{ value: '4789004', description: 'Comércio varejista de animais vivos e de artigos e alimentos para animais de estimação' },
		{ value: '4785701', description: 'Comércio varejista de antigüidades' },
		{ value: '4789009', description: 'Comércio varejista de armas e munições' },
		{ value: '4755502', description: 'Comercio varejista de artigos de armarinho' },
		{ value: '4763604', description: 'Comércio varejista de artigos de caça, pesca e camping' },
		{ value: '4755503', description: 'Comercio varejista de artigos de cama, mesa e banho' },
		{ value: '4754702', description: 'Comércio varejista de artigos de colchoaria' },
		{ value: '4754703', description: 'Comércio varejista de artigos de iluminação' },
		{ value: '4783101', description: 'Comércio varejista de artigos de joalheria' },
		{ value: '4774100', description: 'Comércio varejista de artigos de óptica' },
		{ value: '4761003', description: 'Comércio varejista de artigos de papelaria' },
		{ value: '4783102', description: 'Comércio varejista de artigos de relojoaria' },
		{ value: '4759801', description: 'Comércio varejista de artigos de tapeçaria, cortinas e persianas' },
		{ value: '4782202', description: 'Comércio varejista de artigos de viagem' },
		{ value: '4781400', description: 'Comércio varejista de artigos do vestuário e acessórios' },
		{ value: '4763602', description: 'Comércio varejista de artigos esportivos' },
		{ value: '4789008', description: 'Comércio varejista de artigos fotográficos e para filmagem' },
		{ value: '4773300', description: 'Comércio varejista de artigos médicos e ortopédicos' },
		{ value: '4723700', description: 'Comércio varejista de bebidas' },
		{ value: '4763603', description: 'Comércio varejista de bicicletas e triciclos; peças e acessórios' },
		{ value: '4763601', description: 'Comércio varejista de brinquedos e artigos recreativos' },
		{ value: '4744004', description: 'Comércio varejista de cal, areia, pedra britada, tijolos e telhas' },
		{ value: '4782201', description: 'Comércio varejista de calçados' },
		{ value: '4722901', description: 'Comércio varejista de carnes - açougues' },
		{ value: '4731800', description: 'Comércio varejista de combustíveis para veículos automotores' },
		{ value: '4772500', description: 'Comércio varejista de cosméticos, produtos de perfumaria e de higiene pessoal' },
		{ value: '4762800', description: 'Comércio varejista de discos, CDs, DVDs e fitas' },
		{ value: '4721104', description: 'Comércio varejista de doces, balas, bombons e semelhantes' },
		{ value: '4763605', description: 'Comércio varejista de embarcações e outros veículos recreativos; peças e acessórios' },
		{ value: '4789007', description: 'Comércio varejista de equipamentos para escritório' },
		{ value: '4744001', description: 'Comércio varejista de ferragens e ferramentas' },
		{ value: '4789006', description: 'Comércio varejista de fogos de artifício e artigos pirotécnicos' },
		{ value: '4784900', description: 'Comércio varejista de gás liqüefeito de petróleo (GLP)' },
		{ value: '4724500', description: 'Comércio varejista de hortifrutigranjeiros' },
		{ value: '4761002', description: 'Comércio varejista de jornais e revistas' },
		{ value: '4721103', description: 'Comércio varejista de laticínios e frios' },
		{ value: '4761001', description: 'Comércio varejista de livros' },
		{ value: '4732600', description: 'Comércio varejista de lubrificantes' },
		{ value: '4744002', description: 'Comércio varejista de madeira e artefatos' },
		{ value: '4744099', description: 'Comércio varejista de materiais de construção em geral' },
		{ value: '4744005', description: 'Comércio varejista de materiais de construção não especificados anteriormente' },
		{ value: '4744003', description: 'Comércio varejista de materiais hidráulicos' },
		{ value: '4742300', description: 'Comércio varejista de material elétrico' },
		{ value: '4771704', description: 'Comércio varejista de medicamentos veterinários' },
		{
			value: '4711301',
			description: 'Comércio varejista de mercadorias em geral, com predominância de produtos alimentícios - hipermercad'
		},
		{
			value: '4712100',
			description: 'Comércio varejista de mercadorias em geral, com predominância de produtos alimentícios - minimercado'
		},
		{
			value: '4711302',
			description: 'Comércio varejista de mercadorias em geral, com predominância de produtos alimentícios - supermercad'
		},
		{ value: '4729602', description: 'Comércio varejista de mercadorias em lojas de conveniência' },
		{ value: '4754701', description: 'Comércio varejista de móveis' },
		{ value: '4789003', description: 'Comércio varejista de objetos de arte' },
		{ value: '4759899', description: 'Comércio varejista de outros artigos de uso doméstico não especificados anteriormente' },
		{ value: '4785799', description: 'Comércio varejista de outros artigos usados' },
		{ value: '4789099', description: 'Comércio varejista de outros produtos não especificados anteriormente' },
		{ value: '4744006', description: 'Comércio varejista de pedras para revestimento' },
		{ value: '4789002', description: 'Comércio varejista de plantas e flores naturais' },
		{
			value: '4729699',
			description: 'Comércio varejista de produtos alimentícios em geral ou especializado em produtos alimentícios não e'
		},
		{ value: '4771703', description: 'Comércio varejista de produtos farmacêuticos homeopáticos' },
		{ value: '4771702', description: 'Comércio varejista de produtos farmacêuticos, com manipulação de fórmulas' },
		{ value: '4771701', description: 'Comércio varejista de produtos farmacêuticos, sem manipulação de fórmulas' },
		{ value: '4789005', description: 'Comércio varejista de produtos saneantes domissanitários' },
		{ value: '4789001', description: 'Comércio varejista de suvenires, bijuterias e artesanatos' },
		{ value: '4755501', description: 'Comércio varejista de tecidos' },
		{ value: '4741500', description: 'Comércio varejista de tintas e materiais para pintura' },
		{ value: '4743100', description: 'Comércio varejista de vidros' },
		{ value: '4753900', description: 'Comércio varejista especializado de eletrodomésticos e equipamentos de áudio e vídeo' },
		{ value: '4752100', description: 'Comércio varejista especializado de equipamentos de telefonia e comunicação' },
		{ value: '4751201', description: 'Comércio varejista especializado de equipamentos e suprimentos de informática' },
		{ value: '4756300', description: 'Comércio varejista especializado de instrumentos musicais e acessórios' },
		{
			value: '4757100',
			description: 'Comércio varejista especializado de peças e acessórios para aparelhos eletroeletrônicos para uso dom'
		},
		{ value: '5250801', description: 'Comissaria de despachos' },
		{ value: '6435203', description: 'Companhias hipotecárias' },
		{ value: '6810201', description: 'Compra e venda de imóveis próprios' },
		{ value: '6499905', description: 'Concessão de crédito pelas OSCIP' },
		{ value: '5221400', description: 'Concessionárias de rodovias, pontes, túneis e serviços relacionados' },
		{ value: '8112500', description: 'Condomínios prediais' },
		{ value: '8711505', description: 'Condomínios residenciais para idosos' },
		{ value: '1412601', description: 'Confecção de peças do vestuário, exceto roupas íntimas e as confeccionadas sob medida' },
		{ value: '1411801', description: 'Confecção de roupas íntimas' },
		{ value: '1413401', description: 'Confecção de roupas profissionais, exceto sob medida' },
		{ value: '1412602', description: 'Confecção, sob medida, de peças do vestuário, exceto roupas íntimas' },
		{ value: '1413402', description: 'Confecção, sob medida, de roupas profissionais' },
		{ value: '220906', description: 'Conservação de florestas nativas' },
		{ value: '4221901', description: 'Construção de barragens e represas para geração de energia elétrica' },
		{ value: '4120400', description: 'Construção de edifícios' },
		{ value: '3011301', description: 'Construção de embarcações de grande porte' },
		{ value: '3012100', description: 'Construção de embarcações para esporte e lazer' },
		{ value: '3011302', description: 'Construção de embarcações para uso comercial e para usos especiais, exceto de grande porte' },
		{ value: '4221902', description: 'Construção de estações e redes de distribuição de energia elétrica' },
		{ value: '4221904', description: 'Construção de estações e redes de telecomunicações' },
		{ value: '4299501', description: 'Construção de instalações esportivas e recreativas' },
		{ value: '4212000', description: 'Construção de obras-de-arte especiais' },
		{
			value: '4222701',
			description: 'Construção de redes de abastecimento de água, coleta de esgoto e construções correlatas, exceto obra'
		},
		{ value: '4223500', description: 'Construção de redes de transportes por dutos, exceto para água e esgoto' },
		{ value: '4211101', description: 'Construção de rodovias e ferrovias' },
		{ value: '7319004', description: 'Consultoria em publicidade' },
		{ value: '6204000', description: 'Consultoria em tecnologia da informação' },
		{ value: '6424702', description: 'Cooperativas centrais de crédito' },
		{ value: '6424703', description: 'Cooperativas de crédito mútuo' },
		{ value: '6424704', description: 'Cooperativas de crédito rural' },
		{ value: '1910100', description: 'Coquerias' },
		{ value: '6619302', description: 'Correspondentes de instituições financeiras' },
		{ value: '6821801', description: 'Corretagem na compra e venda e avaliação de imóveis' },
		{ value: '6821802', description: 'Corretagem no aluguel de imóveis' },
		{ value: '6612603', description: 'Corretoras de câmbio' },
		{ value: '6612604', description: 'Corretoras de contratos de mercadorias' },
		{ value: '6612601', description: 'Corretoras de títulos e valores mobiliários' },
		{ value: '6622300', description: 'Corretores e agentes de seguros, de planos de previdência complementar e de saúde' },
		{ value: '159802', description: 'Criação de animais de estimação' },
		{ value: '152103', description: 'Criação de asininos e muares' },
		{ value: '155504', description: 'Criação de aves, exceto galináceos' },
		{ value: '159804', description: 'Criação de bicho-da-seda' },
		{ value: '151201', description: 'Criação de bovinos para corte' },
		{ value: '151202', description: 'Criação de bovinos para leite' },
		{ value: '151203', description: 'Criação de bovinos, exceto para corte e leite' },
		{ value: '152101', description: 'Criação de bufalinos' },
		{ value: '322102', description: 'Criação de camarões em água doce' },
		{ value: '321302', description: 'Criação de camarões em água salgada e salobra' },
		{ value: '153901', description: 'Criação de caprinos' },
		{ value: '152102', description: 'Criação de eqüinos' },
		{ value: '159803', description: 'Criação de escargô' },
		{ value: '7319001', description: 'Criação de estandes para feiras e exposições' },
		{ value: '155501', description: 'Criação de frangos para corte' },
		{ value: '322106', description: 'Criação de jacaré' },
		{ value: '322103', description: 'Criação de ostras e mexilhões em água doce' },
		{ value: '321303', description: 'Criação de ostras e mexilhões em água salgada e salobra' },
		{ value: '155503', description: 'Criação de outros galináceos, exceto para corte' },
		{ value: '153902', description: 'Criação de ovinos, inclusive para produção de lã' },
		{ value: '322101', description: 'Criação de peixes em água doce' },
		{ value: '321301', description: 'Criação de peixes em água salgada e salobra' },
		{ value: '322104', description: 'Criação de peixes ornamentais em água doce' },
		{ value: '321304', description: 'Criação de peixes ornamentais em água salgada e salobra' },
		{ value: '154700', description: 'Criação de suínos' },
		{ value: '119901', description: 'Cultivo de abacaxi' },
		{ value: '210102', description: 'Cultivo de acácia-negra' },
		{ value: '133401', description: 'Cultivo de açaí' },
		{ value: '112101', description: 'Cultivo de algodão herbáceo' },
		{ value: '119902', description: 'Cultivo de alho' },
		{ value: '116401', description: 'Cultivo de amendoim' },
		{ value: '111301', description: 'Cultivo de arroz' },
		{ value: '133402', description: 'Cultivo de banana' },
		{ value: '119903', description: 'Cultivo de batata-inglesa' },
		{ value: '135100', description: 'Cultivo de cacau' },
		{ value: '134200', description: 'Cultivo de café' },
		{ value: '133403', description: 'Cultivo de caju' },
		{ value: '113000', description: 'Cultivo de cana-de-açúcar' },
		{ value: '119904', description: 'Cultivo de cebola' },
		{ value: '139301', description: 'Cultivo de chá-da-índia' },
		{ value: '133404', description: 'Cultivo de cítricos, exceto laranja' },
		{ value: '133405', description: 'Cultivo de coco-da-baía' },
		{ value: '139305', description: 'Cultivo de dendê' },
		{ value: '139302', description: 'Cultivo de erva-mate' },
		{ value: '210105', description: 'Cultivo de espécies madeireiras, exceto eucalipto, acácia-negra, pinus e teca' },
		{ value: '210101', description: 'Cultivo de eucalipto' },
		{ value: '119905', description: 'Cultivo de feijão' },
		{ value: '122900', description: 'Cultivo de flores e plantas ornamentais' },
		{ value: '133499', description: 'Cultivo de frutas de lavoura permanente não especificadas anteriormente' },
		{ value: '114800', description: 'Cultivo de fumo' },
		{ value: '116402', description: 'Cultivo de girassol' },
		{ value: '133406', description: 'Cultivo de guaraná' },
		{ value: '112102', description: 'Cultivo de juta' },
		{ value: '131800', description: 'Cultivo de laranja' },
		{ value: '133407', description: 'Cultivo de maçã' },
		{ value: '133408', description: 'Cultivo de mamão' },
		{ value: '116403', description: 'Cultivo de mamona' },
		{ value: '119906', description: 'Cultivo de mandioca' },
		{ value: '133410', description: 'Cultivo de manga' },
		{ value: '133409', description: 'Cultivo de maracujá' },
		{ value: '119908', description: 'Cultivo de melancia' },
		{ value: '119907', description: 'Cultivo de melão' },
		{ value: '111302', description: 'Cultivo de milho' },
		{ value: '121102', description: 'Cultivo de morango' },
		{ value: '210106', description: 'Cultivo de mudas em viveiros florestais' },
		{ value: '112199', description: 'Cultivo de outras fibras de lavoura temporária não especificadas anteriormente' },
		{ value: '116499', description: 'Cultivo de outras oleaginosas de lavoura temporária não especificadas anteriormente' },
		{ value: '139399', description: 'Cultivo de outras plantas de lavoura permanente não especificadas anteriormente' },
		{ value: '119999', description: 'Cultivo de outras plantas de lavoura temporária não especificadas anteriormente' },
		{ value: '111399', description: 'Cultivo de outros cereais não especificados anteriormente' },
		{ value: '133411', description: 'Cultivo de pêssego' },
		{ value: '139303', description: 'Cultivo de pimenta-do-reino' },
		{ value: '210103', description: 'Cultivo de pinus' },
		{ value: '139304', description: 'Cultivo de plantas para condimento, exceto pimenta-do-reino' },
		{ value: '139306', description: 'Cultivo de seringueira' },
		{ value: '115600', description: 'Cultivo de soja' },
		{ value: '210104', description: 'Cultivo de teca' },
		{ value: '119909', description: 'Cultivo de tomate rasteiro' },
		{ value: '111303', description: 'Cultivo de trigo' },
		{ value: '132600', description: 'Cultivo de uva' },
		{ value: '322199', description: 'Cultivos e semicultivos da aqüicultura em água doce não especificados anteriormente' },
		{ value: '321399', description: 'Cultivos e semicultivos da aqüicultura em água salgada e salobra não especificados anteriormente' },
		{ value: '3211603', description: 'Cunhagem de moedas e medalhas' },
		{ value: '8599602', description: 'Cursos de pilotagem' },
		{ value: '8599605', description: 'Cursos preparatórios para concursos' },
		{ value: '1510600', description: 'Curtimento e outras preparações de couro' },
		{ value: '7410202', description: 'Decoração de interiores' },
		{
			value: '2399101',
			description: 'Decoração, lapidação, gravação, vitrificação e outros trabalhos em cerâmica, louça, vidro e cristal'
		},
		{ value: '8422100', description: 'Defesa' },
		{ value: '8425600', description: 'Defesa Civil' },
		{ value: '4311801', description: 'Demolição de edifícios e outras estruturas' },
		{ value: '5211799', description: 'Depósitos de mercadorias para terceiros, exceto armazéns gerais e guarda-móveis' },
		{ value: '3900500', description: 'Descontaminação e outros serviços de gestão de resíduos' },
		{ value: '6201500', description: 'Desenvolvimento de programas de computador sob encomenda' },
		{ value: '6202300', description: 'Desenvolvimento e licenciamento de programas de computador customizáveis' },
		{ value: '6203100', description: 'Desenvolvimento e licenciamento de programas de computador não-customizáveis' },
		{ value: '7410201', description: 'Design' },
		{ value: '9329801', description: 'Discotecas, danceterias, salões de dança e similares' },
		{ value: '5913800', description: 'Distribuição cinematográfica, de vídeo e de programas de televisão' },
		{ value: '3600602', description: 'Distribuição de água por caminhões' },
		{ value: '3520402', description: 'Distribuição de combustíveis gasosos por redes urbanas' },
		{ value: '3514000', description: 'Distribuição de energia elétrica' },
		{ value: '6612602', description: 'Distribuidoras de títulos e valores mobiliários' },
		{ value: '5819100', description: 'Edição de cadastros, listas e outros produtos gráficos' },
		{ value: '5812300', description: 'Edição de jornais' },
		{ value: '5811500', description: 'Edição de livros' },
		{ value: '5813100', description: 'Edição de revistas' },
		{ value: '5829800', description: 'Edição integrada à impressão de cadastros, listas e outros produtos gráficos' },
		{ value: '5822100', description: 'Edição integrada à impressão de jornais' },
		{ value: '5821200', description: 'Edição integrada à impressão de livros' },
		{ value: '5823900', description: 'Edição integrada à impressão de revistas' },
		{ value: '8511200', description: 'Educação infantil - creche' },
		{ value: '8512100', description: 'Educação infantil - pré-escola' },
		{ value: '8541400', description: 'Educação profissional de nível técnico' },
		{ value: '8542200', description: 'Educação profissional de nível tecnológico' },
		{ value: '8531700', description: 'Educação superior - graduação' },
		{ value: '8532500', description: 'Educação superior - graduação e pós-graduação' },
		{ value: '8533300', description: 'Educação superior - pós-graduação e extensão' },
		{ value: '2019301', description: 'Elaboração de combustíveis nucleares' },
		{ value: '8299702', description: 'Emissão de vales-alimentação, vales-transporte e similares' },
		{ value: '8592999', description: 'Ensino de arte e cultura não especificado anteriormente' },
		{ value: '8592902', description: 'Ensino de artes cênicas, exceto dança' },
		{ value: '8592901', description: 'Ensino de dança' },
		{ value: '8591100', description: 'Ensino de esportes' },
		{ value: '8593700', description: 'Ensino de idiomas' },
		{ value: '8592903', description: 'Ensino de música' },
		{ value: '8513900', description: 'Ensino fundamental' },
		{ value: '8520100', description: 'Ensino médio' },
		{ value: '8292000', description: 'Envasamento e empacotamento sob contrato' },
		{ value: '7490102', description: 'Escafandria e mergulho' },
		{ value: '5223100', description: 'Estacionamento de veículos' },
		{ value: '1340501', description: 'Estamparia e texturização em fios, tecidos, artefatos têxteis e peças do vestuário' },
		{ value: '5911101', description: 'Estúdios cinematográficos' },
		{ value: '9200302', description: 'Exploração de apostas em corridas de cavalos' },
		{ value: '9329802', description: 'Exploração de boliches' },
		{ value: '9200399', description: 'Exploração de jogos de azar e apostas não especificados anteriormente' },
		{ value: '9329803', description: 'Exploração de jogos de sinuca, bilhar e similares' },
		{ value: '9329804', description: 'Exploração de jogos eletrônicos recreativos' },
		{ value: '9609204', description: 'Exploração de máquinas de serviços pessoais acionadas por moeda' },
		{ value: '899103', description: 'Extração de amianto' },
		{ value: '810001', description: 'Extração de ardósia e beneficiamento associado' },
		{ value: '810006', description: 'Extração de areia, cascalho ou pedregulho e beneficiamento associado' },
		{ value: '810007', description: 'Extração de argila e beneficiamento associado' },
		{ value: '810009', description: 'Extração de basalto e beneficiamento associado' },
		{ value: '810004', description: 'Extração de calcário e dolomita e beneficiamento associado' },
		{ value: '500301', description: 'Extração de carvão mineral' },
		{ value: '893200', description: 'Extração de gemas (pedras preciosas e semipreciosas)' },
		{ value: '810005', description: 'Extração de gesso e caulim' },
		{ value: '899101', description: 'Extração de grafita' },
		{ value: '810002', description: 'Extração de granito e beneficiamento associado' },
		{ value: '220901', description: 'Extração de madeira em florestas nativas' },
		{ value: '210107', description: 'Extração de madeira em florestas plantadas' },
		{ value: '810003', description: 'Extração de mármore e beneficiamento associado' },
		{ value: '891600', description: 'Extração de minerais para fabricação de adubos, fertilizantes e outros produtos químicos' },
		{ value: '725100', description: 'Extração de minerais radioativos' },
		{ value: '721901', description: 'Extração de minério de alumínio' },
		{ value: '722701', description: 'Extração de minério de estanho' },
		{ value: '710301', description: 'Extração de minério de ferro' },
		{ value: '723501', description: 'Extração de minério de manganês' },
		{ value: '724301', description: 'Extração de minério de metais preciosos' },
		{ value: '729403', description: 'Extração de minério de níquel' },
		{ value: '729402', description: 'Extração de minério de tungstênio' },
		{
			value: '729404',
			description: 'Extração de minérios de cobre, chumbo, zinco e outros minerais metálicos não-ferrosos não especifica'
		},
		{ value: '729401', description: 'Extração de minérios de nióbio e titânio' },
		{ value: '899199', description: 'Extração de outros minerais não-metálicos não especificados anteriormente' },
		{ value: '600001', description: 'Extração de petróleo e gás natural' },
		{ value: '899102', description: 'Extração de quartzo' },
		{ value: '810008', description: 'Extração de saibro e beneficiamento associado' },
		{ value: '892401', description: 'Extração de sal marinho' },
		{ value: '892402', description: 'Extração de sal-gema' },
		{ value: '600003', description: 'Extração e beneficiamento de areias betuminosas' },
		{ value: '600002', description: 'Extração e beneficiamento de xisto' },
		{ value: '810099', description: 'Extração e britamento de pedras e outros materiais para construção e beneficiamento associado' },
		{ value: '2399102', description: 'Fabricação de abrasivos' },
		{ value: '1742702', description: 'Fabricação de absorventes higiênicos' },
		{ value: '1414200', description: 'Fabricação de acessórios do vestuário, exceto para segurança e proteção' },
		{ value: '1072401', description: 'Fabricação de açúcar de cana refinado' },
		{ value: '1072402', description: 'Fabricação de açúcar de cereais (dextrose) e de beterraba' },
		{ value: '1071600', description: 'Fabricação de açúcar em bruto' },
		{ value: '2091600', description: 'Fabricação de adesivos e selantes' },
		{ value: '2093200', description: 'Fabricação de aditivos de uso industrial' },
		{ value: '1099606', description: 'Fabricação de adoçantes naturais e artificiais' },
		{ value: '2013400', description: 'Fabricação de adubos e fertilizantes' },
		{ value: '3041500', description: 'Fabricação de aeronaves' },
		{ value: '1111901', description: 'Fabricação de aguardente de cana-de-açúcar' },
		{ value: '1121600', description: 'Fabricação de águas envasadas' },
		{ value: '1931400', description: 'Fabricação de álcool' },
		{ value: '1099607', description: 'Fabricação de alimentos dietéticos e complementos alimentares' },
		{ value: '1096100', description: 'Fabricação de alimentos e pratos prontos' },
		{ value: '1066000', description: 'Fabricação de alimentos para animais' },
		{ value: '1065101', description: 'Fabricação de amidos e féculas de vegetais' },
		{ value: '2640000', description: 'Fabricação de aparelhos de recepção, reprodução, gravação e amplificação de áudio e vídeo' },
		{ value: '2824101', description: 'Fabricação de aparelhos e equipamentos de ar condicionado para uso industrial' },
		{ value: '2824102', description: 'Fabricação de aparelhos e equipamentos de ar condicionado para uso não-industrial' },
		{ value: '2651500', description: 'Fabricação de aparelhos e equipamentos de medida, teste e controle' },
		{ value: '2731700', description: 'Fabricação de aparelhos e equipamentos para distribuição e controle de energia elétrica' },
		{
			value: '3250703',
			description: 'Fabricação de aparelhos e utensílios para correção de defeitos físicos e aparelhos ortopédicos em ge'
		},
		{
			value: '3250704',
			description: 'Fabricação de aparelhos e utensílios para correção de defeitos físicos e aparelhos ortopédicos em ge'
		},
		{ value: '2759701', description: 'Fabricação de aparelhos elétricos de uso pessoal, peças e acessórios' },
		{ value: '2660400', description: 'Fabricação de aparelhos eletromédicos e eletroterapêuticos e equipamentos de irradiação' },
		{ value: '2670102', description: 'Fabricação de aparelhos fotográficos e cinematográficos, peças e acessórios' },
		{ value: '2632900', description: 'Fabricação de aparelhos telefônicos e de outros equipamentos de comunicação, peças e acessórios' },
		{ value: '2550102', description: 'Fabricação de armas de fogo, outras armas e munições' },
		{ value: '2219600', description: 'Fabricação de artefatos de borracha não especificados anteriormente' },
		{ value: '2342702', description: 'Fabricação de artefatos de cerâmica e barro cozido para uso na construção, exceto azulejos e pisos' },
		{ value: '2330302', description: 'Fabricação de artefatos de cimento para uso na construção' },
		{ value: '1353700', description: 'Fabricação de artefatos de cordoaria' },
		{ value: '1529700', description: 'Fabricação de artefatos de couro não especificados anteriormente' },
		{ value: '2330303', description: 'Fabricação de artefatos de fibrocimento para uso na construção' },
		{ value: '3211602', description: 'Fabricação de artefatos de joalheria e ourivesaria' },
		{ value: '2229399', description: 'Fabricação de artefatos de material plástico para outros usos não especificados anteriormente' },
		{ value: '2229303', description: 'Fabricação de artefatos de material plástico para uso na construção, exceto tubos e acessórios' },
		{ value: '2229301', description: 'Fabricação de artefatos de material plástico para uso pessoal e doméstico' },
		{ value: '2229302', description: 'Fabricação de artefatos de material plástico para usos industriais' },
		{ value: '1623400', description: 'Fabricação de artefatos de tanoaria e de embalagens de madeira' },
		{ value: '1352900', description: 'Fabricação de artefatos de tapeçaria' },
		{
			value: '1629302',
			description: 'Fabricação de artefatos diversos de cortiça, bambu, palha, vime e outros materiais trançados, exceto'
		},
		{ value: '1629301', description: 'Fabricação de artefatos diversos de madeira, exceto móveis' },
		{ value: '3230200', description: 'Fabricação de artefatos para pesca e esporte' },
		{ value: '1351100', description: 'Fabricação de artefatos têxteis para uso doméstico' },
		{ value: '2541100', description: 'Fabricação de artigos de cutelaria' },
		{ value: '2593400', description: 'Fabricação de artigos de metal para uso doméstico e pessoal' },
		{ value: '2542000', description: 'Fabricação de artigos de serralheria, exceto esquadrias' },
		{ value: '2319200', description: 'Fabricação de artigos de vidro' },
		{ value: '1422300', description: 'Fabricação de artigos do vestuário, produzidos em malharias e tricotagens, exceto meias' },
		{ value: '3250707', description: 'Fabricação de artigos ópticos' },
		{ value: '1521100', description: 'Fabricação de artigos para viagem, bolsas e semelhantes de qualquer material' },
		{ value: '2092402', description: 'Fabricação de artigos pirotécnicos' },
		{ value: '2910701', description: 'Fabricação de automóveis, camionetas e utilitários' },
		{ value: '3299005', description: 'Fabricação de aviamentos para costura' },
		{ value: '2342701', description: 'Fabricação de azulejos e pisos' },
		{ value: '2949201', description: 'Fabricação de bancos e estofados para veículos automotores' },
		{ value: '2722801', description: 'Fabricação de baterias e acumuladores para veículos automotores' },
		{ value: '1122404', description: 'Fabricação de bebidas isotônicas' },
		{ value: '3092000', description: 'Fabricação de bicicletas e triciclos não-motorizados, peças e acessórios' },
		{ value: '3212400', description: 'Fabricação de bijuterias e artefatos semelhantes' },
		{ value: '1932200', description: 'Fabricação de biocombustíveis, exceto álcool' },
		{ value: '1092900', description: 'Fabricação de biscoitos e bolachas' },
		{ value: '2930101', description: 'Fabricação de cabines, carrocerias e reboques para caminhões' },
		{
			value: '2930103',
			description: 'Fabricação de cabines, carrocerias e reboques para outros veículos automotores, exceto caminhões e ô'
		},
		{ value: '2392300', description: 'Fabricação de cal e gesso' },
		{ value: '1531901', description: 'Fabricação de calçados de couro' },
		{ value: '1539400', description: 'Fabricação de calçados de materiais não especificados anteriormente' },
		{ value: '1533500', description: 'Fabricação de calçados de material sintético' },
		{ value: '2522500', description: 'Fabricação de caldeiras geradoras de vapor, exceto para aquecimento central e para veículos' },
		{ value: '2920401', description: 'Fabricação de caminhões e ônibus' },
		{ value: '3299002', description: 'Fabricação de canetas, lápis e outros artigos para escritório' },
		{ value: '2930102', description: 'Fabricação de carrocerias para ônibus' },
		{ value: '1722200', description: 'Fabricação de cartolina e papel-cartão' },
		{ value: '1622601', description: 'Fabricação de casas de madeira pré-fabricadas' },
		{ value: '2330304', description: 'Fabricação de casas pré-moldadas de concreto' },
		{ value: '2094100', description: 'Fabricação de catalisadores' },
		{ value: '1710900', description: 'Fabricação de celulose e outras pastas para a fabricação de papel' },
		{ value: '1113502', description: 'Fabricação de cervejas e chopes' },
		{ value: '1122402', description: 'Fabricação de chá mate e outros chás prontos para consumo' },
		{ value: '1733800', description: 'Fabricação de chapas e de embalagens de papelão ondulado' },
		{ value: '2099101', description: 'Fabricação de chapas, filmes, papéis e outros materiais e produtos químicos para fotografia' },
		{ value: '2910702', description: 'Fabricação de chassis com motor para automóveis, camionetas e utilitários' },
		{ value: '1220402', description: 'Fabricação de cigarrilhas e charutos' },
		{ value: '1220401', description: 'Fabricação de cigarros' },
		{ value: '2320600', description: 'Fabricação de cimento' },
		{ value: '2011800', description: 'Fabricação de cloro e álcalis' },
		{ value: '3104700', description: 'Fabricação de colchões' },
		{ value: '2610800', description: 'Fabricação de componentes eletrônicos' },
		{ value: '2814301', description: 'Fabricação de compressores para uso industrial, peças e acessórios' },
		{ value: '2814302', description: 'Fabricação de compressores para uso não-industrial, peças e acessórios' },
		{ value: '1031700', description: 'Fabricação de conservas de frutas' },
		{ value: '1032599', description: 'Fabricação de conservas de legumes e outros vegetais, exceto palmito' },
		{ value: '1032501', description: 'Fabricação de conservas de palmito' },
		{ value: '1020102', description: 'Fabricação de conservas de peixes, crustáceos e moluscos' },
		{ value: '2063100', description: 'Fabricação de cosméticos, produtos de perfumaria e de higiene pessoal' },
		{ value: '2652300', description: 'Fabricação de cronômetros e relógios' },
		{ value: '2051700', description: 'Fabricação de defensivos agrícolas' },
		{ value: '2052500', description: 'Fabricação de desinfestantes domissanitários' },
		{ value: '2033900', description: 'Fabricação de elastômeros' },
		{
			value: '2790201',
			description: 'Fabricação de eletrodos, contatos e outros artigos de carvão e grafita para uso elétrico, eletroímãs'
		},
		{ value: '1732000', description: 'Fabricação de embalagens de cartolina e papel-cartão' },
		{ value: '2222600', description: 'Fabricação de embalagens de material plástico' },
		{ value: '1731100', description: 'Fabricação de embalagens de papel' },
		{ value: '2312500', description: 'Fabricação de embalagens de vidro' },
		{ value: '2591800', description: 'Fabricação de embalagens metálicas' },
		{ value: '2550101', description: 'Fabricação de equipamento bélico pesado, exceto veículos militares de combate' },
		{ value: '2621300', description: 'Fabricação de equipamentos de informática' },
		{ value: '2815102', description: 'Fabricação de equipamentos de transmissão para fins industriais, exceto rolamentos' },
		{ value: '3099700', description: 'Fabricação de equipamentos de transporte não especificados anteriormente' },
		{ value: '3292202', description: 'Fabricação de equipamentos e acessórios para segurança pessoal e profissional' },
		{ value: '2670101', description: 'Fabricação de equipamentos e instrumentos ópticos, peças e acessórios' },
		{ value: '2812700', description: 'Fabricação de equipamentos hidráulicos e pneumáticos, peças e acessórios, exceto válvulas' },
		{ value: '2832100', description: 'Fabricação de equipamentos para irrigação agrícola, peças e acessórios' },
		{ value: '2790202', description: 'Fabricação de equipamentos para sinalização e alarme' },
		{ value: '2631100', description: 'Fabricação de equipamentos transmissores de comunicação, peças e acessórios' },
		{ value: '3291400', description: 'Fabricação de escovas, pincéis e vassouras' },
		{ value: '1095300', description: 'Fabricação de especiarias, molhos, temperos e condimentos' },
		{
			value: '1622602',
			description: 'Fabricação de esquadrias de madeira e de peças de madeira para instalações industriais e comerciais'
		},
		{ value: '2512800', description: 'Fabricação de esquadrias de metal' },
		{ value: '2511000', description: 'Fabricação de estruturas metálicas' },
		{ value: '2330301', description: 'Fabricação de estruturas pré-moldadas de concreto armado, em série e sob encomenda' },
		{ value: '2821602', description: 'Fabricação de estufas e fornos elétricos para fins industriais, peças e acessórios' },
		{ value: '1063500', description: 'Fabricação de farinha de mandioca e derivados' },
		{ value: '1064300', description: 'Fabricação de farinha de milho e derivados, exceto óleos de milho' },
		{ value: '1099603', description: 'Fabricação de fermentos e leveduras' },
		{ value: '2543800', description: 'Fabricação de ferramentas' },
		{ value: '2040100', description: 'Fabricação de fibras artificiais e sintéticas' },
		{ value: '1220403', description: 'Fabricação de filtros para cigarros' },
		{ value: '2733300', description: 'Fabricação de fios, cabos e condutores elétricos isolados' },
		{
			value: '2751100',
			description: 'Fabricação de fogões, refrigeradores e máquinas de lavar e secar para uso doméstico, peças e acessór'
		},
		{ value: '1741901', description: 'Fabricação de formulários contínuos' },
		{
			value: '2821601',
			description: 'Fabricação de fornos industriais, aparelhos e equipamentos não-elétricos para instalações térmicas, '
		},
		{ value: '2092403', description: 'Fabricação de fósforos de segurança' },
		{ value: '1742701', description: 'Fabricação de fraldas descartáveis' },
		{ value: '1093702', description: 'Fabricação de frutas cristalizadas, balas e semelhantes' },
		{ value: '2014200', description: 'Fabricação de gases industriais' },
		{ value: '1099604', description: 'Fabricação de gelo comum' },
		{ value: '2710401', description: 'Fabricação de geradores de corrente contínua e alternada, peças e acessórios' },
		{ value: '3299001', description: 'Fabricação de guarda-chuvas e similares' },
		{ value: '2073800', description: 'Fabricação de impermeabilizantes, solventes e produtos afins' },
		{ value: '3220500', description: 'Fabricação de instrumentos musicais, peças e acessórios' },
		{
			value: '3250701',
			description: 'Fabricação de instrumentos não-eletrônicos e utensílios para uso médico, cirúrgico, odontológico e d'
		},
		{ value: '2012600', description: 'Fabricação de intermediários para fertilizantes' },
		{ value: '2022300', description: 'Fabricação de intermediários para plastificantes, resinas e fibras' },
		{ value: '3240001', description: 'Fabricação de jogos eletrônicos' },
		{ value: '2221800', description: 'Fabricação de laminados planos e tubulares de material plástico' },
		{ value: '2740601', description: 'Fabricação de lâmpadas' },
		{ value: '1052000', description: 'Fabricação de laticínios' },
		{ value: '3299003', description: 'Fabricação de letras, letreiros e placas de qualquer material, exceto luminosos' },
		{ value: '1314600', description: 'Fabricação de linhas para costurar e bordar' },
		{ value: '3031800', description: 'Fabricação de locomotivas, vagões e outros materiais rodantes' },
		{ value: '2740602', description: 'Fabricação de luminárias e outros equipamentos de iluminação' },
		{ value: '1621800', description: 'Fabricação de madeira laminada e de chapas de madeira compensada, prensada e aglomerada' },
		{ value: '1113501', description: 'Fabricação de malte, inclusive malte uísque' },
		{
			value: '2829101',
			description: 'Fabricação de máquinas de escrever, calcular e outros equipamentos não-eletrônicos para escritório, '
		},
		{
			value: '2823200',
			description: 'Fabricação de máquinas e aparelhos de refrigeração e ventilação para uso industrial e comercial, peç'
		},
		{
			value: '2833000',
			description: 'Fabricação de máquinas e equipamentos para a agricultura e pecuária, peças e acessórios, exceto para'
		},
		{ value: '2866600', description: 'Fabricação de máquinas e equipamentos para a indústria do plástico, peças e acessórios' },
		{ value: '2863100', description: 'Fabricação de máquinas e equipamentos para a indústria têxtil, peças e acessórios' },
		{ value: '2851800', description: 'Fabricação de máquinas e equipamentos para a prospecção e extração de petróleo, peças e acessórios' },
		{
			value: '2862300',
			description: 'Fabricação de máquinas e equipamentos para as indústrias de alimentos, bebidas e fumo, peças e acess'
		},
		{
			value: '2865800',
			description: 'Fabricação de máquinas e equipamentos para as indústrias de celulose, papel e papelão e artefatos, p'
		},
		{
			value: '2864000',
			description: 'Fabricação de máquinas e equipamentos para as indústrias do vestuário, do couro e de calçados, peças'
		},
		{ value: '2825900', description: 'Fabricação de máquinas e equipamentos para saneamento básico e ambiental, peças e acessórios' },
		{
			value: '2854200',
			description: 'Fabricação de máquinas e equipamentos para terraplenagem, pavimentação e construção, peças e acessór'
		},
		{
			value: '2869100',
			description: 'Fabricação de máquinas e equipamentos para uso industrial específico não especificados anteriormente'
		},
		{
			value: '2861500',
			description: 'Fabricação de máquinas para a indústria metalúrgica, peças e acessórios, exceto máquinas-ferramenta'
		},
		{
			value: '2822402',
			description: 'Fabricação de máquinas, equipamentos e aparelhos para transporte e elevação de cargas, peças e acess'
		},
		{
			value: '2822401',
			description: 'Fabricação de máquinas, equipamentos e aparelhos para transporte e elevação de pessoas, peças e aces'
		},
		{ value: '2840200', description: 'Fabricação de máquinas-ferramenta, peças e acessórios' },
		{ value: '1043100', description: 'Fabricação de margarina e outras gorduras vegetais e de óleos não-comestíveis de animais' },
		{ value: '1094500', description: 'Fabricação de massas alimentícias' },
		{ value: '3250705', description: 'Fabricação de materiais para medicina e odontologia' },
		{ value: '2945000', description: 'Fabricação de material elétrico e eletrônico para veículos automotores, exceto baterias' },
		{ value: '2732500', description: 'Fabricação de material elétrico para instalações em circuito de consumo' },
		{ value: '2349401', description: 'Fabricação de material sanitário de cerâmica' },
		{ value: '2121101', description: 'Fabricação de medicamentos alopáticos para uso humano' },
		{ value: '2121103', description: 'Fabricação de medicamentos fitoterápicos para uso humano' },
		{ value: '2121102', description: 'Fabricação de medicamentos homeopáticos para uso humano' },
		{ value: '2122000', description: 'Fabricação de medicamentos para uso veterinário' },
		{ value: '1421500', description: 'Fabricação de meias' },
		{ value: '3240003', description: 'Fabricação de mesas de bilhar, de sinuca e acessórios associada à locação' },
		{ value: '3240002', description: 'Fabricação de mesas de bilhar, de sinuca e acessórios não associada à locação' },
		{ value: '2680900', description: 'Fabricação de mídias virgens, magnéticas e ópticas' },
		{ value: '3250702', description: 'Fabricação de mobiliário para uso médico, cirúrgico, odontológico e de laboratório' },
		{ value: '3091101', description: 'Fabricação de motocicletas' },
		{ value: '2811900', description: 'Fabricação de motores e turbinas, peças e acessórios, exceto para aviões e veículos rodoviários' },
		{ value: '2710403', description: 'Fabricação de motores elétricos, peças e acessórios' },
		{ value: '2910703', description: 'Fabricação de motores para automóveis, camionetas e utilitários' },
		{ value: '2920402', description: 'Fabricação de motores para caminhões e ônibus' },
		{ value: '3101200', description: 'Fabricação de móveis com predominância de madeira' },
		{ value: '3102100', description: 'Fabricação de móveis com predominância de metal' },
		{ value: '3103900', description: 'Fabricação de móveis de outros materiais, exceto madeira e metal' },
		{ value: '2513600', description: 'Fabricação de obras de caldeiraria pesada' },
		{ value: '1065102', description: 'Fabricação de óleo de milho em bruto' },
		{ value: '1065103', description: 'Fabricação de óleo de milho refinado' },
		{ value: '1041400', description: 'Fabricação de óleos vegetais em bruto, exceto óleo de milho' },
		{ value: '1042200', description: 'Fabricação de óleos vegetais refinados, exceto óleo de milho' },
		{ value: '1111902', description: 'Fabricação de outras aguardentes e bebidas destiladas' },
		{ value: '1122499', description: 'Fabricação de outras bebidas não-alcoólicas não especificadas anteriormente' },
		{
			value: '2829199',
			description: 'Fabricação de outras máquinas e equipamentos de uso geral não especificados anteriormente, peças e a'
		},
		{
			value: '2852600',
			description: 'Fabricação de outras máquinas e equipamentos para uso na extração mineral, peças e acessórios, excet'
		},
		{ value: '2949299', description: 'Fabricação de outras peças e acessórios para veículos automotores não especificadas anteriormente' },
		{
			value: '2759799',
			description: 'Fabricação de outros aparelhos eletrodomésticos não especificados anteriormente, peças e acessórios'
		},
		{
			value: '2330399',
			description: 'Fabricação de outros artefatos e produtos de concreto, cimento, fibrocimento, gesso e materiais seme'
		},
		{ value: '1622699', description: 'Fabricação de outros artigos de carpintaria para construção' },
		{ value: '3240099', description: 'Fabricação de outros brinquedos e jogos recreativos não especificados anteriormente' },
		{ value: '2790299', description: 'Fabricação de outros equipamentos e aparelhos elétricos não especificados anteriormente' },
		{ value: '1099699', description: 'Fabricação de outros produtos alimentícios não especificados anteriormente' },
		{ value: '2599399', description: 'Fabricação de outros produtos de metal não especificados anteriormente' },
		{ value: '2399199', description: 'Fabricação de outros produtos de minerais não-metálicos não especificados anteriormente' },
		{ value: '1922599', description: 'Fabricação de outros produtos derivados do petróleo, exceto produtos do refino' },
		{ value: '1220499', description: 'Fabricação de outros produtos do fumo, exceto cigarros, cigarrilhas e charutos' },
		{ value: '2019399', description: 'Fabricação de outros produtos químicos inorgânicos não especificados anteriormente' },
		{ value: '2099199', description: 'Fabricação de outros produtos químicos não especificados anteriormente' },
		{ value: '1359600', description: 'Fabricação de outros produtos têxteis não especificados anteriormente' },
		{ value: '3299004', description: 'Fabricação de painéis e letreiros luminosos' },
		{ value: '1721400', description: 'Fabricação de papel' },
		{ value: '1540800', description: 'Fabricação de partes para calçados, de qualquer material' },
		{ value: '3091102', description: 'Fabricação de peças e acessórios para motocicletas' },
		{ value: '2944100', description: 'Fabricação de peças e acessórios para o sistema de direção e suspensão de veículos automotores' },
		{ value: '2943300', description: 'Fabricação de peças e acessórios para o sistema de freios de veículos automotores' },
		{ value: '2941700', description: 'Fabricação de peças e acessórios para o sistema motor de veículos automotores' },
		{ value: '2942500', description: 'Fabricação de peças e acessórios para os sistemas de marcha e transmissão de veículos automotores' },
		{ value: '3032600', description: 'Fabricação de peças e acessórios para veículos ferroviários' },
		{ value: '2622100', description: 'Fabricação de periféricos para equipamentos de informática' },
		{ value: '2721000', description: 'Fabricação de pilhas, baterias e acumuladores elétricos, exceto para veículos automotores' },
		{ value: '2211100', description: 'Fabricação de pneumáticos e de câmaras-de-ar' },
		{ value: '2092401', description: 'Fabricação de pólvoras, explosivos e detonantes' },
		{ value: '1099602', description: 'Fabricação de pós alimentícios' },
		{ value: '2123800', description: 'Fabricação de preparações farmacêuticas' },
		{ value: '1082100', description: 'Fabricação de produtos à base de café' },
		{ value: '2349499', description: 'Fabricação de produtos cerâmicos não-refratários não especificados anteriormente' },
		{ value: '2341900', description: 'Fabricação de produtos cerâmicos refratários' },
		{ value: '1013901', description: 'Fabricação de produtos de carne' },
		{ value: '2062200', description: 'Fabricação de produtos de limpeza e polimento' },
		{ value: '1091102', description: 'Fabricação de produtos de padaria e confeitaria com predominância de produção própria' },
		{ value: '1091101', description: 'Fabricação de produtos de panificação industrial' },
		{
			value: '1742799',
			description: 'Fabricação de produtos de papel para uso doméstico e higiênico-sanitário não especificados anteriorm'
		},
		{
			value: '1741902',
			description: 'Fabricação de produtos de papel, cartolina, papel-cartão e papelão ondulado para uso comercial e de '
		},
		{
			value: '1749400',
			description: 'Fabricação de produtos de pastas celulósicas, papel, cartolina, papel-cartão e papelão ondulado não '
		},
		{ value: '2592601', description: 'Fabricação de produtos de trefilados de metal padronizados' },
		{ value: '2592602', description: 'Fabricação de produtos de trefilados de metal, exceto padronizados' },
		{ value: '1093701', description: 'Fabricação de produtos derivados do cacau e de chocolates' },
		{ value: '3299099', description: 'Fabricação de produtos diversos não especificados anteriormente' },
		{ value: '1061902', description: 'Fabricação de produtos do arroz' },
		{ value: '1921700', description: 'Fabricação de produtos do refino de petróleo' },
		{ value: '2110600', description: 'Fabricação de produtos farmoquímicos' },
		{ value: '1099605', description: 'Fabricação de produtos para infusão (chá, mate, etc.)' },
		{ value: '2021500', description: 'Fabricação de produtos petroquímicos básicos' },
		{ value: '2029100', description: 'Fabricação de produtos químicos orgânicos não especificados anteriormente' },
		{ value: '1122403', description: 'Fabricação de refrescos, xaropes e pós para refrescos, exceto refrescos de frutas' },
		{ value: '1122401', description: 'Fabricação de refrigerantes' },
		{ value: '2032100', description: 'Fabricação de resinas termofixas' },
		{ value: '2031200', description: 'Fabricação de resinas termoplásticas' },
		{ value: '2815101', description: 'Fabricação de rolamentos para fins industriais' },
		{ value: '3292201', description: 'Fabricação de roupas de proteção e segurança e resistentes a fogo' },
		{ value: '2061400', description: 'Fabricação de sabões e detergentes sintéticos' },
		{ value: '1053800', description: 'Fabricação de sorvetes e outros gelados comestíveis' },
		{ value: '1033301', description: 'Fabricação de sucos concentrados de frutas, hortaliças e legumes' },
		{ value: '1033302', description: 'Fabricação de sucos de frutas, hortaliças e legumes, exceto concentrados' },
		{ value: '2521700', description: 'Fabricação de tanques, reservatórios metálicos e caldeiras para aquecimento central' },
		{ value: '1330800', description: 'Fabricação de tecidos de malha' },
		{ value: '1354500', description: 'Fabricação de tecidos especiais, inclusive artefatos' },
		{ value: '1532700', description: 'Fabricação de tênis de qualquer material' },
		{ value: '2072000', description: 'Fabricação de tintas de impressão' },
		{ value: '2071100', description: 'Fabricação de tintas, vernizes, esmaltes e lacas' },
		{
			value: '2710402',
			description: 'Fabricação de transformadores, indutores, conversores, sincronizadores e semelhantes, peças e acessó'
		},
		{ value: '2831300', description: 'Fabricação de tratores agrícolas, peças e acessórios' },
		{ value: '2853400', description: 'Fabricação de tratores, peças e acessórios, exceto agrícolas' },
		{ value: '2223400', description: 'Fabricação de tubos e acessórios de material plástico para uso na construção' },
		{ value: '3042300', description: 'Fabricação de turbinas, motores e outros componentes e peças para aeronaves' },
		{ value: '2813500', description: 'Fabricação de válvulas, registros e dispositivos semelhantes, peças e acessórios' },
		{ value: '3050400', description: 'Fabricação de veículos militares de combate' },
		{ value: '3299006', description: 'Fabricação de velas, inclusive decorativas' },
		{ value: '2311700', description: 'Fabricação de vidro plano e de segurança' },
		{ value: '1099601', description: 'Fabricação de vinagres' },
		{ value: '1112700', description: 'Fabricação de vinho' },
		{ value: '1412603', description: 'Facção de peças do vestuário, exceto roupas íntimas' },
		{ value: '1411802', description: 'Facção de roupas íntimas' },
		{ value: '1413403', description: 'Facção de roupas profissionais' },
		{ value: '1313800', description: 'Fiação de fibras artificiais e sintéticas' },
		{ value: '7420004', description: 'Filmagem de festas e eventos' },
		{ value: '8599601', description: 'Formação de condutores' },
		{ value: '1922501', description: 'Formulação de combustíveis' },
		{ value: '5620104', description: 'Fornecimento de alimentos preparados preponderantemente para consumo domiciliar' },
		{ value: '5620101', description: 'Fornecimento de alimentos preparados preponderantemente para empresas' },
		{ value: '7830200', description: 'Fornecimento e gestão de recursos humanos para terceiros' },
		{ value: '8219901', description: 'Fotocópias' },
		{ value: '1011201', description: 'Frigorífico - abate de bovinos' },
		{ value: '1011204', description: 'Frigorífico - abate de bufalinos' },
		{ value: '1011202', description: 'Frigorífico - abate de eqüinos' },
		{ value: '1011203', description: 'Frigorífico - abate de ovinos e caprinos' },
		{ value: '1012103', description: 'Frigorífico - abate de suínos' },
		{ value: '2451200', description: 'Fundição de ferro e aço' },
		{ value: '2452100', description: 'Fundição de metais não-ferrosos e suas ligas' },
		{ value: '6499903', description: 'Fundo garantidor de crédito' },
		{ value: '6470103', description: 'Fundos de investimento imobiliários' },
		{ value: '6470102', description: 'Fundos de investimento previdenciários' },
		{ value: '6470101', description: 'Fundos de investimento, exceto previdenciários e imobiliários' },
		{ value: '3511501', description: 'Geração de energia elétrica' },
		{ value: '7740300', description: 'Gestão de ativos intangíveis não-financeiros' },
		{ value: '9003500', description: 'Gestão de espaços para artes cênicas, espetáculos e outras atividades artísticas' },
		{ value: '9311500', description: 'Gestão de instalações de esportes' },
		{ value: '3701100', description: 'Gestão de redes de esgoto' },
		{ value: '6822600', description: 'Gestão e administração da propriedade imobiliária' },
		{ value: '9603301', description: 'Gestão e manutenção de cemitérios' },
		{ value: '5211702', description: 'Guarda-móveis' },
		{ value: '6461100', description: 'Holdings de instituições financeiras' },
		{ value: '6462000', description: 'Holdings de instituições não-financeiras' },
		{ value: '121101', description: 'Horticultura, exceto morango' },
		{ value: '5510801', description: 'Hotéis' },
		{ value: '4330401', description: 'Impermeabilização em obras de engenharia civil' },
		{ value: '1811301', description: 'Impressão de jornais' },
		{ value: '1811302', description: 'Impressão de livros, revistas e outras publicações periódicas' },
		{ value: '1812100', description: 'Impressão de material de segurança' },
		{ value: '1813099', description: 'Impressão de material para outros usos' },
		{ value: '1813001', description: 'Impressão de material para uso publicitário' },
		{ value: '8122200', description: 'Imunização e controle de pragas urbanas' },
		{ value: '4110700', description: 'Incorporação de empreendimentos imobiliários' },
		{ value: '4329102', description: 'Instalação de equipamentos para orientação à navegação marítima, fluvial e lacustre' },
		{ value: '3321000', description: 'Instalação de máquinas e equipamentos industriais' },
		{ value: '3329599', description: 'Instalação de outros equipamentos não especificados anteriormente' },
		{ value: '4329101', description: 'Instalação de painéis publicitários' },
		{ value: '4330402', description: 'Instalação de portas, janelas, tetos, divisórias e armários embutidos de qualquer material' },
		{ value: '4322302', description: 'Instalação e manutenção de sistemas centrais de ar condicionado, de ventilação e refrigeração' },
		{ value: '4321500', description: 'Instalação e manutenção elétrica' },
		{ value: '4329103', description: 'Instalação, manutenção e reparação de elevadores, escadas e esteiras rolantes' },
		{ value: '4322303', description: 'Instalações de sistema de prevenção contra incêndio' },
		{ value: '4322301', description: 'Instalações hidráulicas, sanitárias e de gás' },
		{ value: '8711502', description: 'Instituições de longa permanência para idosos' },
		{ value: '8423000', description: 'Justiça' },
		{ value: '8640202', description: 'Laboratórios clínicos' },
		{ value: '8640201', description: 'Laboratórios de anatomia patológica e citológica' },
		{ value: '7420003', description: 'Laboratórios fotográficos' },
		{ value: '5611203', description: 'Lanchonetes, casas de chá, de sucos e similares' },
		{ value: '3211601', description: 'Lapidação de gemas' },
		{ value: '9601701', description: 'Lavanderias' },
		{ value: '8299704', description: 'Leiloeiros independentes' },
		{ value: '8121400', description: 'Limpeza em prédios e em domicílios' },
		{ value: '7719502', description: 'Locação de aeronaves sem tripulação' },
		{ value: '7711000', description: 'Locação de automóveis sem condutor' },
		{ value: '7719501', description: 'Locação de embarcações sem tripulação, exceto para fins recreativos' },
		{ value: '7820500', description: 'Locação de mão-de-obra temporária' },
		{ value: '7719599', description: 'Locação de outros meios de transporte não especificados anteriormente, sem condutor' },
		{ value: '4713001', description: 'Lojas de departamentos ou magazines' },
		{ value: '4713002', description: 'Lojas de variedades, exceto lojas de departamentos ou magazines' },
		{ value: '4713003', description: 'Lojas duty free de aeroportos internacionais' },
		{ value: '6810203', description: 'Loteamento de imóveis próprios' },
		{ value: '3316302', description: 'Manutenção de aeronaves na pista' },
		{ value: '4221905', description: 'Manutenção de estações e redes de telecomunicações' },
		{ value: '4221903', description: 'Manutenção de redes de distribuição de energia elétrica' },
		{ value: '3316301', description: 'Manutenção e reparação de aeronaves, exceto a manutenção na pista' },
		{ value: '3312102', description: 'Manutenção e reparação de aparelhos e instrumentos de medida, teste e controle' },
		{
			value: '3312103',
			description: 'Manutenção e reparação de aparelhos eletromédicos e eletroterapêuticos e equipamentos de irradiação'
		},
		{ value: '3313902', description: 'Manutenção e reparação de baterias e acumuladores elétricos, exceto para veículos' },
		{ value: '3314704', description: 'Manutenção e reparação de compressores' },
		{ value: '3317101', description: 'Manutenção e reparação de embarcações e estruturas flutuantes' },
		{ value: '3317102', description: 'Manutenção e reparação de embarcações para esporte e lazer' },
		{ value: '3314705', description: 'Manutenção e reparação de equipamentos de transmissão para fins industriais' },
		{ value: '3312104', description: 'Manutenção e reparação de equipamentos e instrumentos ópticos' },
		{ value: '3319800', description: 'Manutenção e reparação de equipamentos e produtos não especificados anteriormente' },
		{ value: '3314702', description: 'Manutenção e reparação de equipamentos hidráulicos e pneumáticos, exceto válvulas' },
		{ value: '3313901', description: 'Manutenção e reparação de geradores, transformadores e motores elétricos' },
		{
			value: '3314709',
			description: 'Manutenção e reparação de máquinas de escrever, calcular e de outros equipamentos não-eletrônicos pa'
		},
		{
			value: '3314707',
			description: 'Manutenção e reparação de máquinas e aparelhos de refrigeração e ventilação para uso industrial e co'
		},
		{
			value: '3314721',
			description: 'Manutenção e reparação de máquinas e aparelhos para a indústria de celulose, papel e papelão e artef'
		},
		{ value: '3314722', description: 'Manutenção e reparação de máquinas e aparelhos para a indústria do plástico' },
		{
			value: '3314717',
			description: 'Manutenção e reparação de máquinas e equipamentos de terraplenagem, pavimentação e construção, excet'
		},
		{
			value: '3314720',
			description: 'Manutenção e reparação de máquinas e equipamentos para a indústria têxtil, do vestuário, do couro e '
		},
		{ value: '3314714', description: 'Manutenção e reparação de máquinas e equipamentos para a prospecção e extração de petróleo' },
		{ value: '3314711', description: 'Manutenção e reparação de máquinas e equipamentos para agricultura e pecuária' },
		{ value: '3314719', description: 'Manutenção e reparação de máquinas e equipamentos para as indústrias de alimentos, bebidas e fumo' },
		{ value: '3314710', description: 'Manutenção e reparação de máquinas e equipamentos para uso geral não especificados anteriormente' },
		{
			value: '3314715',
			description: 'Manutenção e reparação de máquinas e equipamentos para uso na extração mineral, exceto na extração d'
		},
		{ value: '3314701', description: 'Manutenção e reparação de máquinas motrizes não-elétricas' },
		{ value: '3314718', description: 'Manutenção e reparação de máquinas para a indústria metalúrgica, exceto máquinas-ferramenta' },
		{ value: '3314706', description: 'Manutenção e reparação de máquinas, aparelhos e equipamentos para instalações térmicas' },
		{
			value: '3313999',
			description: 'Manutenção e reparação de máquinas, aparelhos e materiais elétricos não especificados anteriormente'
		},
		{ value: '3314708', description: 'Manutenção e reparação de máquinas, equipamentos e aparelhos para transporte e elevação de cargas' },
		{ value: '3314713', description: 'Manutenção e reparação de máquinas-ferramenta' },
		{ value: '4543900', description: 'Manutenção e reparação de motocicletas e motonetas' },
		{
			value: '3314799',
			description: 'Manutenção e reparação de outras máquinas e equipamentos para usos industriais não especificados ant'
		},
		{ value: '3311200', description: 'Manutenção e reparação de tanques, reservatórios metálicos e caldeiras, exceto para veículos' },
		{ value: '3314712', description: 'Manutenção e reparação de tratores agrícolas' },
		{ value: '3314716', description: 'Manutenção e reparação de tratores, exceto agrícolas' },
		{ value: '3314703', description: 'Manutenção e reparação de válvulas industriais' },
		{ value: '3315500', description: 'Manutenção e reparação de veículos ferroviários' },
		{ value: '7319003', description: 'Marketing direto' },
		{ value: '1011205', description: 'Matadouro - abate de reses sob contrato, exceto abate de suínos' },
		{ value: '1012104', description: 'Matadouro - abate de suínos sob contrato' },
		{ value: '8299701', description: 'Medição de consumo de energia elétrica, gás e água' },
		{ value: '2449199', description: 'Metalurgia de outros metais não-ferrosos e suas ligas não especificados anteriormente' },
		{ value: '2443100', description: 'Metalurgia do cobre' },
		{ value: '2532202', description: 'Metalurgia do pó' },
		{ value: '2442300', description: 'Metalurgia dos metais preciosos' },
		{ value: '1062700', description: 'Moagem de trigo e fabricação de derivados' },
		{ value: '1069400', description: 'Moagem e fabricação de produtos de origem vegetal não especificados anteriormente' },
		{ value: '4292801', description: 'Montagem de estruturas metálicas' },
		{ value: '4399102', description: 'Montagem e desmontagem de andaimes e outras estruturas temporárias' },
		{
			value: '4329104',
			description: 'Montagem e instalação de sistemas e equipamentos de iluminação e sinalização em vias públicas, porto'
		},
		{ value: '5510803', description: 'Motéis' },
		{ value: '5030101', description: 'Navegação de apoio marítimo' },
		{ value: '5030102', description: 'Navegação de apoio portuário' },
		{ value: '4330403', description: 'Obras de acabamento em gesso e estuque' },
		{ value: '4399103', description: 'Obras de alvenaria' },
		{ value: '4391600', description: 'Obras de fundações' },
		{ value: '4222702', description: 'Obras de irrigação' },
		{ value: '4292802', description: 'Obras de montagem industrial' },
		{ value: '4313400', description: 'Obras de terraplenagem' },
		{ value: '4213800', description: 'Obras de urbanização - ruas, praças e calçadas' },
		{ value: '4291000', description: 'Obras portuárias, marítimas e fluviais' },
		{ value: '5240101', description: 'Operação dos aeroportos e campos de aterrissagem' },
		{ value: '5231102', description: 'Operações de terminais' },
		{ value: '5250805', description: 'Operador de transporte multimodal - OTM' },
		{ value: '6619305', description: 'Operadoras de cartões de débito' },
		{ value: '6141800', description: 'Operadoras de televisão por assinatura por cabo' },
		{ value: '6142600', description: 'Operadoras de televisão por assinatura por microondas' },
		{ value: '6143400', description: 'Operadoras de televisão por assinatura por satélite' },
		{ value: '7912100', description: 'Operadores turísticos' },
		{ value: '8730101', description: 'Orfanatos' },
		{ value: '9900800', description: 'Organismos internacionais e outras instituições extraterritoriais' },
		{
			value: '4929904',
			description: 'Organização de excursões em veículos rodoviários próprios, intermunicipal, interestadual e internaci'
		},
		{ value: '4929903', description: 'Organização de excursões em veículos rodoviários próprios, municipal' },
		{ value: '5250804', description: 'Organização logística do transporte de carga' },
		{ value: '6619399', description: 'Outras atividades auxiliares dos serviços financeiros não especificadas anteriormente' },
		{ value: '5229099', description: 'Outras atividades auxiliares dos transportes terrestres não especificadas anteriormente' },
		{ value: '8690999', description: 'Outras atividades de atenção à saúde humana não especificadas anteriormente' },
		{ value: '8599699', description: 'Outras atividades de ensino não especificadas anteriormente' },
		{ value: '6399200', description: 'Outras atividades de prestação de serviços de informação não especificadas anteriormente' },
		{ value: '7319099', description: 'Outras atividades de publicidade não especificadas anteriormente' },
		{ value: '9329899', description: 'Outras atividades de recreação e lazer não especificadas anteriormente' },
		{ value: '6499999', description: 'Outras atividades de serviços financeiros não especificadas anteriormente' },
		{ value: '9609299', description: 'Outras atividades de serviços pessoais não especificadas anteriormente' },
		{ value: '8299799', description: 'Outras atividades de serviços prestados principalmente às empresas não especificadas anteriormente' },
		{ value: '6190699', description: 'Outras atividades de telecomunicações não especificadas anteriormente' },
		{ value: '9319199', description: 'Outras atividades esportivas não especificadas anteriormente' },
		{ value: '7490199', description: 'Outras atividades profissionais, científicas e técnicas não especificadas anteriormente' },
		{ value: '6438799', description: 'Outras instituições de intermediação não-monetária não especificadas anteriormente' },
		{ value: '4330499', description: 'Outras obras de acabamento da construção' },
		{ value: '4299599', description: 'Outras obras de engenharia civil não especificadas anteriormente' },
		{ value: '4329199', description: 'Outras obras de instalações em construções não especificadas anteriormente' },
		{ value: '6463800', description: 'Outras sociedades de participação, exceto holdings' },
		{ value: '5590699', description: 'Outros alojamentos não especificados anteriormente' },
		{
			value: '4618499',
			description: 'Outros representantes comerciais e agentes do comércio especializado em produtos não especificados a'
		},
		{ value: '1340599', description: 'Outros serviços de acabamento em fios, tecidos, artefatos têxteis e peças do vestuário' },
		{ value: '5112999', description: 'Outros serviços de transporte aéreo de passageiros não-regular' },
		{ value: '5099899', description: 'Outros transportes aquaviários não especificados anteriormente' },
		{ value: '4929999', description: 'Outros transportes rodoviários de passageiros não especificados anteriormente' },
		{ value: '4721102', description: 'Padaria e confeitaria com predominância de revenda' },
		{ value: '9321200', description: 'Parques de diversão e parques temáticos' },
		{ value: '4722902', description: 'Peixaria' },
		{ value: '710302', description: 'Pelotização, sinterização e outros beneficiamentos de minério de ferro' },
		{ value: '5590603', description: 'Pensões (alojamento)' },
		{ value: '4399105', description: 'Perfuração e construção de poços de água' },
		{ value: '4312600', description: 'Perfurações e sondagens' },
		{ value: '6621501', description: 'Peritos e avaliadores de seguros' },
		{ value: '312402', description: 'Pesca de crustáceos e moluscos em água doce' },
		{ value: '311602', description: 'Pesca de crustáceos e moluscos em água salgada' },
		{ value: '312401', description: 'Pesca de peixes em água doce' },
		{ value: '311601', description: 'Pesca de peixes em água salgada' },
		{ value: '7210000', description: 'Pesquisa e desenvolvimento experimental em ciências físicas e naturais' },
		{ value: '7220700', description: 'Pesquisa e desenvolvimento experimental em ciências sociais e humanas' },
		{ value: '7320300', description: 'Pesquisas de mercado e de opinião pública' },
		{ value: '4211102', description: 'Pintura para sinalização em pistas rodoviárias e aeroportos' },
		{ value: '6511102', description: 'Planos de auxílio-funeral' },
		{ value: '6550200', description: 'Planos de saúde' },
		{ value: '6319400', description: 'Portais, provedores de conteúdo e outros serviços de informação na internet' },
		{ value: '4311802', description: 'Preparação de canteiro e limpeza de terreno' },
		{
			value: '8219999',
			description: 'Preparação de documentos e serviços especializados de apoio administrativo não especificados anterio'
		},
		{ value: '2330305', description: 'Preparação de massa de concreto e argamassa para construção' },
		{ value: '1013902', description: 'Preparação de subprodutos do abate' },
		{ value: '1051100', description: 'Preparação do leite' },
		{ value: '1311100', description: 'Preparação e fiação de fibras de algodão' },
		{ value: '1312000', description: 'Preparação e fiação de fibras têxteis naturais, exceto algodão' },
		{ value: '1020101', description: 'Preservação de peixes, crustáceos e moluscos' },
		{ value: '6542100', description: 'Previdência complementar aberta' },
		{ value: '6541300', description: 'Previdência complementar fechada' },
		{ value: '1210700', description: 'Processamento industrial do fumo' },
		{ value: '2441501', description: 'Produção de alumínio e suas ligas em formas primárias' },
		{ value: '2424501', description: 'Produção de arames de aço' },
		{ value: '2532201', description: 'Produção de artefatos estampados de metal' },
		{ value: '220902', description: 'Produção de carvão vegetal - florestas nativas' },
		{ value: '210108', description: 'Produção de carvão vegetal - florestas plantadas' },
		{ value: '210109', description: 'Produção de casca de acácia-negra - florestas plantadas' },
		{ value: '9001904', description: 'Produção de espetáculos circenses, de marionetes e similares' },
		{ value: '9001903', description: 'Produção de espetáculos de dança' },
		{ value: '9001905', description: 'Produção de espetáculos de rodeios, vaquejadas e similares' },
		{ value: '2411300', description: 'Produção de ferro-gusa' },
		{ value: '2412100', description: 'Produção de ferroligas' },
		{ value: '5911102', description: 'Produção de filmes para publicidade' },
		{ value: '2531401', description: 'Produção de forjados de aço' },
		{ value: '2531402', description: 'Produção de forjados de metais não-ferrosos e suas ligas' },
		{ value: '3520401', description: 'Produção de gás; processamento de gás natural' },
		{ value: '2441502', description: 'Produção de laminados de alumínio' },
		{ value: '2449102', description: 'Produção de laminados de zinco' },
		{ value: '2423702', description: 'Produção de laminados longos de aço, exceto tubos' },
		{ value: '2422901', description: 'Produção de laminados planos de aço ao carbono, revestidos ou não' },
		{ value: '2422902', description: 'Produção de laminados planos de aços especiais' },
		{ value: '142300', description: 'Produção de mudas e outras formas de propagação vegetal, certificadas' },
		{ value: '2439300', description: 'Produção de outros tubos de ferro e aço' },
		{ value: '155505', description: 'Produção de ovos' },
		{ value: '155502', description: 'Produção de pintos de um dia' },
		{ value: '210199', description: 'Produção de produtos não-madeireiros não especificados anteriormente em florestas plantadas' },
		{ value: '2424502', description: 'Produção de relaminados, trefilados e perfilados de aço, exceto arames' },
		{ value: '141502', description: 'Produção de sementes certificadas de forrageiras para formação de pasto' },
		{ value: '141501', description: 'Produção de sementes certificadas, exceto de forrageiras para pasto' },
		{ value: '2421100', description: 'Produção de semi-acabados de aço' },
		{ value: '2449103', description: 'Produção de soldas e ânodos para galvanoplastia' },
		{ value: '2431800', description: 'Produção de tubos de aço com costura' },
		{ value: '2423701', description: 'Produção de tubos de aço sem costura' },
		{ value: '2449101', description: 'Produção de zinco em formas primárias' },
		{ value: '3530100', description: 'Produção e distribuição de vapor, água quente e ar condicionado' },
		{ value: '9319101', description: 'Produção e promoção de eventos esportivos' },
		{ value: '9001902', description: 'Produção musical' },
		{ value: '9001901', description: 'Produção teatral' },
		{ value: '6022501', description: 'Programadoras' },
		{ value: '7319002', description: 'Promoção de vendas' },
		{ value: '6190601', description: 'Provedores de acesso às redes de comunicações' },
		{ value: '6190602', description: 'Provedores de voz sobre protocolo internet - VOIP' },
		{ value: '322105', description: 'Ranicultura' },
		{ value: '4751202', description: 'Recarga de cartuchos para equipamentos de informática' },
		{ value: '2722802', description: 'Recondicionamento de baterias e acumuladores para veículos automotores' },
		{ value: '2950600', description: 'Recondicionamento e recuperação de motores para veículos automotores' },
		{ value: '3831999', description: 'Recuperação de materiais metálicos, exceto alumínio' },
		{ value: '3839499', description: 'Recuperação de materiais não especificados anteriormente' },
		{ value: '3832700', description: 'Recuperação de materiais plásticos' },
		{ value: '3831901', description: 'Recuperação de sucatas de alumínio' },
		{ value: '892403', description: 'Refino e outros tratamentos do sal' },
		{ value: '2212900', description: 'Reforma de pneumáticos usados' },
		{ value: '8412400', description: 'Regulação das atividades de saúde, educação, serviços culturais e outros serviços sociais' },
		{ value: '8413200', description: 'Regulação das atividades econômicas' },
		{ value: '8421300', description: 'Relações exteriores' },
		{ value: '9529105', description: 'Reparação de artigos do mobiliário' },
		{ value: '9529104', description: 'Reparação de bicicletas, triciclos e outros veículos não-motorizados' },
		{ value: '9529101', description: 'Reparação de calçados, bolsas e artigos de viagem' },
		{ value: '9529106', description: 'Reparação de jóias' },
		{ value: '9529103', description: 'Reparação de relógios' },
		{ value: '9511800', description: 'Reparação e manutenção de computadores e de equipamentos periféricos' },
		{ value: '9512600', description: 'Reparação e manutenção de equipamentos de comunicação' },
		{ value: '9521500', description: 'Reparação e manutenção de equipamentos eletroeletrônicos de uso pessoal e doméstico' },
		{
			value: '9529199',
			description: 'Reparação e manutenção de outros objetos e equipamentos pessoais e domésticos não especificados ante'
		},
		{ value: '6619303', description: 'Representações de bancos estrangeiros' },
		{
			value: '4612500',
			description: 'Representantes comerciais e agentes do comércio de combustíveis, minerais, produtos siderúrgicos e q'
		},
		{
			value: '4615000',
			description: 'Representantes comerciais e agentes do comércio de eletrodomésticos, móveis e artigos de uso domésti'
		},
		{
			value: '4618402',
			description: 'Representantes comerciais e agentes do comércio de instrumentos e materiais odonto-médico-hospitalar'
		},
		{ value: '4618403', description: 'Representantes comerciais e agentes do comércio de jornais, revistas e outras publicações' },
		{ value: '4613300', description: 'Representantes comerciais e agentes do comércio de madeira, material de construção e ferragens' },
		{ value: '4614100', description: 'Representantes comerciais e agentes do comércio de máquinas, equipamentos, embarcações e aeronaves' },
		{ value: '4611700', description: 'Representantes comerciais e agentes do comércio de matérias-primas agrícolas e animais vivos' },
		{
			value: '4618401',
			description: 'Representantes comerciais e agentes do comércio de medicamentos, cosméticos e produtos de perfumaria'
		},
		{ value: '4619200', description: 'Representantes comerciais e agentes do comércio de mercadorias em geral não especializado' },
		{ value: '4542101', description: 'Representantes comerciais e agentes do comércio de motocicletas e motonetas, peças e acessórios' },
		{
			value: '4530706',
			description: 'Representantes comerciais e agentes do comércio de peças e acessórios novos e usados para veículos a'
		},
		{ value: '4617600', description: 'Representantes comerciais e agentes do comércio de produtos alimentícios, bebidas e fumo' },
		{
			value: '4616800',
			description: 'Representantes comerciais e agentes do comércio de têxteis, vestuário, calçados e artigos de viagem'
		},
		{ value: '4512901', description: 'Representantes comerciais e agentes do comércio de veículos automotores' },
		{ value: '1830003', description: 'Reprodução de software em qualquer suporte' },
		{ value: '1830001', description: 'Reprodução de som em qualquer suporte' },
		{ value: '1830002', description: 'Reprodução de vídeo em qualquer suporte' },
		{ value: '1922502', description: 'Rerrefino de óleos lubrificantes' },
		{ value: '6530800', description: 'Resseguros' },
		{ value: '9002702', description: 'Restauração de obras de arte' },
		{ value: '9102302', description: 'Restauração e conservação de lugares e prédios históricos' },
		{ value: '5611201', description: 'Restaurantes e similares' },
		{ value: '8299707', description: 'Salas de acesso à internet' },
		{ value: '6492100', description: 'Securitização de créditos' },
		{ value: '8424800', description: 'Segurança e ordem pública' },
		{ value: '8430200', description: 'Seguridade social obrigatória' },
		{ value: '6511101', description: 'Seguros de vida' },
		{ value: '6512000', description: 'Seguros não-vida' },
		{ value: '6520100', description: 'Seguros-saúde' },
		{ value: '7810800', description: 'Seleção e agenciamento de mão-de-obra' },
		{ value: '1610201', description: 'Serrarias com desdobramento de madeira' },
		{ value: '1610202', description: 'Serrarias sem desdobramento de madeira' },
		{ value: '2599302', description: 'Serviço de corte e dobra de metais' },
		{ value: '162801', description: 'Serviço de inseminação artificial em animais' },
		{ value: '162803', description: 'Serviço de manejo de animais' },
		{ value: '161002', description: 'Serviço de poda de árvores para lavouras' },
		{ value: '161003', description: 'Serviço de preparação de terreno, cultivo e colheita' },
		{ value: '159899', description: 'Serviço de pulverização e controle de pragas agrícolas' },
		{ value: '4923001', description: 'Serviço de táxi' },
		{ value: '5112901', description: 'Serviço de táxi aéreo e locação de aeronaves com tripulação' },
		{ value: '162802', description: 'Serviço de tosquiamento de ovinos' },
		{ value: '4923002', description: 'Serviço de transporte de passageiros - locação de automóveis com motorista' },
		{ value: '6120502', description: 'Serviço móvel especializado - SME' },
		{ value: '6911701', description: 'Serviços advocatícios' },
		{ value: '5612100', description: 'Serviços ambulantes de alimentação' },
		{ value: '8211300', description: 'Serviços combinados de escritório e apoio administrativo' },
		{ value: '8111700', description: 'Serviços combinados para apoio a edifícios, exceto condomínios prediais' },
		{ value: '1822900', description: 'Serviços de acabamentos gráficos' },
		{ value: '1822999', description: 'Serviços de acabamentos gráficos, exceto encadernação e plastificação' },
		{ value: '8011102', description: 'Serviços de adestramento de cães de guarda' },
		{ value: '7490103', description: 'Serviços de agronomia e de consultoria às atividades agrícolas e pecuárias' },
		{ value: '5620102', description: 'Serviços de alimentação para eventos e recepções - bufê' },
		{ value: '4520004', description: 'Serviços de alinhamento e balanceamento de veículos automotores' },
		{ value: '5229001', description: 'Serviços de apoio ao transporte por táxi, inclusive centrais de chamada' },
		{ value: '7111100', description: 'Serviços de arquitetura' },
		{ value: '8800600', description: 'Serviços de assistência social sem alojamento' },
		{ value: '8640214', description: 'Serviços de bancos de células e tecidos humanos' },
		{ value: '4520006', description: 'Serviços de borracharia para veículos automotores' },
		{ value: '4520008', description: 'Serviços de capotaria' },
		{ value: '7119701', description: 'Serviços de cartografia, topografia e geodésia' },
		{ value: '6110803', description: 'Serviços de comunicação multimídia - SCM' },
		{ value: '2599301', description: 'Serviços de confecção de armações metálicas para a construção' },
		{ value: '9603302', description: 'Serviços de cremação' },
		{ value: '7119703', description: 'Serviços de desenho técnico relacionados à arquitetura e engenharia' },
		{ value: '8640205', description: 'Serviços de diagnóstico por imagem com uso de radiação ionizante, exceto tomografia' },
		{ value: '8640207', description: 'Serviços de diagnóstico por imagem sem uso de radiação ionizante, exceto ressonância magnética' },
		{ value: '8640209', description: 'Serviços de diagnóstico por métodos ópticos - endoscopia e outros exames análogos' },
		{ value: '8640208', description: 'Serviços de diagnóstico por registro gráfico - ECG, EEG e outros exames análogos' },
		{ value: '8640203', description: 'Serviços de diálise e nefrologia' },
		{ value: '5912001', description: 'Serviços de dublagem' },
		{ value: '1822901', description: 'Serviços de encadernação e plastificação' },
		{ value: '7112000', description: 'Serviços de engenharia' },
		{ value: '5320202', description: 'Serviços de entrega rápida' },
		{ value: '9603304', description: 'Serviços de funerárias' },
		{ value: '8299703', description: 'Serviços de gravação de carimbos, exceto confecção' },
		{ value: '8640212', description: 'Serviços de hemoterapia' },
		{ value: '4520007', description: 'Serviços de instalação, manutenção e reparação de acessórios para veículos automotores' },
		{ value: '3250709', description: 'Serviços de laboratórios ópticos' },
		{ value: '4520002', description: 'Serviços de lanternagem ou funilaria e pintura de veículos automotores' },
		{ value: '4520005', description: 'Serviços de lavagem, lubrificação e polimento de veículos automotores' },
		{ value: '8299705', description: 'Serviços de levantamento de fundos sob contrato' },
		{ value: '6619301', description: 'Serviços de liquidação e custódia' },
		{ value: '8640213', description: 'Serviços de litotripsia' },
		{ value: '5320201', description: 'Serviços de malote não realizados pelo Correio Nacional' },
		{ value: '4520003', description: 'Serviços de manutenção e reparação elétrica de veículos automotores' },
		{ value: '4520001', description: 'Serviços de manutenção e reparação mecânica de veículos automotores' },
		{ value: '7420005', description: 'Serviços de microfilmagem' },
		{ value: '5912002', description: 'Serviços de mixagem sonora em produção audiovisual' },
		{ value: '3329501', description: 'Serviços de montagem de móveis de qualquer material' },
		{
			value: '4399104',
			description: 'Serviços de operação e fornecimento de equipamentos para transporte e elevação de cargas e pessoas p'
		},
		{ value: '8230001', description: 'Serviços de organização de feiras, congressos, exposições e festas' },
		{ value: '7119704', description: 'Serviços de perícia técnica relacionados à segurança do trabalho' },
		{ value: '4330404', description: 'Serviços de pintura de edifícios em geral' },
		{ value: '1821100', description: 'Serviços de pré-impressão' },
		{ value: '4319300', description: 'Serviços de preparação do terreno não especificados anteriormente' },
		{ value: '3250706', description: 'Serviços de prótese dentária' },
		{ value: '8640210', description: 'Serviços de quimioterapia' },
		{ value: '8640211', description: 'Serviços de radioterapia' },
		{ value: '5229002', description: 'Serviços de reboque de veículos' },
		{ value: '6110802', description: 'Serviços de redes de transporte de telecomunicações - SRTT' },
		{ value: '8622400', description: 'Serviços de remoção de pacientes, exceto os serviços móveis de atendimento a urgências' },
		{ value: '7990200', description: 'Serviços de reservas e outros serviços de turismo não especificados anteriormente' },
		{ value: '8640206', description: 'Serviços de ressonância magnética' },
		{ value: '9603303', description: 'Serviços de sepultamento' },
		{ value: '9603305', description: 'Serviços de somatoconservação' },
		{ value: '9609206', description: 'Serviços de tatuagem e colocação de piercing' },
		{ value: '6110899', description: 'Serviços de telecomunicações por fio não especificados anteriormente' },
		{ value: '6120599', description: 'Serviços de telecomunicações sem fio não especificados anteriormente' },
		{ value: '6110801', description: 'Serviços de telefonia fixa comutada - STFC' },
		{ value: '8640204', description: 'Serviços de tomografia' },
		{ value: '7490101', description: 'Serviços de tradução, interpretação e similares' },
		{ value: '2539002', description: 'Serviços de tratamento e revestimento em metais' },
		{ value: '2539001', description: 'Serviços de usinagem, tornearia e solda' },
		{ value: '8630506', description: 'Serviços de vacinação e imunização humana' },
		{ value: '9700500', description: 'Serviços domésticos' },
		{ value: '4399199', description: 'Serviços especializados para construção não especificados anteriormente' },
		{ value: '8621602', description: 'Serviços móveis de atendimento a urgências, exceto por UTI móvel' },
		{ value: '6450600', description: 'Sociedades de capitalização' },
		{ value: '6437900', description: 'Sociedades de crédito ao microempreendedor' },
		{ value: '6435201', description: 'Sociedades de crédito imobiliário' },
		{ value: '6436100', description: 'Sociedades de crédito, financiamento e investimento - financeiras' },
		{ value: '6491300', description: 'Sociedades de fomento mercantil - factoring' },
		{ value: '6499902', description: 'Sociedades de investimento' },
		{ value: '6209100', description: 'Suporte técnico, manutenção e outros serviços em tecnologia da informação' },
		{ value: '4729601', description: 'Tabacaria' },
		{ value: '1321900', description: 'Tecelagem de fios de algodão' },
		{ value: '1323500', description: 'Tecelagem de fios de fibras artificiais e sintéticas' },
		{ value: '1322700', description: 'Tecelagem de fios de fibras têxteis naturais, exceto algodão' },
		{ value: '6130200', description: 'Telecomunicações por satélite' },
		{ value: '6120501', description: 'Telefonia móvel celular' },
		{ value: '5222200', description: 'Terminais rodoviários e ferroviários' },
		{ value: '7120100', description: 'Testes e análises técnicas' },
		{ value: '9601702', description: 'Tinturarias' },
		{ value: '9601703', description: 'Toalheiros' },
		{ value: '1081302', description: 'Torrefação e moagem de café' },
		{ value: '3512300', description: 'Transmissão de energia elétrica' },
		{ value: '5120000', description: 'Transporte aéreo de carga' },
		{ value: '5111100', description: 'Transporte aéreo de passageiros regular' },
		{ value: '5099801', description: 'Transporte aquaviário para passeios turísticos' },
		{ value: '4940000', description: 'Transporte dutoviário' },
		{ value: '4924800', description: 'Transporte escolar' },
		{ value: '5130700', description: 'Transporte espacial' },
		{ value: '4911600', description: 'Transporte ferroviário de carga' },
		{ value: '4912401', description: 'Transporte ferroviário de passageiros intermunicipal e interestadual' },
		{ value: '4912402', description: 'Transporte ferroviário de passageiros municipal e em região metropolitana' },
		{ value: '5011401', description: 'Transporte marítimo de cabotagem - Carga' },
		{ value: '5011402', description: 'Transporte marítimo de cabotagem - passageiros' },
		{ value: '5012201', description: 'Transporte marítimo de longo curso - Carga' },
		{ value: '5012202', description: 'Transporte marítimo de longo curso - Passageiros' },
		{ value: '4912403', description: 'Transporte metroviário' },
		{ value: '5091202', description: 'Transporte por navegação de travessia, intermunicipal' },
		{ value: '5091201', description: 'Transporte por navegação de travessia, municipal' },
		{
			value: '5021102',
			description: 'Transporte por navegação interior de carga, intermunicipal, interestadual e internacional, exceto tr'
		},
		{ value: '5021101', description: 'Transporte por navegação interior de carga, municipal, exceto travessia' },
		{
			value: '5022002',
			description: 'Transporte por navegação interior de passageiros em linhas regulares, intermunicipal, interestadual '
		},
		{ value: '5022001', description: 'Transporte por navegação interior de passageiros em linhas regulares, municipal, exceto travessia' },
		{ value: '4922102', description: 'Transporte rodoviário coletivo de passageiros, com itinerário fixo, interestadual' },
		{
			value: '4921302',
			description: 'Transporte rodoviário coletivo de passageiros, com itinerário fixo, intermunicipal em região metropo'
		},
		{
			value: '4922101',
			description: 'Transporte rodoviário coletivo de passageiros, com itinerário fixo, intermunicipal, exceto em região'
		},
		{ value: '4922103', description: 'Transporte rodoviário coletivo de passageiros, com itinerário fixo, internacional' },
		{ value: '4921301', description: 'Transporte rodoviário coletivo de passageiros, com itinerário fixo, municipal' },
		{
			value: '4929902',
			description: 'Transporte rodoviário coletivo de passageiros, sob regime de fretamento, intermunicipal, interestadu'
		},
		{ value: '4929901', description: 'Transporte rodoviário coletivo de passageiros, sob regime de fretamento, municipal' },
		{
			value: '4930202',
			description: 'Transporte rodoviário de carga, exceto produtos perigosos e mudanças, intermunicipal, interestadual '
		},
		{ value: '4930201', description: 'Transporte rodoviário de carga, exceto produtos perigosos e mudanças, municipal' },
		{ value: '4930204', description: 'Transporte rodoviário de mudanças' },
		{ value: '4930203', description: 'Transporte rodoviário de produtos perigosos' },
		{ value: '6311900', description: 'Tratamento de dados, provedores de serviços de aplicação e serviços de hospedagem na internet' },
		{ value: '3821100', description: 'Tratamento e disposição de resíduos não-perigosos' },
		{ value: '3822000', description: 'Tratamento e disposição de resíduos perigosos' },
		{ value: '4329105', description: 'Tratamentos térmicos, acústicos ou de vibração' },
		{ value: '8599604', description: 'Treinamento em desenvolvimento profissional e gerencial' },
		{ value: '8599603', description: 'Treinamento em informática' },
		{ value: '4950700', description: 'Trens turísticos, teleféricos e similares' },
		{ value: '3839401', description: 'Usinas de compostagem' },
		{ value: '8621601', description: 'UTI móvel' }
	]

	readonly PROFISSAO = [
		{ value: 'ACOUGUEIRO', description: 'ACOUGUEIRO' },
		{ value: 'ADMINISTRADOR', description: 'ADMINISTRADOR' },
		{ value: 'ADMINISTRADOR DE BANCO DE DADOS', description: 'ADMINISTRADOR DE BANCO DE DADOS' },
		{ value: 'ADMINISTRADOR DE REDES', description: 'ADMINISTRADOR DE REDES' },
		{ value: 'ADVOGADO', description: 'ADVOGADO' },
		{ value: 'AEROVIARIO/EMPREGADO DE AEROPORTO', description: 'AEROVIARIO/EMPREGADO DE AEROPORTO' },
		{ value: 'AFIADOR', description: 'AFIADOR' },
		{ value: 'AGENCIADOR DE PROPAGANDA', description: 'AGENCIADOR DE PROPAGANDA' },
		{ value: 'AGENCIADOR SERV. (CARGAS, TRANSPORTES)', description: 'AGENCIADOR SERV. (CARGAS, TRANSPORTES)' },
		{ value: 'AGENTE ADMINISTRATIVO', description: 'AGENTE ADMINISTRATIVO' },
		{ value: 'AGENTE DE COMPRA E VENDA', description: 'AGENTE DE COMPRA E VENDA' },
		{ value: 'AGENTE DE SERVICOS FUNERARIOS', description: 'AGENTE DE SERVICOS FUNERARIOS' },
		{ value: 'AGENTE DE VIAGEM', description: 'AGENTE DE VIAGEM' },
		{ value: 'AGRONOMO', description: 'AGRONOMO' },
		{ value: 'AJUDANTE GERAL', description: 'AJUDANTE GERAL' },
		{ value: 'AJUSTADOR, RETIFICADOR', description: 'AJUSTADOR, RETIFICADOR' },
		{ value: 'ALFAIATE', description: 'ALFAIATE' },
		{ value: 'AN. CARGOS, RH, RECURSOS HUMANOS, ETC', description: 'AN. CARGOS, RH, RECURSOS HUMANOS, ETC' },
		{ value: 'AN. CRED.,COBR.,CAD.,GARANT., INF., ETC', description: 'AN. CRED.,COBR.,CAD.,GARANT., INF., ETC' },
		{ value: 'AN. CUSTOS, PROJ., SERV., ECONOMIA, ETC', description: 'AN. CUSTOS, PROJ., SERV., ECONOMIA, ETC' },
		{ value: 'AN. PRODUCAO, CRONOALISTA', description: 'AN. PRODUCAO, CRONOALISTA' },
		{ value: 'ANALISTA DE SISTEMAS', description: 'ANALISTA DE SISTEMAS' },
		{ value: 'APOSENTADO (EXCETO FUNCIONARIO PUBLICO)', description: 'APOSENTADO (EXCETO FUNCIONARIO PUBLICO)' },
		{ value: 'ARMADOR DE FERRAGENS', description: 'ARMADOR DE FERRAGENS' },
		{ value: 'ARMEIRO', description: 'ARMEIRO' },
		{ value: 'ARQUEOLOGO, MUSEOLOGO E ASS.', description: 'ARQUEOLOGO, MUSEOLOGO E ASS.' },
		{ value: 'ARQUITETO', description: 'ARQUITETO' },
		{ value: 'ARQUIVISTA', description: 'ARQUIVISTA' },
		{ value: 'ARTESAO', description: 'ARTESAO' },
		{ value: 'ARTISTA PLASTICO', description: 'ARTISTA PLASTICO' },
		{ value: 'ASCENSORISTA', description: 'ASCENSORISTA' },
		{ value: 'ASSISTENTE SOCIAL', description: 'ASSISTENTE SOCIAL' },
		{ value: 'ASTRONOMO', description: 'ASTRONOMO' },
		{ value: 'ATLETA PROFISSIONAL', description: 'ATLETA PROFISSIONAL' },
		{ value: 'ATOR', description: 'ATOR' },
		{ value: 'ATUARIO', description: 'ATUARIO' },
		{ value: 'AUDITOR PUBLICO', description: 'AUDITOR PUBLICO' },
		{ value: 'AUTONOMOS', description: 'AUTONOMOS' },
		{ value: 'AUX. COZINHA, COSTURA,LIMPEZA,COPA, ETC', description: 'AUX. COZINHA, COSTURA,LIMPEZA,COPA, ETC' },
		{ value: 'AUX. DE SERVICOS GERAIS', description: 'AUX. DE SERVICOS GERAIS' },
		{ value: 'AUXILIAR DE ESCRITORIO E ASS.', description: 'AUXILIAR DE ESCRITORIO E ASS.' },
		{ value: 'AUXILIAR DE LABORATORIO', description: 'AUXILIAR DE LABORATORIO' },
		{ value: 'AVALIADOR', description: 'AVALIADOR' },
		{ value: 'AZULEJISTA', description: 'AZULEJISTA' },
		{ value: 'BAILARINO', description: 'BAILARINO' },
		{ value: 'BANCARIO', description: 'BANCARIO' },
		{ value: 'BARBEIRO', description: 'BARBEIRO' },
		{ value: 'BIBLIOTECARIO', description: 'BIBLIOTECARIO' },
		{ value: 'BIOLOGO', description: 'BIOLOGO' },
		{ value: 'BIOMEDICO', description: 'BIOMEDICO' },
		{ value: 'BOLSISTA', description: 'BOLSISTA' },
		{ value: 'BOMBEIRO/ENCANADOR', description: 'BOMBEIRO/ENCANADOR' },
		{ value: 'BORRACHEIRO', description: 'BORRACHEIRO' },
		{ value: 'CABELEIREIRO', description: 'CABELEIREIRO' },
		{ value: 'CAIXEIRO-VIAJANTE', description: 'CAIXEIRO-VIAJANTE' },
		{ value: 'CALHISTA', description: 'CALHISTA' },
		{ value: 'CALISTA', description: 'CALISTA' },
		{ value: 'CAMAREIRO', description: 'CAMAREIRO' },
		{ value: 'CANTOR', description: 'CANTOR' },
		{ value: 'CAPITALISTA,RECEB.REND.APLIC.CAP. ATIV', description: 'CAPITALISTA,RECEB.REND.APLIC.CAP. ATIV' },
		{ value: 'CARREGADOR', description: 'CARREGADOR' },
		{ value: 'CARTORARIOS', description: 'CARTORARIOS' },
		{ value: 'CASEIROS', description: 'CASEIROS' },
		{ value: 'CAVALARICO, FERRADOR, TRATADOR ANIMAIS', description: 'CAVALARICO, FERRADOR, TRATADOR ANIMAIS' },
		{ value: 'CHAVEIRO', description: 'CHAVEIRO' },
		{ value: 'CHEFE INTERMEDIARIO', description: 'CHEFE INTERMEDIARIO' },
		{ value: 'CHEFES DA PRODUCAO', description: 'CHEFES DA PRODUCAO' },
		{ value: 'COBRADOR EM GERAL', description: 'COBRADOR EM GERAL' },
		{ value: 'COMANDANTE DE EMBARCACOES', description: 'COMANDANTE DE EMBARCACOES' },
		{ value: 'COMENTARISTA', description: 'COMENTARISTA' },
		{ value: 'COMISSARIO DE BORDO', description: 'COMISSARIO DE BORDO' },
		{ value: 'COMPOSITOR', description: 'COMPOSITOR' },
		{ value: 'COMUNICOLOGO', description: 'COMUNICOLOGO' },
		{ value: 'CONSULTOR DE EMPRESAS', description: 'CONSULTOR DE EMPRESAS' },
		{ value: 'CONTADOR', description: 'CONTADOR' },
		{ value: 'CONTRAMESTRE DE EMBARCACOES', description: 'CONTRAMESTRE DE EMBARCACOES' },
		{ value: 'CONTRAMESTRE DE PRODUCAO', description: 'CONTRAMESTRE DE PRODUCAO' },
		{ value: 'COREOGRAFO', description: 'COREOGRAFO' },
		{ value: 'CORPO DE BOMBEIROS (SOLDADOS)', description: 'CORPO DE BOMBEIROS (SOLDADOS)' },
		{ value: 'CORRETOR EM GERAL', description: 'CORRETOR EM GERAL' },
		{ value: 'CORTADOR', description: 'CORTADOR' },
		{ value: 'COZINHEIRO', description: 'COZINHEIRO' },
		{ value: 'CRIACAO DE PEQUENOS ANIMAIS', description: 'CRIACAO DE PEQUENOS ANIMAIS' },
		{ value: 'DATILOGRAFO', description: 'DATILOGRAFO' },
		{ value: 'DECORADOR', description: 'DECORADOR' },
		{ value: 'DELEGADO DE POLICIA', description: 'DELEGADO DE POLICIA' },
		{ value: 'DEMONSTRADOR', description: 'DEMONSTRADOR' },
		{ value: 'DEPILADOR', description: 'DEPILADOR' },
		{ value: 'DEPUTADO ESTADUAL', description: 'DEPUTADO ESTADUAL' },
		{ value: 'DEPUTADO FEDERAL', description: 'DEPUTADO FEDERAL' },
		{ value: 'DESEMBARGADOR', description: 'DESEMBARGADOR' },
		{ value: 'DESENHISTA COMERCIAL', description: 'DESENHISTA COMERCIAL' },
		{ value: 'DESENHISTA INDUSTRIAL', description: 'DESENHISTA INDUSTRIAL' },
		{ value: 'DESENHISTA TECNICO', description: 'DESENHISTA TECNICO' },
		{ value: 'DESPACHANTE, INCLUSIVE ADUANEIRO', description: 'DESPACHANTE, INCLUSIVE ADUANEIRO' },
		{ value: 'DETETIVE', description: 'DETETIVE' },
		{ value: 'DETETIZADOR', description: 'DETETIZADOR' },
		{ value: 'DIGITADOR', description: 'DIGITADOR' },
		{ value: 'DIPLOMATA', description: 'DIPLOMATA' },
		{ value: 'DIRETOR DE EMPRESA', description: 'DIRETOR DE EMPRESA' },
		{ value: 'DIRETOR DE ESPETACULOS', description: 'DIRETOR DE ESPETACULOS' },
		{ value: 'DIRETOR DE ESTABELECIMENTO DE ENSINO', description: 'DIRETOR DE ESTABELECIMENTO DE ENSINO' },
		{ value: 'ECONOMIARIO', description: 'ECONOMIARIO' },
		{ value: 'ECONOMISTA, CONTADOR, ADMINISTRADOR ASS.', description: 'ECONOMISTA, CONTADOR, ADMINISTRADOR ASS.' },
		{ value: 'ELETRECITARIO', description: 'ELETRECITARIO' },
		{ value: 'ELETRICISTA E ASS.', description: 'ELETRICISTA E ASS.' },
		{ value: 'ELETRICISTA MANUT.DE VEIC.AUTOMOTORES', description: 'ELETRICISTA MANUT.DE VEIC.AUTOMOTORES' },
		{ value: 'ELETRICISTA MANUTENCAO DE MAQUINAS', description: 'ELETRICISTA MANUTENCAO DE MAQUINAS' },
		{ value: 'EMBALADOR', description: 'EMBALADOR' },
		{ value: 'EMBALSAMADOR', description: 'EMBALSAMADOR' },
		{ value: 'EMPREGADO DOMESTICO', description: 'EMPREGADO DOMESTICO' },
		{ value: 'EMPREGADO RESTAURANTE, BUFFET, PADARIAS', description: 'EMPREGADO RESTAURANTE, BUFFET, PADARIAS' },
		{ value: 'EMPRESARIO', description: 'EMPRESARIO' },
		{ value: 'EMPRESARIO DE ATLETA', description: 'EMPRESARIO DE ATLETA' },
		{ value: 'ENFERMEIRO', description: 'ENFERMEIRO' },
		{ value: 'ENGENHEIRO', description: 'ENGENHEIRO' },
		{ value: 'ESCRITOR', description: 'ESCRITOR' },
		{ value: 'ESCULTOR', description: 'ESCULTOR' },
		{ value: 'ESPOLIO', description: 'ESPOLIO' },
		{ value: 'ESTAGIARIOS', description: 'ESTAGIARIOS' },
		{ value: 'ESTENOGRAFO', description: 'ESTENOGRAFO' },
		{ value: 'ESTETICISTA', description: 'ESTETICISTA' },
		{ value: 'ESTILISTA/MODELISTA', description: 'ESTILISTA/MODELISTA' },
		{ value: 'ESTIVADOR', description: 'ESTIVADOR' },
		{ value: 'ESTUDANTE', description: 'ESTUDANTE' },
		{ value: 'FARMACEUTICO', description: 'FARMACEUTICO' },
		{ value: 'FAXINEIRO', description: 'FAXINEIRO' },
		{ value: 'FEIRANTE', description: 'FEIRANTE' },
		{ value: 'FERRAMENTEIRO', description: 'FERRAMENTEIRO' },
		{ value: 'FISCAL', description: 'FISCAL' },
		{ value: 'FISCAL DE PRODUCAO', description: 'FISCAL DE PRODUCAO' },
		{ value: 'FISCAL SERVIGOS DE TRANSPORTE', description: 'FISCAL SERVIGOS DE TRANSPORTE' },
		{ value: 'FISICO', description: 'FISICO' },
		{ value: 'FISIOTERAPEUTA', description: 'FISIOTERAPEUTA' },
		{ value: 'FOGUISTA DE EMBARCACOES OU LOCOMOTIVAS', description: 'FOGUISTA DE EMBARCACOES OU LOCOMOTIVAS' },
		{ value: 'FONAUDIOLOGO', description: 'FONAUDIOLOGO' },
		{ value: 'FORGAS ARMADAS (SOLDADO, MARINHEIRO,ETC)', description: 'FORGAS ARMADAS (SOLDADO, MARINHEIRO,ETC)' },
		{ value: 'FOTOGRAFO', description: 'FOTOGRAFO' },
		{ value: 'FREZADOR', description: 'FREZADOR' },
		{ value: 'FUNCIONARIO PUBLICO CIVIL APOSENTADO', description: 'FUNCIONARIO PUBLICO CIVIL APOSENTADO' },
		{ value: 'FUNDIDOR', description: 'FUNDIDOR' },
		{ value: 'GARAGISTA', description: 'GARAGISTA' },
		{ value: 'GARCOM', description: 'GARCOM' },
		{ value: 'GARIMPEIRO', description: 'GARIMPEIRO' },
		{ value: 'GEOGRAFO', description: 'GEOGRAFO' },
		{ value: 'GEOLOGO', description: 'GEOLOGO' },
		{ value: 'GERENTE', description: 'GERENTE' },
		{ value: 'GESSISTA', description: 'GESSISTA' },
		{ value: 'GOVERNADOR DE ESTADO', description: 'GOVERNADOR DE ESTADO' },
		{ value: 'GOVERNANTA DE HOTEL', description: 'GOVERNANTA DE HOTEL' },
		{ value: 'GUIA TURISTICO', description: 'GUIA TURISTICO' },
		{ value: 'IMPERMEABILIZADOR', description: 'IMPERMEABILIZADOR' },
		{ value: 'INSPETOR', description: 'INSPETOR' },
		{ value: 'INSPETOR DE CONTROLE DE QUALIDADE', description: 'INSPETOR DE CONTROLE DE QUALIDADE' },
		{ value: 'INSTALADOR DE GAS, AGUA E ESGOTO', description: 'INSTALADOR DE GAS, AGUA E ESGOTO' },
		{ value: 'INSTRUMENTADOR CIRURGICO', description: 'INSTRUMENTADOR CIRURGICO' },
		{ value: 'INSTRUMENTISTA', description: 'INSTRUMENTISTA' },
		{ value: 'INSTRUTOR DE ARTES MARCIAS', description: 'INSTRUTOR DE ARTES MARCIAS' },
		{ value: 'INSTRUTOR DE AUTOESCOLA', description: 'INSTRUTOR DE AUTOESCOLA' },
		{ value: 'INSTRUTOR DE GINASTICA', description: 'INSTRUTOR DE GINASTICA' },
		{ value: 'INSTRUTOR DE INFORMATICA', description: 'INSTRUTOR DE INFORMATICA' },
		{ value: 'JARDINEIROS', description: 'JARDINEIROS' },
		{ value: 'JOALHEIRO', description: 'JOALHEIRO' },
		{ value: 'JORNALEIRO', description: 'JORNALEIRO' },
		{ value: 'JORNALISTA', description: 'JORNALISTA' },
		{ value: 'JUIZ DE DIREITO', description: 'JUIZ DE DIREITO' },
		{ value: 'LANTERNEIRO', description: 'LANTERNEIRO' },
		{ value: 'LEILOEIRO', description: 'LEILOEIRO' },
		{ value: 'LEITURISTA', description: 'LEITURISTA' },
		{ value: 'LIXEIRO, GARI, VARREDOR, COLETOR DE LIXO', description: 'LIXEIRO, GARI, VARREDOR, COLETOR DE LIXO' },
		{ value: 'LOCUTOR', description: 'LOCUTOR' },
		{ value: 'MANICURE', description: 'MANICURE' },
		{ value: 'MANOBRIST.NAO EMPREGADO,GUARDADOR CARRO', description: 'MANOBRIST.NAO EMPREGADO,GUARDADOR CARRO' },
		{ value: 'MAQUILADOR', description: 'MAQUILADOR' },
		{ value: 'MAQUINISTA DE EMBARCACOES OU LOCOMOTIVAS', description: 'MAQUINISTA DE EMBARCACOES OU LOCOMOTIVAS' },
		{ value: 'MARINHEIRO E ASS.', description: 'MARINHEIRO E ASS.' },
		{ value: 'MASSAGISTA', description: 'MASSAGISTA' },
		{ value: 'MATEMATICO', description: 'MATEMATICO' },
		{ value: 'MATEMATICO / ESTATISTICO / ATUARIO', description: 'MATEMATICO / ESTATISTICO / ATUARIO' },
		{ value: 'MECANICO DE MANUTENCAO', description: 'MECANICO DE MANUTENCAO' },
		{ value: 'MECANICO MANUT.DE VEICULOS AUTOMOTORES', description: 'MECANICO MANUT.DE VEICULOS AUTOMOTORES' },
		{ value: 'MECANICO MANUTENCAO DE MAQUINAS', description: 'MECANICO MANUTENCAO DE MAQUINAS' },
		{ value: 'MECANICO MAQUINAS, REFRIGERACAO, ETC', description: 'MECANICO MAQUINAS, REFRIGERACAO, ETC' },
		{ value: 'MEDICO', description: 'MEDICO' },
		{ value: 'MEMBRO DA DEFENSORIA PUBLICA', description: 'MEMBRO DA DEFENSORIA PUBLICA' },
		{ value: 'MEMBRO DO MINISTERIO PUBLICO', description: 'MEMBRO DO MINISTERIO PUBLICO' },
		{ value: 'MESTRE DE PRODUCAO', description: 'MESTRE DE PRODUCAO' },
		{ value: 'METEOROLOGISTA', description: 'METEOROLOGISTA' },
		{ value: 'MILITAR EM GERAL', description: 'MILITAR EM GERAL' },
		{ value: 'MILITAR REFORMADO', description: 'MILITAR REFORMADO' },
		{ value: 'MINISTRO DE ESTADO', description: 'MINISTRO DE ESTADO' },
		{ value: 'MINISTRO DE TRIBUNAL SUPERIOR', description: 'MINISTRO DE TRIBUNAL SUPERIOR' },
		{ value: 'MODELO DE MODAS', description: 'MODELO DE MODAS' },
		{ value: 'MONTADOR', description: 'MONTADOR' },
		{ value: 'MOTOBOY', description: 'MOTOBOY' },
		{ value: 'MOTORISTA VEIC.DE TRANSPORTE DE PASSAG.', description: 'MOTORISTA VEIC.DE TRANSPORTE DE PASSAG.' },
		{ value: 'MOTORISTA AUTONOMO (TAXISTA PRINCIP.)', description: 'MOTORISTA AUTONOMO (TAXISTA PRINCIP.)' },
		{ value: 'MOTORISTA VEIC.DE TRANSPORTE DE CARGA', description: 'MOTORISTA VEIC.DE TRANSPORTE DE CARGA' },
		{ value: 'MUSEOLOGO', description: 'MUSEOLOGO' },
		{ value: 'MUSICO', description: 'MUSICO' },
		{ value: 'NUTRICIONISTA', description: 'NUTRICIONISTA' },
		{ value: 'NÃO INFORMADO', description: 'NÃO INFORMADO' },
		{ value: 'OCUPANTE CARGO DIRECAO E ASSES.SUPERIOR', description: 'OCUPANTE CARGO DIRECAO E ASSES.SUPERIOR' },
		{ value: 'OCUPANTE CARGO DIRECAO E ASSISTENCIA INT', description: 'OCUPANTE CARGO DIRECAO E ASSISTENCIA INT' },
		{ value: 'ODONTOLOGO', description: 'ODONTOLOGO' },
		{ value: 'OFFICE BOY, CONTINUO, ENTREGADOR', description: 'OFFICE BOY, CONTINUO, ENTREGADOR' },
		{ value: 'OFICIAIS DAS POL. MILITARES E BOMBEIROS', description: 'OFICIAIS DAS POL. MILITARES E BOMBEIROS' },
		{ value: 'OFICIAIS FORCAS ARMADAS E FORCAS AUX', description: 'OFICIAIS FORCAS ARMADAS E FORCAS AUX' },
		{ value: 'OPERADOR DE CALDEIRA', description: 'OPERADOR DE CALDEIRA' },
		{ value: 'OPERADOR DE CAMERAS DE CINEMA E TV', description: 'OPERADOR DE CAMERAS DE CINEMA E TV' },
		{ value: 'OPERADOR DE COMPUTAR, MICROCOMPUTADOR', description: 'OPERADOR DE COMPUTAR, MICROCOMPUTADOR' },
		{ value: 'OPERADOR DE ILUMINACAO', description: 'OPERADOR DE ILUMINACAO' },
		{ value: 'OPERADOR DE MAQUINAS E APARELHOS', description: 'OPERADOR DE MAQUINAS E APARELHOS' },
		{ value: 'OPERADOR DE TELEMARKETING', description: 'OPERADOR DE TELEMARKETING' },
		{ value: 'OPERADOR DE VIDEOTAPE', description: 'OPERADOR DE VIDEOTAPE' },
		{ value: 'OPERADORES DE GUINDASTE', description: 'OPERADORES DE GUINDASTE' },
		{ value: 'OPERARIOS SEMI-ESPECIALIZADOS PRODUCAO', description: 'OPERARIOS SEMI-ESPECIALIZADOS PRODUCAO' },
		{ value: 'ORIENTADOR PEDAGOGICO', description: 'ORIENTADOR PEDAGOGICO' },
		{ value: 'OT TRAB.DE NIVEL SUPERIOR LIG. AO ENSINO', description: 'OT TRAB.DE NIVEL SUPERIOR LIG. AO ENSINO' },
		{ value: 'OT-ADVOGADOS,PSICOLOGOS,BIBLIOTEC. E ASS', description: 'OT-ADVOGADOS,PSICOLOGOS,BIBLIOTEC. E ASS' },
		{ value: 'OT-DIRETOR E GERENTE', description: 'OT-DIRETOR E GERENTE' },
		{ value: 'OT-ECONOMIST.,ESTATIST.,CONTADORES E ASS', description: 'OT-ECONOMIST.,ESTATIST.,CONTADORES E ASS' },
		{ value: 'OT-ENG.,FISICOS,QUIMICOS E ASS.', description: 'OT-ENG.,FISICOS,QUIMICOS E ASS.' },
		{ value: 'OT-ESTUDANTES', description: 'OT-ESTUDANTES' },
		{ value: 'OT-JORNALISTAS E ASS.', description: 'OT-JORNALISTAS E ASS.' },
		{ value: 'OT-MEDICOS,ODONTOLOGOS,ENFERMEIROS E ASS', description: 'OT-MEDICOS,ODONTOLOGOS,ENFERMEIROS E ASS' },
		{ value: 'OT-MEMBROS DE ORDENS OU SEITAS RELIG.', description: 'OT-MEMBROS DE ORDENS OU SEITAS RELIG.' },
		{ value: 'OT-MEMBROS PODER LEGISLATIV.,EXECUT.JUD.', description: 'OT-MEMBROS PODER LEGISLATIV.,EXECUT.JUD.' },
		{ value: 'OT-OT DECLARANTES N.E.A', description: 'OT-OT DECLARANTES N.E.A' },
		{ value: 'OT-OT TRABALHADORES DE SERVICOS', description: 'OT-OT TRABALHADORES DE SERVICOS' },
		{ value: 'OT-OUT.TRAB.PROFISS.CIENTIF.,TECNIC ARTI', description: 'OT-OUT.TRAB.PROFISS.CIENTIF.,TECNIC ARTI' },
		{ value: 'OT-PROPRIETARIOS E CAPITALISTAS', description: 'OT-PROPRIETARIOS E CAPITALISTAS' },
		{ value: 'OT-SERV. ADMINIST.,CONSERV.E LIMP.EDIF.', description: 'OT-SERV. ADMINIST.,CONSERV.E LIMP.EDIF.' },
		{ value: 'OT-SERV.CIV E MILIT. E AGENTES ADM PUBL', description: 'OT-SERV.CIV E MILIT. E AGENTES ADM PUBL' },
		{ value: 'OT-SERV.HOSPEDAGEM,RESTAURANTE E ASS.', description: 'OT-SERV.HOSPEDAGEM,RESTAURANTE E ASS.' },
		{ value: 'OT-SERVICOS DE MANUTENCAO', description: 'OT-SERVICOS DE MANUTENCAO' },
		{ value: 'OT-SERVICOS DE TRANSPORTE', description: 'OT-SERVICOS DE TRANSPORTE' },
		{ value: 'OT-SERVICOS DE TRATAMENTO DE BELEZA', description: 'OT-SERVICOS DE TRATAMENTO DE BELEZA' },
		{ value: 'OT-SERVIDORES CIV E MILITARES NIV.SUPER.', description: 'OT-SERVIDORES CIV E MILITARES NIV.SUPER.' },
		{ value: 'OT-SUPERVISORES,CORRETORES E ASS.', description: 'OT-SUPERVISORES,CORRETORES E ASS.' },
		{ value: 'OT-TECNICOS', description: 'OT-TECNICOS' },
		{ value: 'OT-TRAB. APOSENTADOS E PENSIONISTAS', description: 'OT-TRAB. APOSENTADOS E PENSIONISTAS' },
		{ value: 'OT-TRAB.AGRICOLAS FLORESTAIS,EXTRACAO', description: 'OT-TRAB.AGRICOLAS FLORESTAIS,EXTRACAO' },
		{ value: 'OT-TRAB.LIG.APRES.ESPETAC.PUBLIC./DESPOR', description: 'OT-TRAB.LIG.APRES.ESPETAC.PUBLIC./DESPOR' },
		{ value: 'OT-TRAB.LIGADOS ATIV.NAVEG.AEREA,MARIT.', description: 'OT-TRAB.LIGADOS ATIV.NAVEG.AEREA,MARIT.' },
		{ value: 'OT-TRABALHADOR.ADMINISTRATIVOS E ASS.', description: 'OT-TRABALHADOR.ADMINISTRATIVOS E ASS.' },
		{ value: 'OT-TRABALHADORES DE PRODUCAO INDUSTRIAL', description: 'OT-TRABALHADORES DE PRODUCAO INDUSTRIAL' },
		{ value: 'OT-TRABALHADORES DO COMERCIO E ASS.', description: 'OT-TRABALHADORES DO COMERCIO E ASS.' },
		{ value: 'OT-VENDEDOR E ASS.', description: 'OT-VENDEDOR E ASS.' },
		{ value: 'OURIVES', description: 'OURIVES' },
		{ value: 'PAISAGISTA', description: 'PAISAGISTA' },
		{ value: 'PEDICURE', description: 'PEDICURE' },
		{ value: 'PEDREIRO', description: 'PEDREIRO' },
		{ value: 'PENSIONISTA', description: 'PENSIONISTA' },
		{ value: 'PERSONAL TRAINER', description: 'PERSONAL TRAINER' },
		{ value: 'PESQUISADOR CIENTIFICO', description: 'PESQUISADOR CIENTIFICO' },
		{ value: 'PESSOAL DE HOSPITAL', description: 'PESSOAL DE HOSPITAL' },
		{ value: 'PESSOAL DE POSTO DE GASOLINA', description: 'PESSOAL DE POSTO DE GASOLINA' },
		{ value: 'PILOTO DE AERONAVES', description: 'PILOTO DE AERONAVES' },
		{ value: 'PINTOR', description: 'PINTOR' },
		{ value: 'PINTOR DE PAREDES', description: 'PINTOR DE PAREDES' },
		{ value: 'PINTOR DE VEICULOS', description: 'PINTOR DE VEICULOS' },
		{ value: 'PORTEIRO DE EDIFICIO', description: 'PORTEIRO DE EDIFICIO' },
		{ value: 'PORTEIRO DE HOTEL', description: 'PORTEIRO DE HOTEL' },
		{ value: 'PORTUARIO', description: 'PORTUARIO' },
		{ value: 'PREFEITO', description: 'PREFEITO' },
		{ value: 'PRENSISTA, ESTAMPADOR', description: 'PRENSISTA, ESTAMPADOR' },
		{ value: 'PREPARADOR', description: 'PREPARADOR' },
		{ value: 'PREPARADOR DE MAQUINAS', description: 'PREPARADOR DE MAQUINAS' },
		{ value: 'PRESIDENTE DA REPUBLICA', description: 'PRESIDENTE DA REPUBLICA' },
		{ value: 'PROCURADOR E ASS.', description: 'PROCURADOR E ASS.' },
		{ value: 'PRODUTOR', description: 'PRODUTOR' },
		{ value: 'PRODUTOR DE ALGODAO', description: 'PRODUTOR DE ALGODAO' },
		{ value: 'PRODUTOR DE BATATA', description: 'PRODUTOR DE BATATA' },
		{ value: 'PRODUTOR DE CACAU', description: 'PRODUTOR DE CACAU' },
		{ value: 'PRODUTOR DE CAFE', description: 'PRODUTOR DE CAFE' },
		{ value: 'PRODUTOR DE CANA', description: 'PRODUTOR DE CANA' },
		{ value: 'PRODUTOR DE CITRUS', description: 'PRODUTOR DE CITRUS' },
		{ value: 'PRODUTOR DE EVENTOS (PROMOTER)', description: 'PRODUTOR DE EVENTOS (PROMOTER)' },
		{ value: 'PRODUTOR DE FLORICULTURA', description: 'PRODUTOR DE FLORICULTURA' },
		{ value: 'PRODUTOR DE FRUTICULTURA', description: 'PRODUTOR DE FRUTICULTURA' },
		{ value: 'PRODUTOR DE HORTICULTURA', description: 'PRODUTOR DE HORTICULTURA' },
		{ value: 'PRODUTOR SOJA/MILHO/TRIGO/ARROZ/FEIJAO', description: 'PRODUTOR SOJA/MILHO/TRIGO/ARROZ/FEIJAO' },
		{ value: 'PROFESSOR DE ENSINO SUPERIOR', description: 'PROFESSOR DE ENSINO SUPERIOR' },
		{ value: 'PROFESSOR DE PRIMEIRO E SEGUNDO GRAU', description: 'PROFESSOR DE PRIMEIRO E SEGUNDO GRAU' },
		{ value: 'PROFESSORES AUTONOMOS/PARTICULARES', description: 'PROFESSORES AUTONOMOS/PARTICULARES' },
		{ value: 'PROFESSORES AUTONOMOS/PARTICULARES', description: 'PROFESSORES AUTONOMOS/PARTICULARES' },
		{ value: 'PROFESSORES DE IDIOMAS', description: 'PROFESSORES DE IDIOMAS' },
		{ value: 'PROFISSIONAIS DE LETRAS E ARTES', description: 'PROFISSIONAIS DE LETRAS E ARTES' },
		{ value: 'PROGRAMACAO DE PRODUCAO', description: 'PROGRAMACAO DE PRODUCAO' },
		{ value: 'PROGRAMADOR DE COMPUTADOR', description: 'PROGRAMADOR DE COMPUTADOR' },
		{ value: 'PROMOTOR DE VENDAS', description: 'PROMOTOR DE VENDAS' },
		{ value: 'PROMOTOR PUBLICO', description: 'PROMOTOR PUBLICO' },
		{ value: 'PROPRIETARIO DE ESTABEL. COMERCIAL', description: 'PROPRIETARIO DE ESTABEL. COMERCIAL' },
		{ value: 'PROPRIETARIO DE ESTABEL. FLORESTAL', description: 'PROPRIETARIO DE ESTABEL. FLORESTAL' },
		{ value: 'PROPRIETARIO DE ESTABEL. INDUSTRIAL', description: 'PROPRIETARIO DE ESTABEL. INDUSTRIAL' },
		{ value: 'PROPRIETARIO DE ESTABELECIMENTO AGRICOLA', description: 'PROPRIETARIO DE ESTABELECIMENTO AGRICOLA' },
		{ value: 'PROPRIETARIO DE ESTABELECIMENTO PECUARIO', description: 'PROPRIETARIO DE ESTABELECIMENTO PECUARIO' },
		{ value: 'PROPRIETARIO DE MICROEMPRESA', description: 'PROPRIETARIO DE MICROEMPRESA' },
		{ value: 'PROPRIETARIO ESTABEL. DE PRESTACAO SERV.', description: 'PROPRIETARIO ESTABEL. DE PRESTACAO SERV.' },
		{ value: 'PROPRIETARIO IMOVEL,RECEBE REND.ALUGUEL', description: 'PROPRIETARIO IMOVEL,RECEBE REND.ALUGUEL' },
		{ value: 'PROTETICO', description: 'PROTETICO' },
		{ value: 'PSICANALISTA', description: 'PSICANALISTA' },
		{ value: 'PSICOLOGO', description: 'PSICOLOGO' },
		{ value: 'PUBLICITARIO', description: 'PUBLICITARIO' },
		{ value: 'QUIMICO', description: 'QUIMICO' },
		{ value: 'RADIALISTA', description: 'RADIALISTA' },
		{ value: 'RECEPCIONISTA', description: 'RECEPCIONISTA' },
		{ value: 'REDATOR', description: 'REDATOR' },
		{ value: 'RELACOES PUBLICAS', description: 'RELACOES PUBLICAS' },
		{ value: 'RELOJOEIRO', description: 'RELOJOEIRO' },
		{ value: 'REPRESENTANTE COMERCIAL', description: 'REPRESENTANTE COMERCIAL' },
		{ value: 'SACERDOTE OU MEMBRO ORDENS OU SEITAS', description: 'SACERDOTE OU MEMBRO ORDENS OU SEITAS' },
		{ value: 'SAPATEIRO', description: 'SAPATEIRO' },
		{ value: 'SECRETARIO', description: 'SECRETARIO' },
		{ value: 'SECRETARIO DE ESTADO', description: 'SECRETARIO DE ESTADO' },
		{ value: 'SECRETARIO MUNICIPAL', description: 'SECRETARIO MUNICIPAL' },
		{ value: 'SECURITARIO', description: 'SECURITARIO' },
		{ value: 'SEGURANCA PATRIMONIAL', description: 'SEGURANCA PATRIMONIAL' },
		{ value: 'SENADOR', description: 'SENADOR' },
		{ value: 'SERRALHEIRO', description: 'SERRALHEIRO' },
		{ value: 'SERVENTUARIO DA JUSTICA', description: 'SERVENTUARIO DA JUSTICA' },
		{ value: 'SERVICOS DE MANUTENCAO', description: 'SERVICOS DE MANUTENCAO' },
		{ value: 'SERVIDOR PUBLICO ESTADUAL', description: 'SERVIDOR PUBLICO ESTADUAL' },
		{ value: 'SERVIDOR PUBLICO FEDERAL', description: 'SERVIDOR PUBLICO FEDERAL' },
		{ value: 'SERVIDOR PUBLICO MUNICIPAL', description: 'SERVIDOR PUBLICO MUNICIPAL' },
		{ value: 'SOCIOLOGO', description: 'SOCIOLOGO' },
		{ value: 'SUPERENTENDENTES NA PRODUCAO', description: 'SUPERENTENDENTES NA PRODUCAO' },
		{ value: 'SUPERVISOR', description: 'SUPERVISOR' },
		{ value: 'SUPERVISORES NA PRODUCAO', description: 'SUPERVISORES NA PRODUCAO' },
		{ value: 'TABELIAO', description: 'TABELIAO' },
		{ value: 'TAPECEIRO', description: 'TAPECEIRO' },
		{ value: 'TEC. PROCES. METODOS, HARDWARE, SOFTWARE', description: 'TEC. PROCES. METODOS, HARDWARE, SOFTWARE' },
		{ value: 'TECNICO DE BIOLOGIA', description: 'TECNICO DE BIOLOGIA' },
		{ value: 'TECNICO DE CONTABILIDADE', description: 'TECNICO DE CONTABILIDADE' },
		{ value: 'TECNICO DE ELETRICIDADE', description: 'TECNICO DE ELETRICIDADE' },
		{ value: 'TECNICO DE ELETRONICA', description: 'TECNICO DE ELETRONICA' },
		{ value: 'TECNICO DE ESTATISTICA', description: 'TECNICO DE ESTATISTICA' },
		{ value: 'TECNICO DE LABORATORIO', description: 'TECNICO DE LABORATORIO' },
		{ value: 'TECNICO DE MECANICA', description: 'TECNICO DE MECANICA' },
		{ value: 'TECNICO DE QUIMICA', description: 'TECNICO DE QUIMICA' },
		{ value: 'TECNICO DE RAIO-X', description: 'TECNICO DE RAIO-X' },
		{ value: 'TECNICO DE TELECOMUNICACOES', description: 'TECNICO DE TELECOMUNICACOES' },
		{ value: 'TECNICO EM AGRIMENSURA', description: 'TECNICO EM AGRIMENSURA' },
		{ value: 'TECNICO EM AGRONOMIA', description: 'TECNICO EM AGRONOMIA' },
		{ value: 'TECNICO EM DESPORTOS', description: 'TECNICO EM DESPORTOS' },
		{ value: 'TECNICO EM EDIFICACOES', description: 'TECNICO EM EDIFICACOES' },
		{ value: 'TECNICO EM ENFERMAGEM', description: 'TECNICO EM ENFERMAGEM' },
		{ value: 'TECNICO EM FARMACIA', description: 'TECNICO EM FARMACIA' },
		{ value: 'TECNICO EM FINANCAS', description: 'TECNICO EM FINANCAS' },
		{ value: 'TECNICO EM INSEMINACAO', description: 'TECNICO EM INSEMINACAO' },
		{ value: 'TECNICO EM ODONTOLOGIA (PROTETICO)', description: 'TECNICO EM ODONTOLOGIA (PROTETICO)' },
		{ value: 'TECNICO EM REFRIGERACAO', description: 'TECNICO EM REFRIGERACAO' },
		{ value: 'TECNICO PROJESTISTA', description: 'TECNICO PROJESTISTA' },
		{ value: 'TECNOLOGO', description: 'TECNOLOGO' },
		{ value: 'TELEFONISTA', description: 'TELEFONISTA' },
		{ value: 'TELHADISTA', description: 'TELHADISTA' },
		{ value: 'TERAPEUTA OCUPACIONAL', description: 'TERAPEUTA OCUPACIONAL' },
		{ value: 'TORNEIRO', description: 'TORNEIRO' },
		{ value: 'TRAB. DE ARTES GRAFICAS', description: 'TRAB. DE ARTES GRAFICAS' },
		{ value: 'TRAB. DE CONSTRUCAO CIVIL', description: 'TRAB. DE CONSTRUCAO CIVIL' },
		{ value: 'TRAB. DE FABRICACAO DE PAPEL E PAPELAO', description: 'TRAB. DE FABRICACAO DE PAPEL E PAPELAO' },
		{ value: 'TRAB. DE USINAGEM DE METAIS', description: 'TRAB. DE USINAGEM DE METAIS' },
		{ value: 'TRAB. FABRIC. CALCADOS E ARTEFATOS COURO', description: 'TRAB. FABRIC. CALCADOS E ARTEFATOS COURO' },
		{ value: 'TRAB. FABRIC. E PREP. ALIMENTOS E BEBIDA', description: 'TRAB. FABRIC. E PREP. ALIMENTOS E BEBIDA' },
		{ value: 'TRAB. FABRIC. PROD TEXTEIS(EXCETO ROUPA)', description: 'TRAB. FABRIC. PROD TEXTEIS(EXCETO ROUPA)' },
		{ value: 'TRAB. FABRIC.PROD. BORRACHA E PLASTICO', description: 'TRAB. FABRIC.PROD. BORRACHA E PLASTICO' },
		{ value: 'TRAB. FABRICACAO DE ARTEFATOS DE MADEIRA', description: 'TRAB. FABRICACAO DE ARTEFATOS DE MADEIRA' },
		{ value: 'TRABALHADOR AGRICOLA', description: 'TRABALHADOR AGRICOLA' },
		{ value: 'TRABALHADOR DA PECUARIA', description: 'TRABALHADOR DA PECUARIA' },
		{ value: 'TRABALHADOR DA PESCA', description: 'TRABALHADOR DA PESCA' },
		{ value: 'TRABALHADOR DE FABRICACAO DE ROUPAS', description: 'TRABALHADOR DE FABRICACAO DE ROUPAS' },
		{ value: 'TRABALHADOR DE FABRICACAO DE ROUPAS', description: 'TRABALHADOR DE FABRICACAO DE ROUPAS' },
		{ value: 'TRABALHADOR DE TRATAMENTO DE FUMO', description: 'TRABALHADOR DE TRATAMENTO DE FUMO' },
		{ value: 'TRABALHADOR FABRIC.CIGARROS E CHARUTOS', description: 'TRABALHADOR FABRIC.CIGARROS E CHARUTOS' },
		{ value: 'TRABALHADOR FLORESTAL', description: 'TRABALHADOR FLORESTAL' },
		{ value: 'TRABALHADOR INSTAL. PROCESSAMENTO QUIM.', description: 'TRABALHADOR INSTAL. PROCESSAMENTO QUIM.' },
		{ value: 'TRABALHADOR METALURGICO', description: 'TRABALHADOR METALURGICO' },
		{ value: 'TRABALHADOR SERV.CONTAB. CAIXA E ASS.', description: 'TRABALHADOR SERV.CONTAB. CAIXA E ASS.' },
		{ value: 'TRABALHADOR SETOR QUIMICO/PETROQUIMICO', description: 'TRABALHADOR SETOR QUIMICO/PETROQUIMICO' },
		{ value: 'TRABALHADOR SIDERURGICO', description: 'TRABALHADOR SIDERURGICO' },
		{ value: 'TRABALHADORES DA ADMINISTRACAO', description: 'TRABALHADORES DA ADMINISTRACAO' },
		{ value: 'TRABALHADORES DE CEREALISTAS', description: 'TRABALHADORES DE CEREALISTAS' },
		{ value: 'TRABALHADORES DE FRIGORIFICOS', description: 'TRABALHADORES DE FRIGORIFICOS' },
		{ value: 'TRABALHADORES DE LATICINIOS', description: 'TRABALHADORES DE LATICINIOS' },
		{ value: 'TRABALHADORES DE USINA - ACUCAR E ALCOOL', description: 'TRABALHADORES DE USINA - ACUCAR E ALCOOL' },
		{ value: 'TRADUTOR', description: 'TRADUTOR' },
		{ value: 'TRAINEES', description: 'TRAINEES' },
		{ value: 'UNIVERSITARIO', description: 'UNIVERSITARIO' },
		{ value: 'VENDEDOR DO COMERCIO ATACADISTA', description: 'VENDEDOR DO COMERCIO ATACADISTA' },
		{ value: 'VENDEDOR DO COMERCIO VAREJISTA', description: 'VENDEDOR DO COMERCIO VAREJISTA' },
		{ value: 'VENDEDOR PRACISTA', description: 'VENDEDOR PRACISTA' },
		{ value: 'VEREADOR', description: 'VEREADOR' },
		{ value: 'VETERINARIO', description: 'VETERINARIO' },
		{ value: 'VIDRACEIRO', description: 'VIDRACEIRO' },
		{ value: 'WEBDESIGNER', description: 'WEBDESIGNER' },
		{ value: 'ZOOTECNISTA', description: 'ZOOTECNISTA' }
	]

	readonly CARGO = [
		{ id: '0', description: 'Presidente' },
		{ id: '1', description: 'Diretor' },
		{ id: '2', description: 'Gerente' },
		{ id: '3', description: 'Outros' }
	]

	readonly SEGURADORAS = {
		MAPFRE: 2,
		BRASILCAP: 19,
		ICATU: 23,
		All: [
			{
				id: 2,
				seguradora: 'Mapfre',
				img: '/vectors/seguradoras/mapfre.svg',
				assistenciaDomiciliar: 'Sim',
				assistenciaJuridica: 'Não',
				showCard: false,
				itens: [
					'- Encanador',
					'- Eletricista',
					'- Chaveiro',
					'- Serralheiro',
					'- Vidraceiro',
					'- Pedreiro',
					'- Serviço de Limpeza',
					'- Carpinteiro',
					'- Pintor',
					'- Instalação de - Carpetes',
					'- Desentupidor'
				]
			},

			{
				id: 23,
				seguradora: 'Icatu',
				img: '/vectors/seguradoras/icatu.svg',
				assistenciaDomiciliar: 'Sim',
				assistenciaJuridica: 'Não',
				showCard: false,
				itens: [
					'- Encanador',
					'- Eletricista',
					'- Chaveiro',
					'- Serralheiro',
					'- Vidraceiro',
					'- Pedreiro',
					'- Serviço de Limpeza',
					'- Carpinteiro',
					'- Pintor',
					'- Instalação de Carpetes',
					'- Desentupidor',
					'- Segurança',
					'- Instalação de Antena de TV',
					'(exceto parabólica e mini-parabólica)',
					'- Pet Assistance',
					'(Guarda e Cuidados com Animais) '
				]
			}
		]
	}

	readonly SETOR_ATUACAO_ICATU = [
		{ id: 'L75', description: 'ADMINISTRAÇÃO PÚBLICA, DEFESA E SEGURIDADE SOCIAL' },
		{ id: 'A1', description: 'AGRICULTURA, PECUÁRIA, CAÇA E SERVIÇOS RELACIONADOS COM ESSAS ATIVIDADES' },
		{ id: 'H55', description: 'ALOJAMENTO E ALIMENTAÇÃO' },
		{
			id: 'K71',
			description: 'ALUGUEL DE VEÍCULOS, MÁQUINAS E EQUIPAMENTOS SEM CONDUTORES OU OPERADORES E DE OBJETOS PESSOAIS E DOMÉSTICOS'
		},
		{ id: 'H63', description: 'ATIVIDADES ANEXAS E AUXILIARES DO TRANSPORTE E AGÊNCIAS DE VIAGEM' },
		{ id: 'O91', description: 'ATIVIDADES ASSOCIATIVAS' },
		{ id: 'J67', description: 'ATIVIDADES AUXILIARES DA INTERMEDIAÇÃO FINANCEIRA' },
		{ id: 'K72', description: 'ATIVIDADES DE INFORMÁTICA E CONEXAS' },
		{ id: 'K70', description: 'ATIVIDADES IMOBILIÁRIAS' },
		{ id: 'O92', description: 'ATIVIDADES RECREATIVAS, CULTURAIS E DESPORTIVAS' },
		{ id: 'E41', description: 'CAPTAÇÃO, TRATAMENTO E DISTRIBUIÇÃO DE ÁGUA' },
		{ id: 'G50', description: 'COMÉRCIO E REPARAÇÃO DE VEÍCULOS AUTOMOTORES E MOTOCICLETAS; E COMÉRCIO A VAREJO DE COMBUSTÍVEIS' },
		{ id: 'G51', description: 'COMÉRCIO POR ATACADO E INTERMEDIÁRIOS DO COMÉRCIO' },
		{ id: 'G47', description: 'COMÉRCIO VAREJISTA' },
		{ id: 'G52', description: 'COMÉRCIO VAREJISTA E REPARAÇÃO DE OBJETOS PESSOAIS E DOMÉSTICOS' },
		{ id: 'D18', description: 'CONFECÇÃO DE ARTIGOS DO VESTUÁRIO E ACESSÓRIOS' },
		{ id: 'F45', description: 'CONSTRUÇÃO' },
		{ id: 'H64', description: 'CORREIO E TELECOMUNICAÇÕES' },
		{ id: 'D22', description: 'EDIÇÃO, IMPRESSÃO E REPRODUÇÃO DE GRAVAÇÕES' },
		{ id: 'M80', description: 'EDUCAÇÃO' },
		{ id: 'E40', description: 'ELETRICIDADE, GÁS E ÁGUA QUENTE' },
		{ id: '093', description: 'ENTIDADE ESPORTIVA' },
		{ id: 'C10', description: 'EXTRAÇÃO DE CARVÃO MINERAL' },
		{ id: 'C13', description: 'EXTRAÇÃO DE MINERAIS METÁLICOS' },
		{ id: 'C14', description: 'EXTRAÇÃO DE MINERAIS NÃO-METÁLICOS' },
		{ id: 'C11', description: 'EXTRAÇÃO DE PETRÓLEO E SERVIÇOS CORRELATOS' },
		{ id: 'D25', description: 'FABRICAÇÃO DE ARTIGOS DE BORRACHA E PLÁSTICO' },
		{ id: 'D21', description: 'FABRICAÇÃO DE CELULOSE, PAPEL E PRODUTOS DE PAPEL' },
		{ id: 'D23', description: 'FABRICAÇÃO DE COQUE, REFINO DE PETRÓLEO, ELABORAÇÃO DE COMBUSTÍVEIS NUCLEARES E PRODUÇÃO DE ÁLCOOL' },
		{
			id: 'D33',
			description:
				'FABRICAÇÃO DE EQUIPAMENTOS DE INSTRUMENTAÇÃO MÉDICO-HOPITALARES, INSTRUMENTOS DE PRECISÃO E ÓPTICOS, EQUIPAMENTOS PARA AUTOMAÇÃO INSDUSTRIAL, CRONÔMETROS E RELÓGIOS'
		},
		{ id: 'D32', description: 'FABRICAÇÃO DE MATERIAL ELETRÔNICO E DE APARELHOS E EQUIPAMENTOS DE COMUNICAÇÕES' },
		{ id: 'D29', description: 'FABRICAÇÃO DE MÁQUINAS E EQUIPAMENTOS' },
		{ id: 'D30', description: 'FABRICAÇÃO DE MÁQUINAS PARA ESCRITÓRIO E EQUIPAMENTOS DE INFORMÁTICA' },
		{ id: 'D31', description: 'FABRICAÇÃO DE MÁQUINAS, APARELHOS E MATERIAIS ELÉTRICOS' },
		{ id: 'D36', description: 'FABRICAÇÃO DE MÓVEIS E INDÚSTRIAS DIVERSAS' },
		{ id: 'D35', description: 'FABRICAÇÃO DE OUTROS EQUIPAMENTOS DE TRANSPORTE' },
		{ id: 'D15', description: 'FABRICAÇÃO DE PRODUTOS ALIMENTÍCIOS E BEBIDAS' },
		{ id: 'D20', description: 'FABRICAÇÃO DE PRODUTOS DE MADEIRA' },
		{ id: 'D28', description: 'FABRICAÇÃO DE PRODUTOS DE METAL - EXCLUSIVE MÁQUINAS E EQUIPAMENTOS' },
		{ id: 'D26', description: 'FABRICAÇÃO DE PRODUTOS DE MINERAIS NÃO-METÁLICOS' },
		{ id: 'D16', description: 'FABRICAÇÃO DE PRODUTOS DO FUMO' },
		{ id: 'D24', description: 'FABRICAÇÃO DE PRODUTOS QUÍMICOS' },
		{ id: 'D17', description: 'FABRICAÇÃO DE PRODUTOS TÊXTEIS' },
		{ id: 'D34', description: 'FABRICAÇÃO E MONTAGEM DE VEÍCULOS AUTOMOTORES, REBOQUES E CARROCERIAS' },
		{ id: 'J65', description: 'INTERMEDIAÇÃO FINANCEIRA, EXCLUSIVE SEGUROS E PREVIDÊNCIA PRIVADA' },
		{ id: 'O90', description: 'LIMPEZA URBANA E ESGOTO; E ATIVIDADES CONEXAS' },
		{ id: 'D27', description: 'METALURGIA BÁSICA' },
		{ id: 'Q99', description: 'ORGANISMOS INTERNACIONAIS E OUTRAS INSTITUIÇÕES EXTRATERRITORIAIS' },
		{ id: 'B5', description: 'PESCA, AQUICULTURA E ATIVIDADES DOS SERVIÇOS RELACIONADOS COM ESTAS ATIVIDADES' },
		{ id: 'K73', description: 'PESQUISA E DESENVOLVIMENTO' },
		{ id: 'D19', description: 'PREPARAÇÃO DE COUROS E FABRICAÇÃO DE ARTEFATOS DE COURO, ARTIGOS DE VIAGEM E CALÇADOS' },
		{ id: 'D37', description: 'RECICLAGEM' },
		{ id: 'N85', description: 'SAÚDE E SERVIÇOS SOCIAIS' },
		{ id: 'J66', description: 'SEGUROS E PREVIDÊNCIA PRIVADA' },
		{ id: 'P95', description: 'SERVIÇOS DOMÉSTICOS' },
		{ id: 'O93', description: 'SERVIÇOS PESSOAIS' },
		{ id: 'K74', description: 'SERVIÇOS PRESTADOS PRINCIPALMENTE AS EMPRESAS' },
		{ id: 'A2', description: 'SILVICULTURA, EXPLORAÇÃO FLORESTAL E SERVIÇOS RELACIONADOS COM ESTAS ATIVIDADES' },
		{ id: 'H61', description: 'TRANSPORTE AQUAVIÁRIO' },
		{ id: 'H62', description: 'TRANSPORTE AÉREO' },
		{ id: 'H60', description: 'TRANSPORTE TERRESTRE' }
	]

	readonly RESPONSAVEL_LOCACAO = {
		IMOBILIARIA: 1,
		LOCADOR: 0,
		OUTRO: 2,
		LISTA: [
			{ id: '1', description: 'Imobiliária (Parceiro/Franquia)' },
			{ id: '0', description: 'Locador' },
			{ id: '2', description: 'Outro (Novo parceiro)' }
		]
	}

	readonly TIPO_CONTA_BANCARIA = [
		{ id: '0', description: 'Conta Corrente' },
		{ id: '1', description: 'Conta Poupança' }
	]

	readonly ORGAO_EXPEDIDOR = [
		{ value: 'SSP', description: 'SSP: Secretaria de Segurança Pública do Estado' },
		{ value: 'Cartório Civil', description: 'Cartório Civil: Emite registro de nascimento, casamento, óbitos etc.' },
		{ value: 'Polícia Federal', description: 'Polícia Federal: Órgão responsável pela emissão de passaporte e outros serviços' },
		{
			value: 'DETRAN',
			description:
				'DETRAN: Emissão de CNH (Carteira Nacional de Habilitação), CRLV (Certificado de Registro e Licenciamento de Veículos), etc.'
		},
		{ value: 'ABNC', description: 'ABNC: Academia Brasileira de Neurocirurgia' },
		{ value: 'CGPI', description: 'CGPI/DUREX/DPF: Coordenação Geral de Polícia de Imigração da Polícia Federal' },
		{ value: 'CGPI', description: 'CGPI: Coordenação-Geral de Privilégios e Imunidades' },
		{ value: 'CGPMAF', description: 'CGPMAF: Coordenadoria Geral de Polícia Marítima, Aeronáutica e de Fronteiras' },
		{ value: 'CNIG', description: 'CNIG: Conselho Nacional de Imigração' },
		{ value: 'CNT', description: 'CNT: Confederação Nacional de Transporte' },
		{ value: 'COREN', description: 'COREN: Conselho Regional de Enfermagem' },
		{ value: 'CORECON', description: 'CORECON: Conselho Regional de Economia' },
		{ value: 'CRA', description: 'CRA: Conselho Regional de Administração' },
		{ value: 'CRAS', description: 'CRAS: Centro de Referência de Assistência Social' },
		{ value: 'CRB', description: 'CRB: Conselho Regional de Biblioteconomia' },
		{ value: 'CRC', description: 'CRC: Conselho Regional de Contabilidade' },
		{ value: 'CRE', description: 'CRE: Conselho Regional de Estatística' },
		{ value: 'CREA', description: 'CREA: Conselho Regional de Engenharia e Agronomia' },
		{ value: 'CRECI', description: 'CRECI: Conselho Regional de Corretores de Imóveis' },
		{ value: 'CREFIT', description: 'CREFIT: Conselho Regional de Fisioterapia e Terapia Ocupacional' },
		{ value: 'CRESS', description: 'CRESS: Conselho Regional de Serviço Social' },
		{ value: 'CRF', description: 'CRF: Conselho Regional de Farmácia' },
		{ value: 'CRM', description: 'CRM: Conselho Regional de Medicina' },
		{ value: 'CRN', description: 'CRN: Conselho Regional de Nutrição' },
		{ value: 'CRO', description: 'CRO: Conselho Regional de Odontologia' },
		{ value: 'CRP', description: 'CRP: Conselho Regional de Psicologia' },
		{ value: 'CRPRE', description: 'CRPRE: Conselho Regional de Profissionais de Relações Públicas' },
		{ value: 'CRQ', description: 'CRQ: Conselho Regional de Química' },
		{ value: 'CRRC', description: 'CRRC: Conselho Regional de Representantes Comerciais' },
		{ value: 'CRMV', description: 'CRMV: Conselho Regional de Medicina Veterinária' },
		{ value: 'CSC', description: 'CSC: Carteira Sede Carpina de Pernambuco' },
		{ value: 'CTPS', description: 'CTPS: Carteira de Trabalho e Previdência Social' },
		{ value: 'DIC', description: 'DIC: Diretoria de Identificação Civil' },
		{ value: 'DIREX', description: 'DIREX: Diretoria-Executiva' },
		{ value: 'DPMAF', description: 'DPMAF: Divisão de Polícia Marítima, Área e de Fronteiras' },
		{ value: 'DPT', description: 'DPT: Departamento de Polícia Técnica Geral' },
		{ value: 'DST', description: 'DST: Programa Municipal DST/Aids' },
		{ value: 'FGTS', description: 'FGTS: Fundo de Garantia do Tempo de Serviço' },
		{ value: 'FIPE', description: 'FIPE: Fundação Instituto de Pesquisas Econômicas' },
		{ value: 'FLS', description: 'FLS: Fundação Lyndolpho Silva' },
		{ value: 'GOVGO', description: 'GOVGO: Governo do Estado de Goiás' },
		{ value: 'I CLA', description: 'I CLA: Carteira de Identidade Classista' },
		{ value: 'IFP', description: 'IFP: Instituto Félix Pacheco' },
		{ value: 'IGP', description: 'IGP: Instituto Geral de Perícias' },
		{ value: 'IICCECF', description: 'IICCECF/RO: Instituto de Identificação Civil e Criminal Engrácia da Costa Francisco de Rondônia' },
		{ value: 'IIMG', description: 'IIMG: Inter-institutional Monitoring Group' },
		{ value: 'IML', description: 'IML: Instituto Médico-Legal' },
		{ value: 'IPC', description: 'IPC: Índice de Preços ao Consumidor' },
		{ value: 'IPF', description: 'IPF: Instituto Pereira Faustino' },
		{ value: 'MAE', description: 'MAE: Ministério da Aeronáutica' },
		{ value: 'MEX', description: 'MEX: Ministério do Exército' },
		{ value: 'MMA', description: 'MMA: Ministério da Marinha' },
		{ value: 'OAB', description: 'OAB: Ordem dos Advogados do Brasil' },
		{ value: 'OMB', description: 'OMB: Ordens dos Músicos do Brasil' },
		{ value: 'PCMG', description: 'PCMG: Polícia Civil do Estado de Minas Gerais' },
		{ value: 'PMMG', description: 'PMMG: Polícia Militar do Estado de Minas Gerais' },
		{ value: 'POF', description: 'POF ou DPF: Polícia Federal' },
		{ value: 'POM', description: 'POM: Polícia Militar' },
		{ value: 'SDS', description: 'SDS: Secretaria de Defesa Social (Pernambuco)' },
		{ value: 'SNJ', description: 'SNJ: Secretaria Nacional de Justiça / Departamento de Estrangeiros' },
		{ value: 'SECC', description: 'SECC: Secretaria de Estado da Casa Civil' },
		{ value: 'SEJUSP', description: 'SEJUSP: Secretaria de Estado de Justiça e Segurança Pública – Mato Grosso' },
		{ value: 'SES', description: 'SES ou EST: Carteira de Estrangeiro' },
		{ value: 'SESP', description: 'SESP: Secretaria de Estado da Segurança Pública do Paraná' },
		{ value: 'SJS', description: 'SJS: Secretaria da Justiça e Segurança' },
		{ value: 'SJTC', description: 'SJTC: Secretaria da Justiça do Trabalho e Cidadania' },
		{ value: 'SJTS', description: 'SJTS: Secretaria da Justiça do Trabalho e Segurança' },
		{ value: 'SPTC', description: 'SPTC: Secretaria de Polícia Técnico-Científica' }
	]

	/**
	 * @deprecated usar constante diretamente em @types/ProdutosCreditoImobiliario.ts
	 */
	readonly PRODUTOS_CREDITO_IMOBILIARIO = {
		SAC: 1,
		PRICE: 2,
		POUPANCA_MAIS: 3,
		ALL: [
			{ id: 1, description: 'SAC' },
			{ id: 2, description: 'PRICE' },
			{ id: 3, description: 'POUPANCA MAIS' }
		]
	}

	readonly PRODUTOS_BANCO_CREDITO_IMOBILIARIO = {
		ITAU: [
			{ id: 1, nome: 'SAC', bancoOpera: true },
			{ id: 2, nome: 'PRICE', bancoOpera: false },
			{ id: 3, nome: 'POUPANÇA+', bancoOpera: true }
		],
		BRADESCO: [
			{ id: 1, nome: 'SAC', bancoOpera: true },
			{ id: 2, nome: 'PRICE', bancoOpera: true },
			{ id: 3, nome: 'POUPANÇA+', bancoOpera: true }
		],
		SANTANDER: [
			{ id: 1, nome: 'SAC', bancoOpera: true },
			{ id: 2, nome: 'PRICE', bancoOpera: true },
			{ id: 3, nome: 'POUPANÇA+', bancoOpera: false }
		],
		CAIXA: [
			{ id: 1, nome: 'SAC', bancoOpera: true },
			{ id: 2, nome: 'PRICE', bancoOpera: true },
			{ id: 3, nome: 'POUPANÇA+', bancoOpera: false }
		],
		ALL: [
			{ id: 1, nome: 'SAC', bancoOpera: true },
			{ id: 2, nome: 'PRICE', bancoOpera: true },
			{ id: 3, nome: 'POUPANÇA+', bancoOpera: true }
		]
	}

	readonly ESTADO_CIVIL_VALUES = {
		SOLTEIRO: '004',
		CASADO: '001',
		DIVORCIADO: '003',
		VIUVO: '005',
		SEPARADO: '008',
		SEPARADO_DE_FATO: '010',
		SEPARADO_JUDICIALMENTE: '011',
		DESQUITADO: '009'
	}

	readonly SUB_PRODUTO_MULTIBANCO_ITAU_ISOLADO = [
		{ id: 1, description: 'Convencional' },
		{ id: 2, description: 'Fast Itaú' },
		{ id: 3, description: 'Chave Antecipada' }
	]

	readonly SUB_PRODUTO_MULTIBANCO_OUTROS = [{ id: 1, description: 'Convencional' }]

	readonly LISTA_ASSISTENCIA_TOO = [
		{ id: 1, description: 'Completa' },
		{ id: 2, description: 'Básica' },
		{ id: 3, description: 'Sem Assistência' }
	]

	readonly PRODUTOS_MULTIBANCO = {
		CI_ISOLADO: 11,
		CI_REPASSE: 15,
		CI_PILOTO: 16,
		CGI: 23,
		SBPE: 24,
		FGTS_MCMV: 25,
		FGTS_PRO_COTISTA: 26,
		ALL: [
			{ id: 11, banks: [this.BANCOS.ITAU, this.BANCOS.BRADESCO, this.BANCOS.SANTANDER], description: 'CI - Isolado' },
			{ id: 15, banks: [this.BANCOS.ITAU, this.BANCOS.BRADESCO, this.BANCOS.SANTANDER], description: 'CI - Repasse' },
			{ id: 16, banks: [this.BANCOS.ITAU, this.BANCOS.BRADESCO, this.BANCOS.SANTANDER], description: 'CI - Piloto' },
			{ id: 23, banks: [this.BANCOS.ITAU, this.BANCOS.BRADESCO, this.BANCOS.SANTANDER], description: 'CGI' },
			{ id: 24, banks: [this.BANCOS.CAIXA], description: 'SBPE' },
			{ id: 25, banks: [this.BANCOS.CAIXA], description: 'FGTS - MCMV' },
			{ id: 26, banks: [this.BANCOS.CAIXA], description: 'FGTS - Pró-Cotista' }
		]
	}

	readonly RESPONSAVEL_LOCACAO_V2 = {
		IMOBILIARIA: 1,
		LOCADOR: 0,
		OUTRO: 2,
		LISTA: [
			{ id: '1', description: 'Parceiro/Franquia' },
			{ id: '2', description: 'Outro (Novo parceiro)' }
		]
	}

	readonly FORNECEDOR_TIPO_PARAMETRO = {
		TAXA_MINIMA: 1,
		LTV_MAXIMO: 2,
		PRAZO_MAXIMO: 3,
		TAXA_AVALIACAO: 4,
		FINANCIAMENTO_MINIMO: 5,
		FINANCIAMENTO_MAXIMO: 6,
		IMOVEL_VALOR_MINIMO: 7,
		IMOVEL_VALOR_MAXIMO: 8,
		PRAZO_MINIMO: 9
	}

	readonly PERFIL_VISUALIZAO_PARCEIROS = {
		PERFIL_ADMINISTRADOR: 1,
		PERFIL_FRANQUEADO: 2,
		PERFIL_CONSULTOR: 3,
		PERFIL_CASA_MINEIRA: 4,
		PERFIL_NAVENT: 5,
		PERFIL_QUINTO_ANDAR: 6,
		PERFIL_NULL: 7
	}
	readonly PRAZO_MAXIMO_EM_ANOS = 80.5

	readonly RESOURCES_TEXT = {
		PROPOSTA_GERADAS: 'Propostas geradas com sucesso! Verifique a aba Minhas Propostas para dar andamento.',
		ERRO_PROPOSTA: 'Erro ao gerar as propostas!',
		FORMULARIO_OFF: 'Formulário Temporariamente indisponível.'
	}
}

export const Constants = new ConstantsModel()

export function sleep(ms: number) {
	return new Promise((resolve) => setTimeout(resolve, ms))
}
